const autoInput = {
	"Sample": {
		"Reset" : ['Reset'],
		"Animal": ["Buccal@Animal", "Buffy Coat@Animal", "Eukaryotic Cells@Animal", "FFPE@Animal", "Insects@Animal", "Lymphocytes@Animal", "Milk@Animal", "Plasma@Animal", "Rodent Tail@Animal", "Saliva@Animal", "Serum@Animal", "Stool@Animal", "Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Animal", "Tissue@Animal", "Trizol@Animal", "Urine@Animal", "Whole Blood@Animal"],
		"Environmental": ["Fungus@Environmental", "Insects@Environmental", "Plant@Environmental", "Seeds@Environmental", "Soil@Environmental", "Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Environmental", "Waste Water@Environmental", "Yeast@Environmental"],
		"Human": ["Buccal@Human", "Buffy Coat@Human", "Eukaryotic Cells@Human", "FFPE@Human", "Lymphocytes@Human", "Milk@Human", "Plasma@Human", "Saliva@Human", "Serum@Human", "Stool@Human", "Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Human", "Tissue@Human", "Trizol@Human", "Urine@Human", "Whole Blood@Human"],
		"Microbial": ["Bacterial Culture@Microbial", "Fungus@Microbial", "Soil@Microbial", "Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Microbial", "Trizol@Microbial", "Waste Water@Microbial", "Yeast@Microbial"]
	},
	"Nucleic Acid Target": {
		"Reset" : ['Reset'],
		"DNA": ["Cell-Free@DNA", "High-Molecular Weight@DNA", "Microbial@DNA", "Pathogen@DNA", "Total@DNA", "Viral@DNA"],
		"Fractional (DNA & RNA Separate)": ["Microbial@Fractional (DNA & RNA Separate)", "Pathogen@Fractional (DNA & RNA Separate)", "Total@Fractional (DNA & RNA Separate)", "Viral@Fractional (DNA & RNA Separate)"],
		"RNA": ["Microbial@RNA", "micro-RNA@RNA", "Pathogen@RNA", "Total@RNA", "Viral@RNA"],
		"Total Nucleic Acid": ["Microbial@Total Nucleic Acid", "Pathogen@Total Nucleic Acid", "Total@Total Nucleic Acid", "Viral@Total Nucleic Acid"]
	},
	"Analysis": {
		"Reset" : ['Reset'],
		"NGS": ["Chromatin Analysis@NGS", "DNA Methylation@NGS", "Fungal Sequencing@NGS", "General/Other@NGS", "Microbial Sequencing@NGS"],
		"PCR/rt-PCR": ["DNA Methylation@PCR/rt-PCR", "Fungal Sequencing@PCR/rt-PCR", "General/Other@PCR/rt-PCR", "Microbial Sequencing@PCR/rt-PCR"],
		"Post-Extraction Clean-up": ["Post-Extraction Clean-up"]
	},
	"Instrument":{
		"Reset" : ['Reset'],
		"AllSheng" : ['Auto-Pure 24@AllSheng', 'Auto-Pure 32@AllSheng', 'Auto-Pure 96/48/24@AllSheng', 'Auto-Pure Mini@AllSheng'],
		"Beckman Coulter" : ['Biomek FX@Beckman Coulter', 'Biomek i5@Beckman Coulter', 'Biomek i7@Beckman Coulter', 'Biomek NX@Beckman Coulter'],
		"Benchmark / Accuris" : ['IsoPure™ 96@Benchmark / Accuris', 'IsoPure™ Mini@Benchmark / Accuris'],
		"Eppendorf" : ['epMotion® 5070@Eppendorf', 'epMotion® 5073@Eppendorf', 'epMotion® 5075@Eppendorf'],
		"Hamilton" : ['Microlab NIMBUS@Hamilton', 'Microlab Prep@Hamilton', 'Microlab STAR@Hamilton', 'Microlab STAR V@Hamilton'],
		"Opentrons" : ['Opentrons Flex@Opentrons', 'OT-2@Opentrons'],
		"TANBead" : ['Maelstrom 2410@TANBead', 'Maelstrom 4810@TANBead', 'Maelstrom 9610@TANBead', 'Maelstrom Switch 8@TANBead'],
		"Tecan" : ['DreamPrep® NAP x Zymo Research@Tecan', 'Fluent®@Tecan', 'Freedom EVO®@Tecan'],
		"ThermoFisher Scientific" : ['KingFisher® Apex@ThermoFisher Scientific', 'KingFisher® Duo Prime@ThermoFisher Scientific', 'KingFisher® Flex@ThermoFisher Scientific'],
		"Undecided" : ['Undecided']
	}
}

const bulkProducts = 	["dna-rna-shield","dna-rna-shield-blood-collection-tube","dna-rna-shield-collection-tube-w-swab",
						"dna-rna-shield-collection-tube-w-swab-dx","dna-rna-shield-fecal-collection-kit","dna-rna-shield-fecal-collection-tube",
						"dna-rna-shield-fecal-collection-tube-dx","dna-rna-shield-lysis-and-collection-tubes","dna-rna-shield-safecollect-saliva-collection-kit",
						"dna-rna-shield-safecollect-swab-collection-kit","dna-rna-shield-saliva-collection-kit","dna-rna-shield-saliva-sputum-collection-kit-dx",
						"dnase-i-set","proteinase-k-w-storage-buffer-set","rnase-a","sterile-collection-swab","urine-conditioning-buffer",
						"zr-96-bashingbead-lysis-rack-barcoded","zymolyase"]

const instrumentData = {
	'Microlab Prep@Hamilton'		:{
		"manufacturer": "Hamilton",
		"platform-type": "Liquid Handler",
		"description": "The Microlab Prep is a benchtop liquid handling platform ideal for sample prep, PCR prep, library prep, or small to mid-scale nucleic acid extraction workflows.",
		"image-url": "https://files.zymoresearch.com/images/workflow_instruments/ml_prep.webp"
	}, 
	'Microlab NIMBUS@Hamilton'	:{
		"manufacturer": "Hamilton",
		"platform-type": "Liquid Handler",
		"description": "The NIMBUS is a benchtop liquid handling platform for small to mid-scale workflows that is offered in 4 different models: NIMBUS4, NIMBUS96, NIMBUS384, and NIMBUS HD",
		"image-url": "https://files.zymoresearch.com/images/workflow_instruments/nimbus.webp"
	},  
	'Microlab STAR@Hamilton'		:{
		"manufacturer": "Hamilton",
		"platform-type": "Liquid Handler",
		"description": "The STAR is a large-scale liquid handling platform for large-scale workflows that is capable of fully walk-away, end-to-end workflows.",
		"image-url": "https://files.zymoresearch.com/images/workflow_instruments/star.webp"
	},  
	'Microlab STAR V@Hamilton'	:{
		"manufacturer": "Hamilton",
		"platform-type": "Liquid Handler",
		"description": "The STAR is a large-scale liquid handling platform for large-scale workflows that is capable of fully walk-away, end-to-end workflows.",
		"image-url": "https://files.zymoresearch.com/images/workflow_instruments/star_v.webp"
	}, 
	'Fluent®@Tecan':{
		"manufacturer": "Tecan",
		"platform-type": "Liquid Handler",
		"description": "The Fluent is a large-scale liquid handling platform for large-scale workflows that is capable of fully walk-away, end-to-end workflows.",
		"image-url": "https://s3.amazonaws.com/files.zymoresearch.com/images/workflow_instruments/fluent.webp"
	},  
	'Freedom EVO®@Tecan':{
		"manufacturer": "Tecan",
		"platform-type": "Liquid Handler",
		"description": "The Freedom EVO is a large-scale liquid handling platform for large-scale workflows that is capable of fully walk-away, end-to-end workflows.",
		"image-url": "https://s3.amazonaws.com/files.zymoresearch.com/images/workflow_instruments/freedom_evo.webp"
	},  
	'DreamPrep® NAP x Zymo Research@Tecan':{
		"manufacturer": "Tecan",
		"platform-type": "Liquid Handler",
		"description": "The DreamPrep NAP is a preconfigured large-scale liquid handling system that that features standardized workflows involving chemistries by Zymo Research.",
		"image-url": "https://files.zymoresearch.com/images/workflow_instruments/dreamprep_nap.webp"
	}, 
	'KingFisher® Flex@ThermoFisher Scientific':{
		"manufacturer": "ThermoFisher Scientific",
		"platform-type": "Magnetic Bead Transfer",
		"description": "The KingFisher Flex is a benchtop magnetic bead transfer system that can run in both 24-well and 96-well deep-well plate formats.",
		"image-url": "https://files.zymoresearch.com/images/workflow_instruments/flex.webp"
	},  
	'KingFisher® Apex@ThermoFisher Scientific':{
		"manufacturer": "ThermoFisher Scientific",
		"platform-type": "Magnetic Bead Transfer",
		"description": "The KingFisher Apex is a benchtop magnetic bead transfer system that can run in both 24-well and 96-well deep-well plate formats.",
		"image-url": "https://files.zymoresearch.com/images/workflow_instruments/apex.webp"
	},  
	'KingFisher® Duo Prime@ThermoFisher Scientific':{
		"manufacturer": "ThermoFisher Scientific",
		"platform-type": "Magnetic Bead Transfer",
		"description": "The KingFisher Duo Prime is a small-scale benchtop magnetic bead transfer system that can run 6 or 12 samples at a time on a 96-well SBS deep-well plate format.",
		"image-url": "https://files.zymoresearch.com/images/workflow_instruments/duo_prime.webp"
	}, 
	'OT-2@Opentrons':{
		"manufacturer": "Opentrons",
		"platform-type": "Liquid Handler",
		"description": "The OT-2 is a small-scale benchtop liquid handling platform that is ideal for small to mid-scale workflows.",
		"image-url": "https://files.zymoresearch.com/images/workflow_instruments/ot_2.webp"
	},  
	'Opentrons Flex@Opentrons':{
		"manufacturer": "Opentrons",
		"platform-type": "Liquid Handler",
		"description": "The Opentrons Flex is a small-scale benchtop liquid handling platform that is ideal for small to mid-scale workflows.",
		"image-url": "https://files.zymoresearch.com/images/workflow_instruments/opentrons_flex.webp"
	}, 
	'Biomek FX@Beckman Coulter':{
		"manufacturer": "Beckman Coulter",
		"platform-type": "Liquid Handler",
		"description": "The Biomek FX is a large-scale liquid handling platform for large-scale workflows that is capable of fully walk-away, end-to-end workflows.",
		"image-url": "https://files.zymoresearch.com/images/workflow_instruments/biomek_fx.webp"
	},  
	'Biomek NX@Beckman Coulter':{
		"manufacturer": "Beckman Coulter",
		"platform-type": "Liquid Handler",
		"description": "The Biomek NX is a large-scale liquid handling platform for large-scale workflows that is capable of fully walk-away, end-to-end workflows.",
		"image-url": "https://files.zymoresearch.com/images/workflow_instruments/biomek_nx.webp"
	},  
	'Biomek i5@Beckman Coulter':{
		"manufacturer": "Beckman Coulter",
		"platform-type": "Liquid Handler",
		"description": "The Biomek i5 is a mid-scale liquid handling platform for mid-scale workflows that is capable of fully walk-away workflow solutions.",
		"image-url": "https://files.zymoresearch.com/images/workflow_instruments/biomek_i5.webp"
	},  
	'Biomek i7@Beckman Coulter':{
		"manufacturer": "Beckman Coulter",
		"platform-type": "Liquid Handler",
		"description": "The Biomek i7 is a large-scale liquid handling platform for large-scale workflows that is capable of fully walk-away, end-to-end workflows.",
		"image-url": "https://files.zymoresearch.com/images/workflow_instruments/biomek_i7.webp"
	}, 
	'IsoPure™ 96@Benchmark / Accuris':{
		"manufacturer": "Accuris",
		"platform-type": "Magnetic Bead Transfer",
		"description": "The IsoPure 96 is a benchtop magnetic bead transfer system that can run in both 24-well and 96-well deep-well plate formats.",
		"image-url": "https://files.zymoresearch.com/images/workflow_instruments/isopure_96.webp"
	},  
	'IsoPure™ Mini@Benchmark / Accuris':{
		"manufacturer": "Accuris",
		"platform-type": "Magnetic Bead Transfer",
		"description": "The IsoPure Mini is a small-scale benchtop magnetic bead transfer system that can run 8 or 16 samples at a time on a 96-well SBS deep-well plate format.",
		"image-url": "https://files.zymoresearch.com/images/workflow_instruments/isopure_mini.webp"
	}, 
	'epMotion® 5070@Eppendorf':{
		"manufacturer": "Eppendorf",
		"platform-type": "Liquid Handler",
		"description": "The epMotion 5070 is a small-scale benchtop liquid handling platform that is ideal for small-scale workflows.",
		"image-url": "https://files.zymoresearch.com/images/workflow_instruments/epmotion_5070.webp"
	},  
	'epMotion® 5073@Eppendorf':{
		"manufacturer": "Eppendorf",
		"platform-type": "Liquid Handler",
		"description": "The epMotion 5073 is a small-scale benchtop liquid handling platform that is ideal for small-scale workflows.",
		"image-url": "https://files.zymoresearch.com/images/workflow_instruments/epmotion_5073.webp"
	},  
	'epMotion® 5075@Eppendorf':{
		"manufacturer": "Eppendorf",
		"platform-type": "Liquid Handler",
		"description": "The epMotion 5075 is a large-scale liquid handling platform for large-scale workflows that is capable of fully walk-away, end-to-end workflows.",
		"image-url": "https://files.zymoresearch.com/images/workflow_instruments/epmotion_5075.webp"
	}, 
	'Maelstrom 4810@TANBead':{
		"manufacturer": "TANBead",
		"platform-type": "Magnetic Bead Transfer",
		"description": "The Maelstrom 4810 is a mid-sized magnetic bead transfer system that can run nucelic acid extraction or purification on up to 48 samples at a time.",
		"image-url": "https://files.zymoresearch.com/images/workflow_instruments/maelstrom+4810.webp"
	},  
	'Maelstrom 2410@TANBead':{
		"manufacturer": "TANBead",
		"platform-type": "Magnetic Bead Transfer",
		"description": "The Maelstrom 2410 is a benchtop magnetic bead transfer system that can run nucleic acid extraction or purification on up to 24 samples at a time.",
		"image-url": "https://files.zymoresearch.com/images/workflow_instruments/maelstrom_2410.webp"
	},  
	'Maelstrom 9610@TANBead':{
		"manufacturer": "TANBead",
		"platform-type": "Magnetic Bead Transfer",
		"description": "The Maelstrom 9610 is a benchtop magnetic bead transfer system that can run nucleic acid extraction or purification on up to 96 samples at a time.",
		"image-url": "https://files.zymoresearch.com/images/workflow_instruments/maelstrom_9610.webp"
	},  
	'Maelstrom Switch 8@TANBead':{
		"manufacturer": "TANBead",
		"platform-type": "Magnetic Bead Transfer",
		"description": "The Maelstrom Switch 8 is a benchtop magnetic bead transfer system that can run nucleic acid extraction or purification on up to 16 low volume samples or up to 4 high volume samples at a time.",
		"image-url": "https://files.zymoresearch.com/images/workflow_instruments/maelstrom_switch_8.webp"
	}, 
	'Auto-Pure 96/48/24@AllSheng':{
		"manufacturer": "AllSheng",
		"platform-type": "Magnetic Bead Transfer",
		"description": "The AutoPure 96 is a benchtop magnetic bead transfer system that can run up to 96 samples at a time.",
		"image-url": "https://files.zymoresearch.com/images/workflow_instruments/autopure_96.webp"
	},  
	'Auto-Pure 32@AllSheng':{
		"manufacturer": "AllSheng",
		"platform-type": "Magnetic Bead Transfer",
		"description": "The AutoPure 32 is a benchtop magnetic bead transfer system that can run up to 32 samples at a time.",
		"image-url": "https://files.zymoresearch.com/images/workflow_instruments/autopure_32.webp"
	},  
	'Auto-Pure Mini@AllSheng':{
		"manufacturer": "AllSheng",
		"platform-type": "Magnetic Bead Transfer",
		"description": "The AutoPure Mini is a small-scale benchtop magnetic bead transfer system that can run 8 or 16 samples at a time on a 96-well SBS deep-well plate format.",
		"image-url": "https://files.zymoresearch.com/images/workflow_instruments/autopure_mini.webp"
	},  
	'Auto-Pure 24@AllSheng':{
		"manufacturer": "AllSheng",
		"platform-type": "Magnetic Bead Transfer",
		"description": "The AutoPure 24 is a benchtop magnetic bead transfer system that can run up to 24 samples at a time.",
		"image-url": "https://files.zymoresearch.com/images/workflow_instruments/autopure_24.webp"
	}, 
}

const autoOutput = {
	"FFPE@Human?Microbial@DNA?Fungal Sequencing@NGS": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep 2 Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"FFPE@Human?Microbial@DNA?Microbial Sequencing@NGS": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep 2 Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"FFPE@Human?Microbial@DNA?General/Other@NGS": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep 2 Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"FFPE@Human?Microbial@DNA?Fungal Sequencing@PCR/rt-PCR": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep 2 Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"FFPE@Human?Microbial@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep 2 Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"FFPE@Human?Microbial@DNA?General/Other@PCR/rt-PCR": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep 2 Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"FFPE@Human?Microbial@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"FFPE@Human?Pathogen@DNA?Fungal Sequencing@NGS": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep 2 Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"FFPE@Human?Pathogen@DNA?Microbial Sequencing@NGS": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep 2 Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"FFPE@Human?Pathogen@DNA?General/Other@NGS": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep 2 Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"FFPE@Human?Pathogen@DNA?Fungal Sequencing@PCR/rt-PCR": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep 2 Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"FFPE@Human?Pathogen@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep 2 Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"FFPE@Human?Pathogen@DNA?General/Other@PCR/rt-PCR": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep 2 Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"FFPE@Human?Pathogen@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"FFPE@Human?Total@DNA?DNA Methylation@NGS": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"2x-digestion-buffer",
		"Sample Prep 2 Numbers":"D3050-1-20",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymo-seq-wgbs-library-kit,zymo-seq-rrbs-library-kit,pico-methyl-seq-library-prep-kit",
		"Application Kit Numbers":"D5465,D5460,D5461,D5455,D5456",
		"Application Kit 2 Handle":"ez-methylation-magprep-beads",
		"Application Kit 2 Numbers":"D4100-5-4,D4100-5-8,D4100-5-16",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"FFPE@Human?Total@DNA?Chromatin Analysis@NGS": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"2x-digestion-buffer",
		"Sample Prep 2 Numbers":"D3050-1-20",
		"Application Kit Handle":"zymo-seq-atac-library-kit",
		"Application Kit Numbers":"D5458",
	},
	"FFPE@Human?Total@DNA?General/Other@NGS": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"2x-digestion-buffer",
		"Sample Prep 2 Numbers":"D3050-1-20",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
	},
	"FFPE@Human?Total@DNA?DNA Methylation@PCR/rt-PCR": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"2x-digestion-buffer",
		"Sample Prep 2 Numbers":"D3050-1-20",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymotaq-dna-polymerase,zymotaq-qpcr-premix",
		"Application Kit Numbers":"E2003,E2004,E2001,E2002,E2054,E2055",
		"Application Kit 2 Handle":"ez-dna-methylation-lightning-automation-kit",
		"Application Kit 2 Numbers":"D5049",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"FFPE@Human?Total@DNA?General/Other@PCR/rt-PCR": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"2x-digestion-buffer",
		"Sample Prep 2 Numbers":"D3050-1-20",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"FFPE@Human?Total@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"FFPE@Human?Viral@DNA?General/Other@NGS": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"2x-digestion-buffer",
		"Sample Prep 2 Numbers":"D3050-1-20",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
	},
	"FFPE@Human?Viral@DNA?General/Other@PCR/rt-PCR": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"2x-digestion-buffer",
		"Sample Prep 2 Numbers":"D3050-1-20",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"FFPE@Human?Viral@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"FFPE@Human?Microbial@RNA?Fungal Sequencing@NGS": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep 2 Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"FFPE@Human?Microbial@RNA?General/Other@NGS": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep 2 Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"FFPE@Human?Microbial@RNA?Microbial Sequencing@NGS": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep 2 Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"FFPE@Human?Microbial@RNA?Fungal Sequencing@PCR/rt-PCR": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep 2 Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"FFPE@Human?Microbial@RNA?General/Other@PCR/rt-PCR": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep 2 Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"FFPE@Human?Microbial@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep 2 Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"FFPE@Human?Microbial@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"FFPE@Human?micro-RNA@RNA?General/Other@NGS": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"2x-digestion-buffer",
		"Sample Prep 2 Numbers":"D3050-1-20",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"FFPE@Human?micro-RNA@RNA?General/Other@PCR/rt-PCR": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"2x-digestion-buffer",
		"Sample Prep 2 Numbers":"D3050-1-20",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"FFPE@Human?micro-RNA@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"FFPE@Human?Pathogen@RNA?Fungal Sequencing@NGS": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep 2 Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"FFPE@Human?Pathogen@RNA?Microbial Sequencing@NGS": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep 2 Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"FFPE@Human?Pathogen@RNA?General/Other@NGS": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep 2 Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"FFPE@Human?Pathogen@RNA?Fungal Sequencing@PCR/rt-PCR": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep 2 Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"FFPE@Human?Pathogen@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep 2 Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"FFPE@Human?Pathogen@RNA?General/Other@PCR/rt-PCR": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep 2 Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"FFPE@Human?Pathogen@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"FFPE@Human?Total@RNA?General/Other@NGS": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"2x-digestion-buffer",
		"Sample Prep 2 Numbers":"D3050-1-20",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3001",
	},
	"FFPE@Human?Total@RNA?General/Other@PCR/rt-PCR": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"2x-digestion-buffer",
		"Sample Prep 2 Numbers":"D3050-1-20",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"FFPE@Human?Total@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"FFPE@Human?Viral@RNA?General/Other@NGS": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"2x-digestion-buffer",
		"Sample Prep 2 Numbers":"D3050-1-20",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"FFPE@Human?Viral@RNA?General/Other@PCR/rt-PCR": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"2x-digestion-buffer",
		"Sample Prep 2 Numbers":"D3050-1-20",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"FFPE@Human?Viral@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"FFPE@Human?Microbial@Total Nucleic Acid?Fungal Sequencing@NGS": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep 2 Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"FFPE@Human?Microbial@Total Nucleic Acid?Microbial Sequencing@NGS": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep 2 Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"FFPE@Human?Microbial@Total Nucleic Acid?General/Other@NGS": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep 2 Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410,D6432",
	},
	"FFPE@Human?Microbial@Total Nucleic Acid?Fungal Sequencing@PCR/rt-PCR": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep 2 Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"FFPE@Human?Microbial@Total Nucleic Acid?Microbial Sequencing@PCR/rt-PCR": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep 2 Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"FFPE@Human?Microbial@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep 2 Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"FFPE@Human?Microbial@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"FFPE@Human?Pathogen@Total Nucleic Acid?Fungal Sequencing@NGS": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep 2 Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"FFPE@Human?Pathogen@Total Nucleic Acid?Microbial Sequencing@NGS": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep 2 Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"FFPE@Human?Pathogen@Total Nucleic Acid?General/Other@NGS": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep 2 Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410",
	},
	"FFPE@Human?Pathogen@Total Nucleic Acid?Fungal Sequencing@PCR/rt-PCR": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep 2 Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"FFPE@Human?Pathogen@Total Nucleic Acid?Microbial Sequencing@PCR/rt-PCR": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep 2 Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"FFPE@Human?Pathogen@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep 2 Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"FFPE@Human?Pathogen@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"FFPE@Human?Total@Total Nucleic Acid?DNA Methylation@NGS": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"2x-digestion-buffer",
		"Sample Prep 2 Numbers":"D3050-1-20",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymo-seq-wgbs-library-kit,zymo-seq-rrbs-library-kit,pico-methyl-seq-library-prep-kit",
		"Application Kit Numbers":"D5465,D5460,D5461,D5455,D5456",
		"Application Kit 2 Handle":"ez-methylation-magprep-beads",
		"Application Kit 2 Numbers":"D4100-5-4,D4100-5-8,D4100-5-16",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"FFPE@Human?Total@Total Nucleic Acid?Chromatin Analysis@NGS": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"2x-digestion-buffer",
		"Sample Prep 2 Numbers":"D3050-1-20",
		"Application Kit Handle":"zymo-seq-atac-library-kit",
		"Application Kit Numbers":"D5458",
	},
	"FFPE@Human?Total@Total Nucleic Acid?General/Other@NGS": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"2x-digestion-buffer",
		"Sample Prep 2 Numbers":"D3050-1-20",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
	},
	"FFPE@Human?Total@Total Nucleic Acid?DNA Methylation@PCR/rt-PCR": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"2x-digestion-buffer",
		"Sample Prep 2 Numbers":"D3050-1-20",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Application Kit 2 Handle":"ez-dna-methylation-lightning-automation-kit",
		"Application Kit 2 Numbers":"D5049",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"FFPE@Human?Total@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"2x-digestion-buffer",
		"Sample Prep 2 Numbers":"D3050-1-20",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"FFPE@Human?Total@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"FFPE@Human?Viral@Total Nucleic Acid?General/Other@NGS": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"2x-digestion-buffer",
		"Sample Prep 2 Numbers":"D3050-1-20",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"FFPE@Human?Viral@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"2x-digestion-buffer",
		"Sample Prep 2 Numbers":"D3050-1-20",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"FFPE@Human?Viral@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"FFPE@Human?Microbial@Fractional (DNA & RNA Separate)?Fungal Sequencing@NGS": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep 2 Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"FFPE@Human?Microbial@Fractional (DNA & RNA Separate)?Microbial Sequencing@NGS": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep 2 Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410",
	},
	"FFPE@Human?Microbial@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep 2 Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410,D6432",
	},
	"FFPE@Human?Microbial@Fractional (DNA & RNA Separate)?Fungal Sequencing@PCR/rt-PCR": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep 2 Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"FFPE@Human?Microbial@Fractional (DNA & RNA Separate)?Microbial Sequencing@PCR/rt-PCR": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep 2 Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"FFPE@Human?Microbial@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep 2 Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"FFPE@Human?Microbial@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"FFPE@Human?Pathogen@Fractional (DNA & RNA Separate)?Fungal Sequencing@NGS": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep 2 Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"FFPE@Human?Pathogen@Fractional (DNA & RNA Separate)?Microbial Sequencing@NGS": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep 2 Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410",
	},
	"FFPE@Human?Pathogen@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep 2 Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410",
	},
	"FFPE@Human?Pathogen@Fractional (DNA & RNA Separate)?Fungal Sequencing@PCR/rt-PCR": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep 2 Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"FFPE@Human?Pathogen@Fractional (DNA & RNA Separate)?Microbial Sequencing@PCR/rt-PCR": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep 2 Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"FFPE@Human?Pathogen@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep 2 Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"FFPE@Human?Pathogen@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"FFPE@Human?Total@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"2x-digestion-buffer",
		"Sample Prep 2 Numbers":"D3050-1-20",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3001",
	},
	"FFPE@Human?Total@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"2x-digestion-buffer",
		"Sample Prep 2 Numbers":"D3050-1-20",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"FFPE@Human?Total@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Tissue@Human?High-Molecular Weight@DNA?DNA Methylation@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-hmw-magbead-kit",
		"Extraction/Purification Numbers":"D6060",
		"Application Kit Handle":"zymo-seq-wgbs-library-kit,zymo-seq-rrbs-library-kit,pico-methyl-seq-library-prep-kit",
		"Application Kit Numbers":"D5465,D5460,D5461,D5455,D5456",
		"Application Kit 2 Handle":"ez-methylation-magprep-beads",
		"Application Kit 2 Numbers":"D4100-5-4,D4100-5-8,D4100-5-16",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Tissue@Human?High-Molecular Weight@DNA?Chromatin Analysis@NGS": {
		"Application Kit Handle":"zymo-seq-atac-library-kit",
		"Application Kit Numbers":"D5458",
	},
	"Tissue@Human?High-Molecular Weight@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-dna-hmw-magbead-kit",
		"Extraction/Purification Numbers":"D6060",
	},
	"Tissue@Human?High-Molecular Weight@DNA?DNA Methylation@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-hmw-magbead-kit",
		"Extraction/Purification Numbers":"D6060",
		"Application Kit Handle":"zymotaq-premix,zymotaq-dna-polymerase,zymotaq-qpcr-premix",
		"Application Kit Numbers":"E2003,E2004,E2001,E2002,E2054,E2055",
		"Application Kit 2 Handle":"ez-dna-methylation-lightning-automation-kit",
		"Application Kit 2 Numbers":"D5049",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Tissue@Human?High-Molecular Weight@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-dna-hmw-magbead-kit",
		"Extraction/Purification Numbers":"D6060",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Tissue@Human?High-Molecular Weight@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Tissue@Human?Microbial@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Tissue@Human?Microbial@DNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Tissue@Human?Microbial@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Tissue@Human?Microbial@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Tissue@Human?Microbial@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Tissue@Human?Pathogen@DNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Tissue@Human?Pathogen@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
	},
	"Tissue@Human?Pathogen@DNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Tissue@Human?Pathogen@DNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Tissue@Human?Pathogen@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Tissue@Human?Pathogen@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Tissue@Human?Pathogen@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Tissue@Human?Total@DNA?DNA Methylation@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
		"Application Kit Handle":"zymo-seq-wgbs-library-kit,zymo-seq-rrbs-library-kit,pico-methyl-seq-library-prep-kit",
		"Application Kit Numbers":"D5465,D5460,D5461,D5455,D5456",
		"Application Kit 2 Handle":"ez-methylation-magprep-beads",
		"Application Kit 2 Numbers":"D4100-5-4,D4100-5-8,D4100-5-16",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Tissue@Human?Total@DNA?Chromatin Analysis@NGS": {
		"Application Kit Handle":"zymo-seq-atac-library-kit",
		"Application Kit Numbers":"D5458",
	},
	"Tissue@Human?Total@DNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
	},
	"Tissue@Human?Total@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
	},
	"Tissue@Human?Total@DNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Tissue@Human?Total@DNA?DNA Methylation@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
		"Application Kit Handle":"zymotaq-premix,zymotaq-dna-polymerase,zymotaq-qpcr-premix",
		"Application Kit Numbers":"E2003,E2004,E2001,E2002,E2054,E2055",
		"Application Kit 2 Handle":"ez-dna-methylation-lightning-automation-kit",
		"Application Kit 2 Numbers":"D5049",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Tissue@Human?Total@DNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Tissue@Human?Total@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Tissue@Human?Total@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Tissue@Human?Total@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Tissue@Human?Viral@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
	},
	"Tissue@Human?Viral@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Tissue@Human?Viral@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Tissue@Human?Microbial@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Tissue@Human?Microbial@RNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Tissue@Human?Microbial@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Tissue@Human?Microbial@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Tissue@Human?Microbial@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Tissue@Human?micro-RNA@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Tissue@Human?micro-RNA@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Tissue@Human?Pathogen@RNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Tissue@Human?Pathogen@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Tissue@Human?Pathogen@RNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Tissue@Human?Pathogen@RNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Tissue@Human?Pathogen@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Tissue@Human?Pathogen@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Tissue@Human?Pathogen@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Tissue@Human?Total@RNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Tissue@Human?Total@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Tissue@Human?Total@RNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Tissue@Human?Total@RNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Tissue@Human?Total@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Tissue@Human?Total@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Tissue@Human?Total@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Tissue@Human?Viral@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Tissue@Human?Viral@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Tissue@Human?Viral@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Tissue@Human?Microbial@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410,D6432",
	},
	"Tissue@Human?Microbial@Total Nucleic Acid?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Tissue@Human?Microbial@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Tissue@Human?Microbial@Total Nucleic Acid?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Tissue@Human?Microbial@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Tissue@Human?Pathogen@Total Nucleic Acid?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Tissue@Human?Pathogen@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
	},
	"Tissue@Human?Pathogen@Total Nucleic Acid?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Tissue@Human?Pathogen@Total Nucleic Acid?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Tissue@Human?Pathogen@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Tissue@Human?Pathogen@Total Nucleic Acid?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Tissue@Human?Pathogen@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Tissue@Human?Total@Total Nucleic Acid?DNA Methylation@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymo-seq-wgbs-library-kit,zymo-seq-rrbs-library-kit,pico-methyl-seq-library-prep-kit",
		"Application Kit Numbers":"D5465,D5460,D5461,D5455,D5456",
		"Application Kit 2 Handle":"ez-methylation-magprep-beads",
		"Application Kit 2 Numbers":"D4100-5-4,D4100-5-8,D4100-5-16",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Tissue@Human?Total@Total Nucleic Acid?Chromatin Analysis@NGS": {
		"Application Kit Handle":"zymo-seq-atac-library-kit",
		"Application Kit Numbers":"D5458",
	},
	"Tissue@Human?Total@Total Nucleic Acid?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Tissue@Human?Total@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
	},
	"Tissue@Human?Total@Total Nucleic Acid?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Tissue@Human?Total@Total Nucleic Acid?DNA Methylation@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Application Kit 2 Handle":"ez-dna-methylation-lightning-automation-kit",
		"Application Kit 2 Numbers":"D5049",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Tissue@Human?Total@Total Nucleic Acid?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Tissue@Human?Total@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Tissue@Human?Total@Total Nucleic Acid?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Tissue@Human?Total@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Tissue@Human?Viral@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
	},
	"Tissue@Human?Viral@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Tissue@Human?Viral@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Tissue@Human?Microbial@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410,D6432",
	},
	"Tissue@Human?Microbial@Fractional (DNA & RNA Separate)?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410",
	},
	"Tissue@Human?Microbial@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Tissue@Human?Microbial@Fractional (DNA & RNA Separate)?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Tissue@Human?Microbial@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Tissue@Human?Pathogen@Fractional (DNA & RNA Separate)?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Tissue@Human?Pathogen@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
	},
	"Tissue@Human?Pathogen@Fractional (DNA & RNA Separate)?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410",
	},
	"Tissue@Human?Pathogen@Fractional (DNA & RNA Separate)?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Tissue@Human?Pathogen@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Tissue@Human?Pathogen@Fractional (DNA & RNA Separate)?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Tissue@Human?Pathogen@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Tissue@Human?Viral@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
	},
	"Tissue@Human?Viral@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Tissue@Human?Viral@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Tissue@Human?Total@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
	},
	"Tissue@Human?Total@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Tissue@Human?Total@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Saliva@Human?Cell-Free@DNA?DNA Methylation@NGS": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Numbers":"R1100-50,R1100-250,R1211",
		"Extraction/Purification Handle":"magicbead-cfdna-isolation-kit",
		"Extraction/Purification Numbers":"D4086",
		"Application Kit Handle":"zymo-seq-cell-free-dna-wgbs-library-kit",
		"Application Kit Numbers":"D5462,D5463",
		"Application Kit 2 Handle":"ez-methylation-magprep-beads",
		"Application Kit 2 Numbers":"D4100-5-4,D4100-5-8,D4100-5-16",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Saliva@Human?Cell-Free@DNA?Fungal Sequencing@NGS": {
		"Extraction/Purification Handle":"magicbead-cfdna-isolation-kit",
		"Extraction/Purification Numbers":"D4086",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Saliva@Human?Cell-Free@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Numbers":"R1211",
		"Extraction/Purification Handle":"magicbead-cfdna-isolation-kit",
		"Extraction/Purification Numbers":"D4086",
		"Application Kit Handle":"zymo-seq-cell-free-dna-wgbs-library-kit",
		"Application Kit Numbers":"D5462,D5463",
	},
	"Saliva@Human?Cell-Free@DNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Numbers":"R1211",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"magicbead-cfdna-isolation-kit",
		"Extraction/Purification Numbers":"D4086",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Saliva@Human?Cell-Free@DNA?DNA Methylation@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Numbers":"R1100-50,R1100-250,R1211",
		"Extraction/Purification Handle":"magicbead-cfdna-isolation-kit",
		"Extraction/Purification Numbers":"D4086",
		"Application Kit Handle":"zymotaq-premix,zymotaq-dna-polymerase,zymotaq-qpcr-premix",
		"Application Kit Numbers":"E2003,E2004,E2001,E2002,E2054,E2055",
		"Application Kit 2 Handle":"ez-dna-methylation-lightning-automation-kit",
		"Application Kit 2 Numbers":"D5049",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Saliva@Human?Cell-Free@DNA?Fungal Sequencing@PCR/rt-PCR": {
		"Extraction/Purification Handle":"magicbead-cfdna-isolation-kit",
		"Extraction/Purification Numbers":"D4086",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Saliva@Human?Cell-Free@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Numbers":"R1211",
		"Extraction/Purification Handle":"magicbead-cfdna-isolation-kit",
		"Extraction/Purification Numbers":"D4086",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Saliva@Human?Cell-Free@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Numbers":"R1211",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"magicbead-cfdna-isolation-kit",
		"Extraction/Purification Numbers":"D4086",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Saliva@Human?Cell-Free@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Saliva@Human?Microbial@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Numbers":"R1211",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Saliva@Human?Microbial@DNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Numbers":"R1211",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Saliva@Human?Microbial@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Numbers":"R1211",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Saliva@Human?Microbial@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Numbers":"R1211",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Saliva@Human?Microbial@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Saliva@Human?Pathogen@DNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Numbers":"R1100-50,R1100-250,R1211",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Saliva@Human?Pathogen@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Numbers":"R1211",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
	},
	"Saliva@Human?Pathogen@DNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Numbers":"R1211",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Saliva@Human?Pathogen@DNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Numbers":"R1211",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Saliva@Human?Pathogen@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Numbers":"R1211",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Saliva@Human?Pathogen@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Numbers":"R1211",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Saliva@Human?Pathogen@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Saliva@Human?Total@DNA?DNA Methylation@NGS": {
		"Collection Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Numbers":"R1211",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
		"Application Kit Handle":"zymo-seq-wgbs-library-kit,zymo-seq-rrbs-library-kit,pico-methyl-seq-library-prep-kit",
		"Application Kit Numbers":"D5465,D5460,D5461,D5455,D5456",
		"Application Kit 2 Handle":"ez-methylation-magprep-beads",
		"Application Kit 2 Numbers":"D4100-5-4,D4100-5-8,D4100-5-16",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Saliva@Human?Total@DNA?Chromatin Analysis@NGS": {
		"Application Kit Handle":"zymo-seq-atac-library-kit",
		"Application Kit Numbers":"D5458",
	},
	"Saliva@Human?Total@DNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Numbers":"R1211",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
	},
	"Saliva@Human?Total@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Numbers":"R1211",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
	},
	"Saliva@Human?Total@DNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Numbers":"R1211",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Saliva@Human?Total@DNA?DNA Methylation@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Numbers":"R1211",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
		"Application Kit Handle":"zymotaq-premix,zymotaq-dna-polymerase,zymotaq-qpcr-premix",
		"Application Kit Numbers":"E2003,E2004,E2001,E2002,E2054,E2055",
		"Application Kit 2 Handle":"ez-dna-methylation-lightning-automation-kit",
		"Application Kit 2 Numbers":"D5049",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Saliva@Human?Total@DNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Numbers":"R1211",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Saliva@Human?Total@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Numbers":"R1211",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Saliva@Human?Total@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Numbers":"R1211",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Saliva@Human?Total@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Saliva@Human?Viral@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Numbers":"R1211",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
	},
	"Saliva@Human?Viral@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Numbers":"R1211",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Saliva@Human?Viral@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Saliva@Human?Microbial@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Numbers":"R1211",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Saliva@Human?Microbial@RNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Numbers":"R1211",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Saliva@Human?Microbial@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Numbers":"R1211",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Saliva@Human?Microbial@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Numbers":"R1211",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Saliva@Human?Microbial@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Saliva@Human?micro-RNA@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Numbers":"R1211",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Saliva@Human?micro-RNA@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Numbers":"R1211",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Saliva@Human?Pathogen@RNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Numbers":"R1211",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Saliva@Human?Pathogen@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Numbers":"R1211",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Saliva@Human?Pathogen@RNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Numbers":"R1211",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Saliva@Human?Pathogen@RNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Numbers":"R1211",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Saliva@Human?Pathogen@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Numbers":"R1211",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Saliva@Human?Pathogen@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Numbers":"R1211",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Saliva@Human?Pathogen@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Saliva@Human?Total@RNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Numbers":"R1211",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Saliva@Human?Total@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Numbers":"R1211",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Saliva@Human?Total@RNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Numbers":"R1211",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Saliva@Human?Total@RNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Numbers":"R1211",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Saliva@Human?Total@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Numbers":"R1211",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Saliva@Human?Total@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Numbers":"R1211",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Saliva@Human?Total@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Saliva@Human?Viral@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Numbers":"R1211",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Saliva@Human?Viral@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Numbers":"R1211",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Saliva@Human?Viral@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Saliva@Human?Microbial@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Numbers":"R1211",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410,D6432",
	},
	"Saliva@Human?Microbial@Total Nucleic Acid?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Numbers":"R1211",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Saliva@Human?Microbial@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Numbers":"R1211",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Saliva@Human?Microbial@Total Nucleic Acid?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Numbers":"R1211",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Saliva@Human?Microbial@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Saliva@Human?Pathogen@Total Nucleic Acid?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Numbers":"R1211",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Saliva@Human?Pathogen@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Numbers":"R1211",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
	},
	"Saliva@Human?Pathogen@Total Nucleic Acid?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Numbers":"R1211",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Saliva@Human?Pathogen@Total Nucleic Acid?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Numbers":"R1211",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Saliva@Human?Pathogen@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Numbers":"R1211",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Saliva@Human?Pathogen@Total Nucleic Acid?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Numbers":"R1211",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Saliva@Human?Pathogen@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Saliva@Human?Total@Total Nucleic Acid?DNA Methylation@NGS": {
		"Collection Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Numbers":"R1211",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymo-seq-wgbs-library-kit,zymo-seq-rrbs-library-kit,pico-methyl-seq-library-prep-kit",
		"Application Kit Numbers":"D5465,D5460,D5461,D5455,D5456",
		"Application Kit 2 Handle":"ez-methylation-magprep-beads",
		"Application Kit 2 Numbers":"D4100-5-4,D4100-5-8,D4100-5-16",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Saliva@Human?Total@Total Nucleic Acid?Chromatin Analysis@NGS": {
		"Application Kit Handle":"zymo-seq-atac-library-kit",
		"Application Kit Numbers":"D5458",
	},
	"Saliva@Human?Total@Total Nucleic Acid?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Numbers":"R1211",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Saliva@Human?Total@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Numbers":"R1211",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
	},
	"Saliva@Human?Total@Total Nucleic Acid?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Numbers":"R1211",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Saliva@Human?Total@Total Nucleic Acid?DNA Methylation@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Numbers":"R1211",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Application Kit 2 Handle":"ez-dna-methylation-lightning-automation-kit",
		"Application Kit 2 Numbers":"D5049",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Saliva@Human?Total@Total Nucleic Acid?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Numbers":"R1211",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Saliva@Human?Total@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Numbers":"R1211",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Saliva@Human?Total@Total Nucleic Acid?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Numbers":"R1211",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Saliva@Human?Total@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Saliva@Human?Viral@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Numbers":"R1211",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
	},
	"Saliva@Human?Viral@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Numbers":"R1211",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Saliva@Human?Viral@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Saliva@Human?Microbial@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Numbers":"R1211",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410,D6432",
	},
	"Saliva@Human?Microbial@Fractional (DNA & RNA Separate)?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Numbers":"R1211",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410",
	},
	"Saliva@Human?Microbial@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Numbers":"R1211",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Saliva@Human?Microbial@Fractional (DNA & RNA Separate)?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Numbers":"R1211",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Saliva@Human?Microbial@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Saliva@Human?Pathogen@Fractional (DNA & RNA Separate)?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Numbers":"R1211",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Saliva@Human?Pathogen@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Numbers":"R1211",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
	},
	"Saliva@Human?Pathogen@Fractional (DNA & RNA Separate)?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Numbers":"R1211",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410",
	},
	"Saliva@Human?Pathogen@Fractional (DNA & RNA Separate)?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Numbers":"R1211",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Saliva@Human?Pathogen@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Numbers":"R1211",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Saliva@Human?Pathogen@Fractional (DNA & RNA Separate)?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Numbers":"R1211",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Saliva@Human?Pathogen@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Saliva@Human?Viral@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Numbers":"R1211",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
	},
	"Saliva@Human?Viral@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Numbers":"R1211",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Saliva@Human?Viral@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Saliva@Human?Total@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Numbers":"R1211",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
	},
	"Saliva@Human?Total@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Collection Numbers":"R1211",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Saliva@Human?Total@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Stool@Human?High-Molecular Weight@DNA?DNA Methylation@NGS": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Extraction/Purification Handle":"quick-dna-hmw-magbead-kit",
		"Extraction/Purification Numbers":"D6060",
		"Application Kit Handle":"zymo-seq-wgbs-library-kit,zymo-seq-rrbs-library-kit,pico-methyl-seq-library-prep-kit",
		"Application Kit Numbers":"D5465,D5460,D5461,D5455,D5456",
		"Application Kit 2 Handle":"ez-methylation-magprep-beads",
		"Application Kit 2 Numbers":"D4100-5-4,D4100-5-8,D4100-5-16",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Stool@Human?High-Molecular Weight@DNA?Chromatin Analysis@NGS": {
		"Application Kit Handle":"zymo-seq-atac-library-kit",
		"Application Kit Numbers":"D5458",
	},
	"Stool@Human?High-Molecular Weight@DNA?General/Other@NGS": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-hmw-magbead-kit",
		"Extraction/Purification Numbers":"D6060",
	},
	"Stool@Human?High-Molecular Weight@DNA?DNA Methylation@PCR/rt-PCR": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Extraction/Purification Handle":"quick-dna-hmw-magbead-kit",
		"Extraction/Purification Numbers":"D6060",
		"Application Kit Handle":"zymotaq-premix,zymotaq-dna-polymerase,zymotaq-qpcr-premix",
		"Application Kit Numbers":"E2003,E2004,E2001,E2002,E2054,E2055",
		"Application Kit 2 Handle":"ez-dna-methylation-lightning-automation-kit",
		"Application Kit 2 Numbers":"D5049",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Stool@Human?High-Molecular Weight@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-hmw-magbead-kit",
		"Extraction/Purification Numbers":"D6060",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Stool@Human?High-Molecular Weight@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Stool@Human?Microbial@DNA?General/Other@NGS": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Stool@Human?Microbial@DNA?Microbial Sequencing@NGS": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Stool@Human?Microbial@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Stool@Human?Microbial@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Stool@Human?Microbial@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Stool@Human?Pathogen@DNA?Fungal Sequencing@NGS": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Stool@Human?Pathogen@DNA?General/Other@NGS": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
	},
	"Stool@Human?Pathogen@DNA?Microbial Sequencing@NGS": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Stool@Human?Pathogen@DNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Stool@Human?Pathogen@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Stool@Human?Pathogen@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Stool@Human?Pathogen@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Stool@Human?Total@DNA?DNA Methylation@NGS": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
		"Application Kit Handle":"zymo-seq-wgbs-library-kit,zymo-seq-rrbs-library-kit,pico-methyl-seq-library-prep-kit",
		"Application Kit Numbers":"D5465,D5460,D5461,D5455,D5456",
		"Application Kit 2 Handle":"ez-methylation-magprep-beads",
		"Application Kit 2 Numbers":"D4100-5-4,D4100-5-8,D4100-5-16",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Stool@Human?Total@DNA?Chromatin Analysis@NGS": {
		"Application Kit Handle":"zymo-seq-atac-library-kit",
		"Application Kit Numbers":"D5458",
	},
	"Stool@Human?Total@DNA?Fungal Sequencing@NGS": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
	},
	"Stool@Human?Total@DNA?General/Other@NGS": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
	},
	"Stool@Human?Total@DNA?Microbial Sequencing@NGS": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Stool@Human?Total@DNA?DNA Methylation@PCR/rt-PCR": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
		"Application Kit Handle":"zymotaq-premix,zymotaq-dna-polymerase,zymotaq-qpcr-premix",
		"Application Kit Numbers":"E2003,E2004,E2001,E2002,E2054,E2055",
		"Application Kit 2 Handle":"ez-dna-methylation-lightning-automation-kit",
		"Application Kit 2 Numbers":"D5049",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Stool@Human?Total@DNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Stool@Human?Total@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Stool@Human?Total@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Stool@Human?Total@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Stool@Human?Viral@DNA?General/Other@NGS": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
	},
	"Stool@Human?Viral@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Stool@Human?Viral@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Stool@Human?Microbial@RNA?General/Other@NGS": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Stool@Human?Microbial@RNA?Microbial Sequencing@NGS": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Stool@Human?Microbial@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Stool@Human?Microbial@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Stool@Human?Microbial@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Stool@Human?micro-RNA@RNA?General/Other@NGS": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Stool@Human?micro-RNA@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Stool@Human?Pathogen@RNA?Fungal Sequencing@NGS": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Stool@Human?Pathogen@RNA?General/Other@NGS": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Stool@Human?Pathogen@RNA?Microbial Sequencing@NGS": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Stool@Human?Pathogen@RNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Stool@Human?Pathogen@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Stool@Human?Pathogen@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Stool@Human?Pathogen@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Stool@Human?Total@RNA?Fungal Sequencing@NGS": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Stool@Human?Total@RNA?General/Other@NGS": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Stool@Human?Total@RNA?Microbial Sequencing@NGS": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Stool@Human?Total@RNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Stool@Human?Total@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Stool@Human?Total@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Stool@Human?Total@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Stool@Human?Viral@RNA?General/Other@NGS": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Stool@Human?Viral@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Stool@Human?Viral@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Stool@Human?Microbial@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4,zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1,R3000,R3001",
	},
	"Stool@Human?Microbial@Total Nucleic Acid?Microbial Sequencing@NGS": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4,zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1,R3000,R3001",
	},
	"Stool@Human?Microbial@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Stool@Human?Microbial@Total Nucleic Acid?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Stool@Human?Microbial@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Stool@Human?Pathogen@Total Nucleic Acid?Fungal Sequencing@NGS": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Stool@Human?Pathogen@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
	},
	"Stool@Human?Pathogen@Total Nucleic Acid?Microbial Sequencing@NGS": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Stool@Human?Pathogen@Total Nucleic Acid?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Stool@Human?Pathogen@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Stool@Human?Pathogen@Total Nucleic Acid?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Stool@Human?Pathogen@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Stool@Human?Total@Total Nucleic Acid?DNA Methylation@NGS": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymo-seq-wgbs-library-kit,zymo-seq-rrbs-library-kit,pico-methyl-seq-library-prep-kit",
		"Application Kit Numbers":"D5465,D5460,D5461,D5455,D5456",
		"Application Kit 2 Handle":"ez-methylation-magprep-beads",
		"Application Kit 2 Numbers":"D4100-5-4,D4100-5-8,D4100-5-16",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Stool@Human?Total@Total Nucleic Acid?Chromatin Analysis@NGS": {
		"Application Kit Handle":"zymo-seq-atac-library-kit",
		"Application Kit Numbers":"D5458",
	},
	"Stool@Human?Total@Total Nucleic Acid?Fungal Sequencing@NGS": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Stool@Human?Total@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
	},
	"Stool@Human?Total@Total Nucleic Acid?Microbial Sequencing@NGS": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Stool@Human?Total@Total Nucleic Acid?DNA Methylation@PCR/rt-PCR": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Application Kit 2 Handle":"ez-dna-methylation-lightning-automation-kit",
		"Application Kit 2 Numbers":"D5049",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Stool@Human?Total@Total Nucleic Acid?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Stool@Human?Total@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Stool@Human?Total@Total Nucleic Acid?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Stool@Human?Total@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Stool@Human?Viral@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
	},
	"Stool@Human?Viral@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Stool@Human?Viral@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Stool@Human?Microbial@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4,zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1,R3000,R3001",
	},
	"Stool@Human?Microbial@Fractional (DNA & RNA Separate)?Microbial Sequencing@NGS": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4,zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1,R3000,R3001",
	},
	"Stool@Human?Microbial@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Stool@Human?Microbial@Fractional (DNA & RNA Separate)?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Stool@Human?Microbial@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Stool@Human?Pathogen@Fractional (DNA & RNA Separate)?Fungal Sequencing@NGS": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Stool@Human?Pathogen@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
	},
	"Stool@Human?Pathogen@Fractional (DNA & RNA Separate)?Microbial Sequencing@NGS": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410",
	},
	"Stool@Human?Pathogen@Fractional (DNA & RNA Separate)?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Stool@Human?Pathogen@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Stool@Human?Pathogen@Fractional (DNA & RNA Separate)?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Stool@Human?Pathogen@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Stool@Human?Viral@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
	},
	"Stool@Human?Viral@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Stool@Human?Viral@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Stool@Human?Total@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
	},
	"Stool@Human?Total@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Stool@Human?Total@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Buccal@Human?High-Molecular Weight@DNA?DNA Methylation@NGS": {
		"Collection Handle":"dna-rna-shield-safecollect-swab-collection-kit,dna-rna-shield-collection-tube-w-swab,dna-rna-shield",
		"Collection Numbers":"R1160-E,R1161-E,R1160,R1161,R1107-E,R1109-E,R1106,R1107,R1108,R1109,R1100-50,R1100-250,R1200-25,R1200-125",
		"Extraction/Purification Handle":"quick-dna-hmw-magbead-kit",
		"Extraction/Purification Numbers":"D6060",
		"Application Kit Handle":"zymo-seq-wgbs-library-kit,zymo-seq-rrbs-library-kit,pico-methyl-seq-library-prep-kit",
		"Application Kit Numbers":"D5465,D5460,D5461,D5455,D5456",
		"Application Kit 2 Handle":"ez-methylation-magprep-beads",
		"Application Kit 2 Numbers":"D4100-5-4,D4100-5-8,D4100-5-16",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Buccal@Human?High-Molecular Weight@DNA?Chromatin Analysis@NGS": {
		"Application Kit Handle":"zymo-seq-atac-library-kit",
		"Application Kit Numbers":"D5458",
	},
	"Buccal@Human?High-Molecular Weight@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-safecollect-swab-collection-kit,dna-rna-shield-collection-tube-w-swab,dna-rna-shield",
		"Collection Numbers":"R1160-E,R1161-E,R1160,R1161,R1107-E,R1109-E,R1106,R1107,R1108,R1109,R1100-50,R1100-250,R1200-25,R1200-125",
		"Extraction/Purification Handle":"quick-dna-hmw-magbead-kit",
		"Extraction/Purification Numbers":"D6060",
	},
	"Buccal@Human?High-Molecular Weight@DNA?DNA Methylation@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-safecollect-swab-collection-kit,dna-rna-shield-collection-tube-w-swab,dna-rna-shield",
		"Collection Numbers":"R1160-E,R1161-E,R1160,R1161,R1107-E,R1109-E,R1106,R1107,R1108,R1109,R1100-50,R1100-250,R1200-25,R1200-125",
		"Extraction/Purification Handle":"quick-dna-hmw-magbead-kit",
		"Extraction/Purification Numbers":"D6060",
		"Application Kit Handle":"zymotaq-premix,zymotaq-dna-polymerase,zymotaq-qpcr-premix",
		"Application Kit Numbers":"E2003,E2004,E2001,E2002,E2054,E2055",
		"Application Kit 2 Handle":"ez-dna-methylation-lightning-automation-kit",
		"Application Kit 2 Numbers":"D5049",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Buccal@Human?High-Molecular Weight@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-safecollect-swab-collection-kit,dna-rna-shield-collection-tube-w-swab,dna-rna-shield",
		"Collection Numbers":"R1160-E,R1161-E,R1160,R1161,R1107-E,R1109-E,R1106,R1107,R1108,R1109,R1100-50,R1100-250,R1200-25,R1200-125",
		"Extraction/Purification Handle":"quick-dna-hmw-magbead-kit",
		"Extraction/Purification Numbers":"D6060",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Buccal@Human?High-Molecular Weight@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Buccal@Human?Microbial@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-safecollect-swab-collection-kit,dna-rna-shield-collection-tube-w-swab,dna-rna-shield",
		"Collection Numbers":"R1160-E,R1161-E,R1160,R1161,R1107-E,R1109-E,R1106,R1107,R1108,R1109,R1100-50,R1100-250,R1200-25,R1200-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Buccal@Human?Microbial@DNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-safecollect-swab-collection-kit,dna-rna-shield-collection-tube-w-swab,dna-rna-shield",
		"Collection Numbers":"R1160-E,R1161-E,R1160,R1161,R1107-E,R1109-E,R1106,R1107,R1108,R1109,R1100-50,R1100-250,R1200-25,R1200-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Buccal@Human?Microbial@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-safecollect-swab-collection-kit,dna-rna-shield-collection-tube-w-swab,dna-rna-shield",
		"Collection Numbers":"R1160-E,R1161-E,R1160,R1161,R1107-E,R1109-E,R1106,R1107,R1108,R1109,R1100-50,R1100-250,R1200-25,R1200-125",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Buccal@Human?Microbial@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-safecollect-swab-collection-kit,dna-rna-shield-collection-tube-w-swab,dna-rna-shield",
		"Collection Numbers":"R1160-E,R1161-E,R1160,R1161,R1107-E,R1109-E,R1106,R1107,R1108,R1109,R1100-50,R1100-250,R1200-25,R1200-125",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Buccal@Human?Microbial@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Buccal@Human?Pathogen@DNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-safecollect-swab-collection-kit,dna-rna-shield-collection-tube-w-swab,dna-rna-shield",
		"Collection Numbers":"R1160-E,R1161-E,R1160,R1161,R1107-E,R1109-E,R1106,R1107,R1108,R1109,R1100-50,R1100-250,R1200-25,R1200-125",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Buccal@Human?Pathogen@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-safecollect-swab-collection-kit,dna-rna-shield-collection-tube-w-swab,dna-rna-shield",
		"Collection Numbers":"R1160-E,R1161-E,R1160,R1161,R1107-E,R1109-E,R1106,R1107,R1108,R1109,R1100-50,R1100-250,R1200-25,R1200-125",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
	},
	"Buccal@Human?Pathogen@DNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-safecollect-swab-collection-kit,dna-rna-shield-collection-tube-w-swab,dna-rna-shield",
		"Collection Numbers":"R1160-E,R1161-E,R1160,R1161,R1107-E,R1109-E,R1106,R1107,R1108,R1109,R1100-50,R1100-250,R1200-25,R1200-125",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Buccal@Human?Pathogen@DNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-safecollect-swab-collection-kit,dna-rna-shield-collection-tube-w-swab,dna-rna-shield",
		"Collection Numbers":"R1160-E,R1161-E,R1160,R1161,R1107-E,R1109-E,R1106,R1107,R1108,R1109,R1100-50,R1100-250,R1200-25,R1200-125",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Buccal@Human?Pathogen@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-safecollect-swab-collection-kit,dna-rna-shield-collection-tube-w-swab,dna-rna-shield",
		"Collection Numbers":"R1160-E,R1161-E,R1160,R1161,R1107-E,R1109-E,R1106,R1107,R1108,R1109,R1100-50,R1100-250,R1200-25,R1200-125",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Buccal@Human?Pathogen@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-safecollect-swab-collection-kit,dna-rna-shield-collection-tube-w-swab,dna-rna-shield",
		"Collection Numbers":"R1160-E,R1161-E,R1160,R1161,R1107-E,R1109-E,R1106,R1107,R1108,R1109,R1100-50,R1100-250,R1200-25,R1200-125",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Buccal@Human?Pathogen@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Buccal@Human?Total@DNA?DNA Methylation@NGS": {
		"Collection Handle":"dna-rna-shield-safecollect-swab-collection-kit,dna-rna-shield-collection-tube-w-swab,dna-rna-shield",
		"Collection Numbers":"R1160-E,R1161-E,R1160,R1161,R1107-E,R1109-E,R1106,R1107,R1108,R1109,R1100-50,R1100-250,R1200-25,R1200-125",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
		"Application Kit Handle":"zymo-seq-wgbs-library-kit,zymo-seq-rrbs-library-kit,pico-methyl-seq-library-prep-kit",
		"Application Kit Numbers":"D5465,D5460,D5461,D5455,D5456",
		"Application Kit 2 Handle":"ez-methylation-magprep-beads",
		"Application Kit 2 Numbers":"D4100-5-4,D4100-5-8,D4100-5-16",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Buccal@Human?Total@DNA?Chromatin Analysis@NGS": {
		"Application Kit Handle":"zymo-seq-atac-library-kit",
		"Application Kit Numbers":"D5458",
	},
	"Buccal@Human?Total@DNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
	},
	"Buccal@Human?Total@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
	},
	"Buccal@Human?Total@DNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Buccal@Human?Total@DNA?DNA Methylation@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-safecollect-swab-collection-kit,dna-rna-shield-collection-tube-w-swab,dna-rna-shield",
		"Collection Numbers":"R1160-E,R1161-E,R1160,R1161,R1107-E,R1109-E,R1106,R1107,R1108,R1109,R1100-50,R1100-250,R1200-25,R1200-125",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
		"Application Kit Handle":"zymotaq-premix,zymotaq-dna-polymerase,zymotaq-qpcr-premix",
		"Application Kit Numbers":"E2003,E2004,E2001,E2002,E2054,E2055",
		"Application Kit 2 Handle":"ez-dna-methylation-lightning-automation-kit",
		"Application Kit 2 Numbers":"D5049",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Buccal@Human?Total@DNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Buccal@Human?Total@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Buccal@Human?Total@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Buccal@Human?Total@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Buccal@Human?Viral@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-safecollect-swab-collection-kit,dna-rna-shield-collection-tube-w-swab,dna-rna-shield",
		"Collection Numbers":"R1160-E,R1161-E,R1160,R1161,R1107-E,R1109-E,R1106,R1107,R1108,R1109,R1100-50,R1100-250,R1200-25,R1200-125",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
	},
	"Buccal@Human?Viral@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-safecollect-swab-collection-kit,dna-rna-shield-collection-tube-w-swab,dna-rna-shield",
		"Collection Numbers":"R1160-E,R1161-E,R1160,R1161,R1107-E,R1109-E,R1106,R1107,R1108,R1109,R1100-50,R1100-250,R1200-25,R1200-125",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Buccal@Human?Viral@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Buccal@Human?Microbial@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-safecollect-swab-collection-kit,dna-rna-shield-collection-tube-w-swab,dna-rna-shield",
		"Collection Numbers":"R1160-E,R1161-E,R1160,R1161,R1107-E,R1109-E,R1106,R1107,R1108,R1109,R1100-50,R1100-250,R1200-25,R1200-125",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Buccal@Human?Microbial@RNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-safecollect-swab-collection-kit,dna-rna-shield-collection-tube-w-swab,dna-rna-shield",
		"Collection Numbers":"R1160-E,R1161-E,R1160,R1161,R1107-E,R1109-E,R1106,R1107,R1108,R1109,R1100-50,R1100-250,R1200-25,R1200-125",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Buccal@Human?Microbial@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-safecollect-swab-collection-kit,dna-rna-shield-collection-tube-w-swab,dna-rna-shield",
		"Collection Numbers":"R1160-E,R1161-E,R1160,R1161,R1107-E,R1109-E,R1106,R1107,R1108,R1109,R1100-50,R1100-250,R1200-25,R1200-125",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Buccal@Human?Microbial@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-safecollect-swab-collection-kit,dna-rna-shield-collection-tube-w-swab,dna-rna-shield",
		"Collection Numbers":"R1160-E,R1161-E,R1160,R1161,R1107-E,R1109-E,R1106,R1107,R1108,R1109,R1100-50,R1100-250,R1200-25,R1200-125",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Buccal@Human?Microbial@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Buccal@Human?micro-RNA@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-safecollect-swab-collection-kit,dna-rna-shield-collection-tube-w-swab,dna-rna-shield",
		"Collection Numbers":"R1160-E,R1161-E,R1160,R1161,R1107-E,R1109-E,R1106,R1107,R1108,R1109,R1100-50,R1100-250,R1200-25,R1200-125",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Buccal@Human?micro-RNA@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-safecollect-swab-collection-kit,dna-rna-shield-collection-tube-w-swab,dna-rna-shield",
		"Collection Numbers":"R1160-E,R1161-E,R1160,R1161,R1107-E,R1109-E,R1106,R1107,R1108,R1109,R1100-50,R1100-250,R1200-25,R1200-125",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Buccal@Human?Pathogen@RNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-safecollect-swab-collection-kit,dna-rna-shield-collection-tube-w-swab,dna-rna-shield",
		"Collection Numbers":"R1160-E,R1161-E,R1160,R1161,R1107-E,R1109-E,R1106,R1107,R1108,R1109,R1100-50,R1100-250,R1200-25,R1200-125",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Buccal@Human?Pathogen@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-safecollect-swab-collection-kit,dna-rna-shield-collection-tube-w-swab,dna-rna-shield",
		"Collection Numbers":"R1160-E,R1161-E,R1160,R1161,R1107-E,R1109-E,R1106,R1107,R1108,R1109,R1100-50,R1100-250,R1200-25,R1200-125",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Buccal@Human?Pathogen@RNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-safecollect-swab-collection-kit,dna-rna-shield-collection-tube-w-swab,dna-rna-shield",
		"Collection Numbers":"R1160-E,R1161-E,R1160,R1161,R1107-E,R1109-E,R1106,R1107,R1108,R1109,R1100-50,R1100-250,R1200-25,R1200-125",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Buccal@Human?Pathogen@RNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-safecollect-swab-collection-kit,dna-rna-shield-collection-tube-w-swab,dna-rna-shield",
		"Collection Numbers":"R1160-E,R1161-E,R1160,R1161,R1107-E,R1109-E,R1106,R1107,R1108,R1109,R1100-50,R1100-250,R1200-25,R1200-125",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Buccal@Human?Pathogen@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-safecollect-swab-collection-kit,dna-rna-shield-collection-tube-w-swab,dna-rna-shield",
		"Collection Numbers":"R1160-E,R1161-E,R1160,R1161,R1107-E,R1109-E,R1106,R1107,R1108,R1109,R1100-50,R1100-250,R1200-25,R1200-125",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Buccal@Human?Pathogen@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-safecollect-swab-collection-kit,dna-rna-shield-collection-tube-w-swab,dna-rna-shield",
		"Collection Numbers":"R1160-E,R1161-E,R1160,R1161,R1107-E,R1109-E,R1106,R1107,R1108,R1109,R1100-50,R1100-250,R1200-25,R1200-125",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Buccal@Human?Pathogen@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Buccal@Human?Total@RNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Buccal@Human?Total@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Buccal@Human?Total@RNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Buccal@Human?Total@RNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Buccal@Human?Total@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Buccal@Human?Total@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Buccal@Human?Total@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Buccal@Human?Viral@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-safecollect-swab-collection-kit,dna-rna-shield-collection-tube-w-swab,dna-rna-shield",
		"Collection Numbers":"R1160-E,R1161-E,R1160,R1161,R1107-E,R1109-E,R1106,R1107,R1108,R1109,R1100-50,R1100-250,R1200-25,R1200-125",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Buccal@Human?Viral@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-safecollect-swab-collection-kit,dna-rna-shield-collection-tube-w-swab,dna-rna-shield",
		"Collection Numbers":"R1160-E,R1161-E,R1160,R1161,R1107-E,R1109-E,R1106,R1107,R1108,R1109,R1100-50,R1100-250,R1200-25,R1200-125",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Buccal@Human?Viral@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Buccal@Human?Microbial@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410,D6432",
	},
	"Buccal@Human?Microbial@Total Nucleic Acid?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-safecollect-swab-collection-kit,dna-rna-shield-collection-tube-w-swab,dna-rna-shield",
		"Collection Numbers":"R1160-E,R1161-E,R1160,R1161,R1107-E,R1109-E,R1106,R1107,R1108,R1109,R1100-50,R1100-250,R1200-25,R1200-125",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Buccal@Human?Microbial@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-safecollect-swab-collection-kit,dna-rna-shield-collection-tube-w-swab,dna-rna-shield",
		"Collection Numbers":"R1160-E,R1161-E,R1160,R1161,R1107-E,R1109-E,R1106,R1107,R1108,R1109,R1100-50,R1100-250,R1200-25,R1200-125",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Buccal@Human?Microbial@Total Nucleic Acid?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-safecollect-swab-collection-kit,dna-rna-shield-collection-tube-w-swab,dna-rna-shield",
		"Collection Numbers":"R1160-E,R1161-E,R1160,R1161,R1107-E,R1109-E,R1106,R1107,R1108,R1109,R1100-50,R1100-250,R1200-25,R1200-125",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Buccal@Human?Microbial@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Buccal@Human?Pathogen@Total Nucleic Acid?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-safecollect-swab-collection-kit,dna-rna-shield-collection-tube-w-swab,dna-rna-shield",
		"Collection Numbers":"R1160-E,R1161-E,R1160,R1161,R1107-E,R1109-E,R1106,R1107,R1108,R1109,R1100-50,R1100-250,R1200-25,R1200-125",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Buccal@Human?Pathogen@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-safecollect-swab-collection-kit,dna-rna-shield-collection-tube-w-swab,dna-rna-shield",
		"Collection Numbers":"R1160-E,R1161-E,R1160,R1161,R1107-E,R1109-E,R1106,R1107,R1108,R1109,R1100-50,R1100-250,R1200-25,R1200-125",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
	},
	"Buccal@Human?Pathogen@Total Nucleic Acid?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-safecollect-swab-collection-kit,dna-rna-shield-collection-tube-w-swab,dna-rna-shield",
		"Collection Numbers":"R1160-E,R1161-E,R1160,R1161,R1107-E,R1109-E,R1106,R1107,R1108,R1109,R1100-50,R1100-250,R1200-25,R1200-125",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Buccal@Human?Pathogen@Total Nucleic Acid?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-safecollect-swab-collection-kit,dna-rna-shield-collection-tube-w-swab,dna-rna-shield",
		"Collection Numbers":"R1160-E,R1161-E,R1160,R1161,R1107-E,R1109-E,R1106,R1107,R1108,R1109,R1100-50,R1100-250,R1200-25,R1200-125",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Buccal@Human?Pathogen@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-safecollect-swab-collection-kit,dna-rna-shield-collection-tube-w-swab,dna-rna-shield",
		"Collection Numbers":"R1160-E,R1161-E,R1160,R1161,R1107-E,R1109-E,R1106,R1107,R1108,R1109,R1100-50,R1100-250,R1200-25,R1200-125",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Buccal@Human?Pathogen@Total Nucleic Acid?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-safecollect-swab-collection-kit,dna-rna-shield-collection-tube-w-swab,dna-rna-shield",
		"Collection Numbers":"R1160-E,R1161-E,R1160,R1161,R1107-E,R1109-E,R1106,R1107,R1108,R1109,R1100-50,R1100-250,R1200-25,R1200-125",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Buccal@Human?Pathogen@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Buccal@Human?Total@Total Nucleic Acid?DNA Methylation@NGS": {
		"Collection Handle":"dna-rna-shield-safecollect-swab-collection-kit,dna-rna-shield-collection-tube-w-swab,dna-rna-shield",
		"Collection Numbers":"R1160-E,R1161-E,R1160,R1161,R1107-E,R1109-E,R1106,R1107,R1108,R1109,R1100-50,R1100-250,R1200-25,R1200-125",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymo-seq-wgbs-library-kit,zymo-seq-rrbs-library-kit,pico-methyl-seq-library-prep-kit",
		"Application Kit Numbers":"D5465,D5460,D5461,D5455,D5456",
		"Application Kit 2 Handle":"ez-methylation-magprep-beads",
		"Application Kit 2 Numbers":"D4100-5-4,D4100-5-8,D4100-5-16",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Buccal@Human?Total@Total Nucleic Acid?Chromatin Analysis@NGS": {
		"Application Kit Handle":"zymo-seq-atac-library-kit",
		"Application Kit Numbers":"D5458",
	},
	"Buccal@Human?Total@Total Nucleic Acid?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Buccal@Human?Total@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
	},
	"Buccal@Human?Total@Total Nucleic Acid?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Buccal@Human?Total@Total Nucleic Acid?DNA Methylation@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-safecollect-swab-collection-kit,dna-rna-shield-collection-tube-w-swab,dna-rna-shield",
		"Collection Numbers":"R1160-E,R1161-E,R1160,R1161,R1107-E,R1109-E,R1106,R1107,R1108,R1109,R1100-50,R1100-250,R1200-25,R1200-125",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Application Kit 2 Handle":"ez-dna-methylation-lightning-automation-kit",
		"Application Kit 2 Numbers":"D5049",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Buccal@Human?Total@Total Nucleic Acid?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Buccal@Human?Total@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Buccal@Human?Total@Total Nucleic Acid?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Buccal@Human?Total@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Buccal@Human?Viral@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-safecollect-swab-collection-kit,dna-rna-shield-collection-tube-w-swab,dna-rna-shield",
		"Collection Numbers":"R1160-E,R1161-E,R1160,R1161,R1107-E,R1109-E,R1106,R1107,R1108,R1109,R1100-50,R1100-250,R1200-25,R1200-125",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
	},
	"Buccal@Human?Viral@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-safecollect-swab-collection-kit,dna-rna-shield-collection-tube-w-swab,dna-rna-shield",
		"Collection Numbers":"R1160-E,R1161-E,R1160,R1161,R1107-E,R1109-E,R1106,R1107,R1108,R1109,R1100-50,R1100-250,R1200-25,R1200-125",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Buccal@Human?Viral@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Buccal@Human?Microbial@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-safecollect-swab-collection-kit,dna-rna-shield-collection-tube-w-swab,dna-rna-shield",
		"Collection Numbers":"R1160-E,R1161-E,R1160,R1161,R1107-E,R1109-E,R1106,R1107,R1108,R1109,R1100-50,R1100-250,R1200-25,R1200-125",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410,D6432",
	},
	"Buccal@Human?Microbial@Fractional (DNA & RNA Separate)?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-safecollect-swab-collection-kit,dna-rna-shield-collection-tube-w-swab,dna-rna-shield",
		"Collection Numbers":"R1160-E,R1161-E,R1160,R1161,R1107-E,R1109-E,R1106,R1107,R1108,R1109,R1100-50,R1100-250,R1200-25,R1200-125",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410",
	},
	"Buccal@Human?Microbial@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-safecollect-swab-collection-kit,dna-rna-shield-collection-tube-w-swab,dna-rna-shield",
		"Collection Numbers":"R1160-E,R1161-E,R1160,R1161,R1107-E,R1109-E,R1106,R1107,R1108,R1109,R1100-50,R1100-250,R1200-25,R1200-125",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Buccal@Human?Microbial@Fractional (DNA & RNA Separate)?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-safecollect-swab-collection-kit,dna-rna-shield-collection-tube-w-swab,dna-rna-shield",
		"Collection Numbers":"R1160-E,R1161-E,R1160,R1161,R1107-E,R1109-E,R1106,R1107,R1108,R1109,R1100-50,R1100-250,R1200-25,R1200-125",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Buccal@Human?Microbial@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Buccal@Human?Pathogen@Fractional (DNA & RNA Separate)?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-safecollect-swab-collection-kit,dna-rna-shield-collection-tube-w-swab,dna-rna-shield",
		"Collection Numbers":"R1160-E,R1161-E,R1160,R1161,R1107-E,R1109-E,R1106,R1107,R1108,R1109,R1100-50,R1100-250,R1200-25,R1200-125",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Buccal@Human?Pathogen@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-safecollect-swab-collection-kit,dna-rna-shield-collection-tube-w-swab,dna-rna-shield",
		"Collection Numbers":"R1160-E,R1161-E,R1160,R1161,R1107-E,R1109-E,R1106,R1107,R1108,R1109,R1100-50,R1100-250,R1200-25,R1200-125",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
	},
	"Buccal@Human?Pathogen@Fractional (DNA & RNA Separate)?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-safecollect-swab-collection-kit,dna-rna-shield-collection-tube-w-swab,dna-rna-shield",
		"Collection Numbers":"R1160-E,R1161-E,R1160,R1161,R1107-E,R1109-E,R1106,R1107,R1108,R1109,R1100-50,R1100-250,R1200-25,R1200-125",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410",
	},
	"Buccal@Human?Pathogen@Fractional (DNA & RNA Separate)?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-safecollect-swab-collection-kit,dna-rna-shield-collection-tube-w-swab,dna-rna-shield",
		"Collection Numbers":"R1160-E,R1161-E,R1160,R1161,R1107-E,R1109-E,R1106,R1107,R1108,R1109,R1100-50,R1100-250,R1200-25,R1200-125",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Buccal@Human?Pathogen@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-safecollect-swab-collection-kit,dna-rna-shield-collection-tube-w-swab,dna-rna-shield",
		"Collection Numbers":"R1160-E,R1161-E,R1160,R1161,R1107-E,R1109-E,R1106,R1107,R1108,R1109,R1100-50,R1100-250,R1200-25,R1200-125",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Buccal@Human?Pathogen@Fractional (DNA & RNA Separate)?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-safecollect-swab-collection-kit,dna-rna-shield-collection-tube-w-swab,dna-rna-shield",
		"Collection Numbers":"R1160-E,R1161-E,R1160,R1161,R1107-E,R1109-E,R1106,R1107,R1108,R1109,R1100-50,R1100-250,R1200-25,R1200-125",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Buccal@Human?Pathogen@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Buccal@Human?Viral@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-safecollect-swab-collection-kit,dna-rna-shield-collection-tube-w-swab,dna-rna-shield",
		"Collection Numbers":"R1160-E,R1161-E,R1160,R1161,R1107-E,R1109-E,R1106,R1107,R1108,R1109,R1100-50,R1100-250,R1200-25,R1200-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
	},
	"Buccal@Human?Viral@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-safecollect-swab-collection-kit,dna-rna-shield-collection-tube-w-swab,dna-rna-shield",
		"Collection Numbers":"R1160-E,R1161-E,R1160,R1161,R1107-E,R1109-E,R1106,R1107,R1108,R1109,R1100-50,R1100-250,R1200-25,R1200-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Buccal@Human?Viral@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Buccal@Human?Total@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
	},
	"Buccal@Human?Total@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Buccal@Human?Total@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Urine@Human?Cell-Free@DNA?DNA Methylation@NGS": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Extraction/Purification Handle":"magicbead-cfdna-isolation-kit",
		"Extraction/Purification Numbers":"D4086",
		"Application Kit Handle":"zymo-seq-cell-free-dna-wgbs-library-kit",
		"Application Kit Numbers":"D5462,D5463",
		"Application Kit 2 Handle":"ez-methylation-magprep-beads",
		"Application Kit 2 Numbers":"D4100-5-4,D4100-5-8,D4100-5-16",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Urine@Human?Cell-Free@DNA?Fungal Sequencing@NGS": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Extraction/Purification Handle":"magicbead-cfdna-isolation-kit",
		"Extraction/Purification Numbers":"D4086",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Urine@Human?Cell-Free@DNA?General/Other@NGS": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Extraction/Purification Handle":"magicbead-cfdna-isolation-kit",
		"Extraction/Purification Numbers":"D4086",
		"Application Kit Handle":"zymo-seq-cell-free-dna-wgbs-library-kit",
		"Application Kit Numbers":"D5462,D5463",
	},
	"Urine@Human?Cell-Free@DNA?Microbial Sequencing@NGS": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"magicbead-cfdna-isolation-kit",
		"Extraction/Purification Numbers":"D4086",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Urine@Human?Cell-Free@DNA?DNA Methylation@PCR/rt-PCR": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Extraction/Purification Handle":"magicbead-cfdna-isolation-kit",
		"Extraction/Purification Numbers":"D4086",
		"Application Kit Handle":"zymotaq-premix,zymotaq-dna-polymerase,zymotaq-qpcr-premix",
		"Application Kit Numbers":"E2003,E2004,E2001,E2002,E2054,E2055",
		"Application Kit 2 Handle":"ez-dna-methylation-lightning-automation-kit",
		"Application Kit 2 Numbers":"D5049",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Urine@Human?Cell-Free@DNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Extraction/Purification Handle":"magicbead-cfdna-isolation-kit",
		"Extraction/Purification Numbers":"D4086",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Urine@Human?Cell-Free@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Extraction/Purification Handle":"magicbead-cfdna-isolation-kit",
		"Extraction/Purification Numbers":"D4086",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Urine@Human?Cell-Free@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"magicbead-cfdna-isolation-kit",
		"Extraction/Purification Numbers":"D4086",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Urine@Human?Cell-Free@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Urine@Human?Microbial@DNA?General/Other@NGS": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Urine@Human?Microbial@DNA?Microbial Sequencing@NGS": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Urine@Human?Microbial@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Urine@Human?Microbial@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Urine@Human?Microbial@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Urine@Human?Pathogen@DNA?Fungal Sequencing@NGS": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Urine@Human?Pathogen@DNA?General/Other@NGS": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
	},
	"Urine@Human?Pathogen@DNA?Microbial Sequencing@NGS": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Urine@Human?Pathogen@DNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Urine@Human?Pathogen@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Urine@Human?Pathogen@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Urine@Human?Pathogen@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Urine@Human?Total@DNA?DNA Methylation@NGS": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
		"Application Kit Handle":"zymo-seq-wgbs-library-kit,zymo-seq-rrbs-library-kit,pico-methyl-seq-library-prep-kit",
		"Application Kit Numbers":"D5465,D5460,D5461,D5455,D5456",
		"Application Kit 2 Handle":"ez-methylation-magprep-beads",
		"Application Kit 2 Numbers":"D4100-5-4,D4100-5-8,D4100-5-16",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Urine@Human?Total@DNA?Chromatin Analysis@NGS": {
		"Application Kit Handle":"zymo-seq-atac-library-kit",
		"Application Kit Numbers":"D5458",
	},
	"Urine@Human?Total@DNA?Fungal Sequencing@NGS": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
	},
	"Urine@Human?Total@DNA?General/Other@NGS": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
	},
	"Urine@Human?Total@DNA?Microbial Sequencing@NGS": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Urine@Human?Total@DNA?DNA Methylation@PCR/rt-PCR": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
		"Application Kit Handle":"zymotaq-premix,zymotaq-dna-polymerase,zymotaq-qpcr-premix",
		"Application Kit Numbers":"E2003,E2004,E2001,E2002,E2054,E2055",
		"Application Kit 2 Handle":"ez-dna-methylation-lightning-automation-kit",
		"Application Kit 2 Numbers":"D5049",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Urine@Human?Total@DNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Urine@Human?Total@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Urine@Human?Total@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Urine@Human?Total@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Urine@Human?Viral@DNA?General/Other@NGS": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
	},
	"Urine@Human?Viral@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Urine@Human?Viral@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Urine@Human?Microbial@RNA?General/Other@NGS": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Urine@Human?Microbial@RNA?Microbial Sequencing@NGS": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Urine@Human?Microbial@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Urine@Human?Microbial@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Urine@Human?Microbial@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Urine@Human?micro-RNA@RNA?General/Other@NGS": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Urine@Human?micro-RNA@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Urine@Human?Pathogen@RNA?Fungal Sequencing@NGS": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Urine@Human?Pathogen@RNA?General/Other@NGS": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Urine@Human?Pathogen@RNA?Microbial Sequencing@NGS": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Urine@Human?Pathogen@RNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Urine@Human?Pathogen@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Urine@Human?Pathogen@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Urine@Human?Pathogen@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Urine@Human?Total@RNA?Fungal Sequencing@NGS": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Urine@Human?Total@RNA?General/Other@NGS": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Urine@Human?Total@RNA?Microbial Sequencing@NGS": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Urine@Human?Total@RNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Urine@Human?Total@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Urine@Human?Total@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Urine@Human?Total@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Urine@Human?Viral@RNA?General/Other@NGS": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Urine@Human?Viral@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Urine@Human?Viral@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Urine@Human?Microbial@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410,D6432",
	},
	"Urine@Human?Microbial@Total Nucleic Acid?Microbial Sequencing@NGS": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Urine@Human?Microbial@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Urine@Human?Microbial@Total Nucleic Acid?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Urine@Human?Microbial@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Urine@Human?Pathogen@Total Nucleic Acid?Fungal Sequencing@NGS": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Urine@Human?Pathogen@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
	},
	"Urine@Human?Pathogen@Total Nucleic Acid?Microbial Sequencing@NGS": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Urine@Human?Pathogen@Total Nucleic Acid?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Urine@Human?Pathogen@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Urine@Human?Pathogen@Total Nucleic Acid?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Urine@Human?Pathogen@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Urine@Human?Total@Total Nucleic Acid?DNA Methylation@NGS": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymo-seq-wgbs-library-kit,zymo-seq-rrbs-library-kit,pico-methyl-seq-library-prep-kit",
		"Application Kit Numbers":"D5465,D5460,D5461,D5455,D5456",
		"Application Kit 2 Handle":"ez-methylation-magprep-beads",
		"Application Kit 2 Numbers":"D4100-5-4,D4100-5-8,D4100-5-16",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Urine@Human?Total@Total Nucleic Acid?Chromatin Analysis@NGS": {
		"Application Kit Handle":"zymo-seq-atac-library-kit",
		"Application Kit Numbers":"D5458",
	},
	"Urine@Human?Total@Total Nucleic Acid?Fungal Sequencing@NGS": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Urine@Human?Total@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
	},
	"Urine@Human?Total@Total Nucleic Acid?Microbial Sequencing@NGS": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Urine@Human?Total@Total Nucleic Acid?DNA Methylation@PCR/rt-PCR": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Application Kit 2 Handle":"ez-dna-methylation-lightning-automation-kit",
		"Application Kit 2 Numbers":"D5049",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Urine@Human?Total@Total Nucleic Acid?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Urine@Human?Total@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Urine@Human?Total@Total Nucleic Acid?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Urine@Human?Total@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Urine@Human?Viral@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
	},
	"Urine@Human?Viral@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Urine@Human?Viral@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Urine@Human?Microbial@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410,D6432",
	},
	"Urine@Human?Microbial@Fractional (DNA & RNA Separate)?Microbial Sequencing@NGS": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410",
	},
	"Urine@Human?Microbial@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Urine@Human?Microbial@Fractional (DNA & RNA Separate)?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Urine@Human?Microbial@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Urine@Human?Pathogen@Fractional (DNA & RNA Separate)?Fungal Sequencing@NGS": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Urine@Human?Pathogen@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
	},
	"Urine@Human?Pathogen@Fractional (DNA & RNA Separate)?Microbial Sequencing@NGS": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410",
	},
	"Urine@Human?Pathogen@Fractional (DNA & RNA Separate)?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Urine@Human?Pathogen@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Urine@Human?Pathogen@Fractional (DNA & RNA Separate)?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Urine@Human?Pathogen@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Urine@Human?Viral@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
	},
	"Urine@Human?Viral@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Urine@Human?Viral@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Urine@Human?Total@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
	},
	"Urine@Human?Total@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Urine@Human?Total@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Whole Blood@Human?High-Molecular Weight@DNA?DNA Methylation@NGS": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Extraction/Purification Handle":"quick-dna-hmw-magbead-kit",
		"Extraction/Purification Numbers":"D6060",
		"Application Kit Handle":"zymo-seq-wgbs-library-kit,zymo-seq-rrbs-library-kit,pico-methyl-seq-library-prep-kit",
		"Application Kit Numbers":"D5465,D5460,D5461,D5455,D5456",
		"Application Kit 2 Handle":"ez-methylation-magprep-beads",
		"Application Kit 2 Numbers":"D4100-5-4,D4100-5-8,D4100-5-16",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Whole Blood@Human?High-Molecular Weight@DNA?Chromatin Analysis@NGS": {
		"Application Kit Handle":"zymo-seq-atac-library-kit",
		"Application Kit Numbers":"D5458",
	},
	"Whole Blood@Human?High-Molecular Weight@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Extraction/Purification Handle":"quick-dna-hmw-magbead-kit",
		"Extraction/Purification Numbers":"D6060",
	},
	"Whole Blood@Human?High-Molecular Weight@DNA?DNA Methylation@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Extraction/Purification Handle":"quick-dna-hmw-magbead-kit",
		"Extraction/Purification Numbers":"D6060",
		"Application Kit Handle":"zymotaq-premix,zymotaq-dna-polymerase,zymotaq-qpcr-premix",
		"Application Kit Numbers":"E2003,E2004,E2001,E2002,E2054,E2055",
		"Application Kit 2 Handle":"ez-dna-methylation-lightning-automation-kit",
		"Application Kit 2 Numbers":"D5049",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Whole Blood@Human?High-Molecular Weight@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Extraction/Purification Handle":"quick-dna-hmw-magbead-kit",
		"Extraction/Purification Numbers":"D6060",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Whole Blood@Human?High-Molecular Weight@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Whole Blood@Human?Microbial@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Whole Blood@Human?Microbial@DNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Whole Blood@Human?Microbial@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Whole Blood@Human?Microbial@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Whole Blood@Human?Microbial@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Whole Blood@Human?Pathogen@DNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Whole Blood@Human?Pathogen@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
	},
	"Whole Blood@Human?Pathogen@DNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Whole Blood@Human?Pathogen@DNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Whole Blood@Human?Pathogen@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Whole Blood@Human?Pathogen@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Whole Blood@Human?Pathogen@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Whole Blood@Human?Total@DNA?DNA Methylation@NGS": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
		"Application Kit Handle":"zymo-seq-wgbs-library-kit,zymo-seq-rrbs-library-kit,pico-methyl-seq-library-prep-kit",
		"Application Kit Numbers":"D5465,D5460,D5461,D5455,D5456",
		"Application Kit 2 Handle":"ez-methylation-magprep-beads",
		"Application Kit 2 Numbers":"D4100-5-4,D4100-5-8,D4100-5-16",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Whole Blood@Human?Total@DNA?Chromatin Analysis@NGS": {
		"Application Kit Handle":"zymo-seq-atac-library-kit",
		"Application Kit Numbers":"D5458",
	},
	"Whole Blood@Human?Total@DNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
	},
	"Whole Blood@Human?Total@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
	},
	"Whole Blood@Human?Total@DNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Whole Blood@Human?Total@DNA?DNA Methylation@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
		"Application Kit Handle":"zymotaq-premix,zymotaq-dna-polymerase,zymotaq-qpcr-premix",
		"Application Kit Numbers":"E2003,E2004,E2001,E2002,E2054,E2055",
		"Application Kit 2 Handle":"ez-dna-methylation-lightning-automation-kit",
		"Application Kit 2 Numbers":"D5049",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Whole Blood@Human?Total@DNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Whole Blood@Human?Total@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Whole Blood@Human?Total@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Whole Blood@Human?Total@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Whole Blood@Human?Viral@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
	},
	"Whole Blood@Human?Viral@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Whole Blood@Human?Viral@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Whole Blood@Human?Microbial@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Whole Blood@Human?Microbial@RNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Whole Blood@Human?Microbial@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Whole Blood@Human?Microbial@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Whole Blood@Human?Microbial@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Whole Blood@Human?micro-RNA@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Whole Blood@Human?micro-RNA@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Whole Blood@Human?Pathogen@RNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Whole Blood@Human?Pathogen@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Whole Blood@Human?Pathogen@RNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Whole Blood@Human?Pathogen@RNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Whole Blood@Human?Pathogen@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Whole Blood@Human?Pathogen@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Whole Blood@Human?Pathogen@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Whole Blood@Human?Total@RNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Whole Blood@Human?Total@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Whole Blood@Human?Total@RNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Whole Blood@Human?Total@RNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Whole Blood@Human?Total@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Whole Blood@Human?Total@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Whole Blood@Human?Total@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Whole Blood@Human?Viral@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Whole Blood@Human?Viral@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Whole Blood@Human?Viral@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Whole Blood@Human?Microbial@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410,D6432",
	},
	"Whole Blood@Human?Microbial@Total Nucleic Acid?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Whole Blood@Human?Microbial@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Whole Blood@Human?Microbial@Total Nucleic Acid?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Whole Blood@Human?Microbial@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Whole Blood@Human?Pathogen@Total Nucleic Acid?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Whole Blood@Human?Pathogen@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
	},
	"Whole Blood@Human?Pathogen@Total Nucleic Acid?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Whole Blood@Human?Pathogen@Total Nucleic Acid?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Whole Blood@Human?Pathogen@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Whole Blood@Human?Pathogen@Total Nucleic Acid?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Whole Blood@Human?Pathogen@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Whole Blood@Human?Total@Total Nucleic Acid?DNA Methylation@NGS": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymo-seq-wgbs-library-kit,zymo-seq-rrbs-library-kit,pico-methyl-seq-library-prep-kit",
		"Application Kit Numbers":"D5465,D5460,D5461,D5455,D5456",
		"Application Kit 2 Handle":"ez-methylation-magprep-beads",
		"Application Kit 2 Numbers":"D4100-5-4,D4100-5-8,D4100-5-16",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Whole Blood@Human?Total@Total Nucleic Acid?Chromatin Analysis@NGS": {
		"Application Kit Handle":"zymo-seq-atac-library-kit",
		"Application Kit Numbers":"D5458",
	},
	"Whole Blood@Human?Total@Total Nucleic Acid?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Whole Blood@Human?Total@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
	},
	"Whole Blood@Human?Total@Total Nucleic Acid?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Whole Blood@Human?Total@Total Nucleic Acid?DNA Methylation@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Application Kit 2 Handle":"ez-dna-methylation-lightning-automation-kit",
		"Application Kit 2 Numbers":"D5049",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Whole Blood@Human?Total@Total Nucleic Acid?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Whole Blood@Human?Total@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Whole Blood@Human?Total@Total Nucleic Acid?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Whole Blood@Human?Total@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Whole Blood@Human?Viral@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
	},
	"Whole Blood@Human?Viral@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Whole Blood@Human?Viral@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Whole Blood@Human?Microbial@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410,D6432",
	},
	"Whole Blood@Human?Microbial@Fractional (DNA & RNA Separate)?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410",
	},
	"Whole Blood@Human?Microbial@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Whole Blood@Human?Microbial@Fractional (DNA & RNA Separate)?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Whole Blood@Human?Microbial@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Whole Blood@Human?Pathogen@Fractional (DNA & RNA Separate)?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Whole Blood@Human?Pathogen@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
	},
	"Whole Blood@Human?Pathogen@Fractional (DNA & RNA Separate)?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410",
	},
	"Whole Blood@Human?Pathogen@Fractional (DNA & RNA Separate)?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Whole Blood@Human?Pathogen@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Whole Blood@Human?Pathogen@Fractional (DNA & RNA Separate)?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Whole Blood@Human?Pathogen@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Whole Blood@Human?Viral@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
	},
	"Whole Blood@Human?Viral@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Whole Blood@Human?Viral@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Whole Blood@Human?Total@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
	},
	"Whole Blood@Human?Total@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Whole Blood@Human?Total@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Trizol@Human?Microbial@RNA?General/Other@NGS": {
		"Collection Handle":"tri-reagent",
		"Collection Numbers":"R2050-1-200",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"direct-zol-96-magbead-rna",
		"Extraction/Purification Numbers":"R2100,R2101,R2102,R2103",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Trizol@Human?Microbial@RNA?Microbial Sequencing@NGS": {
		"Collection Handle":"tri-reagent",
		"Collection Numbers":"R2050-1-200",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"direct-zol-96-magbead-rna",
		"Extraction/Purification Numbers":"R2100,R2101,R2102,R2103",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Trizol@Human?Microbial@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"tri-reagent",
		"Collection Numbers":"R2050-1-200",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"direct-zol-96-magbead-rna",
		"Extraction/Purification Numbers":"R2100,R2101,R2102,R2103",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Trizol@Human?Microbial@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"tri-reagent",
		"Collection Numbers":"R2050-1-200",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"direct-zol-96-magbead-rna",
		"Extraction/Purification Numbers":"R2100,R2101,R2102,R2103",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Trizol@Human?Microbial@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Trizol@Human?micro-RNA@RNA?General/Other@NGS": {
		"Collection Handle":"tri-reagent",
		"Collection Numbers":"R2050-1-200",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Trizol@Human?micro-RNA@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"tri-reagent",
		"Collection Numbers":"R2050-1-200",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Trizol@Human?Pathogen@RNA?Fungal Sequencing@NGS": {
		"Collection Handle":"tri-reagent",
		"Collection Numbers":"R2050-1-200",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Trizol@Human?Pathogen@RNA?General/Other@NGS": {
		"Collection Handle":"tri-reagent",
		"Collection Numbers":"R2050-1-200",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Trizol@Human?Pathogen@RNA?Microbial Sequencing@NGS": {
		"Collection Handle":"tri-reagent",
		"Collection Numbers":"R2050-1-200",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Trizol@Human?Pathogen@RNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"tri-reagent",
		"Collection Numbers":"R2050-1-200",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Trizol@Human?Pathogen@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"tri-reagent",
		"Collection Numbers":"R2050-1-200",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Trizol@Human?Pathogen@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"tri-reagent",
		"Collection Numbers":"R2050-1-200",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Trizol@Human?Pathogen@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Trizol@Human?Total@RNA?Fungal Sequencing@NGS": {
		"Collection Handle":"tri-reagent",
		"Collection Numbers":"R2050-1-200",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"direct-zol-96-magbead-rna",
		"Extraction/Purification Numbers":"R2100,R2101,R2102,R2103",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Trizol@Human?Total@RNA?General/Other@NGS": {
		"Collection Handle":"tri-reagent",
		"Collection Numbers":"R2050-1-200",
		"Extraction/Purification Handle":"direct-zol-96-magbead-rna",
		"Extraction/Purification Numbers":"R2100,R2101,R2102,R2103",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Trizol@Human?Total@RNA?Microbial Sequencing@NGS": {
		"Collection Handle":"tri-reagent",
		"Collection Numbers":"R2050-1-200",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"direct-zol-96-magbead-rna",
		"Extraction/Purification Numbers":"R2100,R2101,R2102,R2103",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Trizol@Human?Total@RNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"tri-reagent",
		"Collection Numbers":"R2050-1-200",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"direct-zol-96-magbead-rna",
		"Extraction/Purification Numbers":"R2100,R2101,R2102,R2103",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Trizol@Human?Total@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"tri-reagent",
		"Collection Numbers":"R2050-1-200",
		"Extraction/Purification Handle":"direct-zol-96-magbead-rna",
		"Extraction/Purification Numbers":"R2100,R2101,R2102,R2103",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Trizol@Human?Total@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"tri-reagent",
		"Collection Numbers":"R2050-1-200",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"direct-zol-96-magbead-rna",
		"Extraction/Purification Numbers":"R2100,R2101,R2102,R2103",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Trizol@Human?Total@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Trizol@Human?Viral@RNA?General/Other@NGS": {
		"Collection Handle":"tri-reagent",
		"Collection Numbers":"R2050-1-200",
		"Extraction/Purification Handle":"direct-zol-96-magbead-rna",
		"Extraction/Purification Numbers":"R2100,R2101,R2102,R2103",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Trizol@Human?Viral@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"tri-reagent",
		"Collection Numbers":"R2050-1-200",
		"Extraction/Purification Handle":"direct-zol-96-magbead-rna",
		"Extraction/Purification Numbers":"R2100,R2101,R2102,R2103",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Trizol@Human?Viral@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Eukaryotic Cells@Human?High-Molecular Weight@DNA?DNA Methylation@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-hmw-magbead-kit",
		"Extraction/Purification Numbers":"D6060",
		"Application Kit Handle":"zymo-seq-wgbs-library-kit,zymo-seq-rrbs-library-kit,pico-methyl-seq-library-prep-kit",
		"Application Kit Numbers":"D5465,D5460,D5461,D5455,D5456",
		"Application Kit 2 Handle":"ez-methylation-magprep-beads",
		"Application Kit 2 Numbers":"D4100-5-4,D4100-5-8,D4100-5-16",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Eukaryotic Cells@Human?High-Molecular Weight@DNA?Chromatin Analysis@NGS": {
		"Application Kit Handle":"zymo-seq-atac-library-kit",
		"Application Kit Numbers":"D5458",
	},
	"Eukaryotic Cells@Human?High-Molecular Weight@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-hmw-magbead-kit",
		"Extraction/Purification Numbers":"D6060",
	},
	"Eukaryotic Cells@Human?High-Molecular Weight@DNA?DNA Methylation@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-hmw-magbead-kit",
		"Extraction/Purification Numbers":"D6060",
		"Application Kit Handle":"zymotaq-premix,zymotaq-dna-polymerase,zymotaq-qpcr-premix",
		"Application Kit Numbers":"E2003,E2004,E2001,E2002,E2054,E2055",
		"Application Kit 2 Handle":"ez-dna-methylation-lightning-automation-kit",
		"Application Kit 2 Numbers":"D5049",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Eukaryotic Cells@Human?High-Molecular Weight@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-hmw-magbead-kit",
		"Extraction/Purification Numbers":"D6060",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Eukaryotic Cells@Human?High-Molecular Weight@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Eukaryotic Cells@Human?Microbial@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Eukaryotic Cells@Human?Microbial@DNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Eukaryotic Cells@Human?Microbial@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Eukaryotic Cells@Human?Microbial@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Eukaryotic Cells@Human?Microbial@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Eukaryotic Cells@Human?Pathogen@DNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Eukaryotic Cells@Human?Pathogen@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
	},
	"Eukaryotic Cells@Human?Pathogen@DNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Eukaryotic Cells@Human?Pathogen@DNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Eukaryotic Cells@Human?Pathogen@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Eukaryotic Cells@Human?Pathogen@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Eukaryotic Cells@Human?Pathogen@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Eukaryotic Cells@Human?Total@DNA?DNA Methylation@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
		"Application Kit Handle":"zymo-seq-wgbs-library-kit,zymo-seq-rrbs-library-kit,pico-methyl-seq-library-prep-kit",
		"Application Kit Numbers":"D5465,D5460,D5461,D5455,D5456",
		"Application Kit 2 Handle":"ez-methylation-magprep-beads",
		"Application Kit 2 Numbers":"D4100-5-4,D4100-5-8,D4100-5-16",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Eukaryotic Cells@Human?Total@DNA?Chromatin Analysis@NGS": {
		"Application Kit Handle":"zymo-seq-atac-library-kit",
		"Application Kit Numbers":"D5458",
	},
	"Eukaryotic Cells@Human?Total@DNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
	},
	"Eukaryotic Cells@Human?Total@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
	},
	"Eukaryotic Cells@Human?Total@DNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Eukaryotic Cells@Human?Total@DNA?DNA Methylation@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
		"Application Kit Handle":"zymotaq-premix,zymotaq-dna-polymerase,zymotaq-qpcr-premix",
		"Application Kit Numbers":"E2003,E2004,E2001,E2002,E2054,E2055",
		"Application Kit 2 Handle":"ez-dna-methylation-lightning-automation-kit",
		"Application Kit 2 Numbers":"D5049",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Eukaryotic Cells@Human?Total@DNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Eukaryotic Cells@Human?Total@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Eukaryotic Cells@Human?Total@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Eukaryotic Cells@Human?Total@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Eukaryotic Cells@Human?Viral@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
	},
	"Eukaryotic Cells@Human?Viral@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Eukaryotic Cells@Human?Viral@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Eukaryotic Cells@Human?Microbial@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Eukaryotic Cells@Human?Microbial@RNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Eukaryotic Cells@Human?Microbial@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Eukaryotic Cells@Human?Microbial@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Eukaryotic Cells@Human?Microbial@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Eukaryotic Cells@Human?micro-RNA@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Eukaryotic Cells@Human?micro-RNA@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Eukaryotic Cells@Human?Pathogen@RNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Eukaryotic Cells@Human?Pathogen@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Eukaryotic Cells@Human?Pathogen@RNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Eukaryotic Cells@Human?Pathogen@RNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Eukaryotic Cells@Human?Pathogen@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Eukaryotic Cells@Human?Pathogen@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Eukaryotic Cells@Human?Pathogen@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Eukaryotic Cells@Human?Total@RNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Eukaryotic Cells@Human?Total@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Eukaryotic Cells@Human?Total@RNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Eukaryotic Cells@Human?Total@RNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Eukaryotic Cells@Human?Total@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Eukaryotic Cells@Human?Total@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Eukaryotic Cells@Human?Total@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Eukaryotic Cells@Human?Viral@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Eukaryotic Cells@Human?Viral@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Eukaryotic Cells@Human?Viral@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Eukaryotic Cells@Human?Microbial@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410,D6432",
	},
	"Eukaryotic Cells@Human?Microbial@Total Nucleic Acid?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Eukaryotic Cells@Human?Microbial@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Eukaryotic Cells@Human?Microbial@Total Nucleic Acid?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Eukaryotic Cells@Human?Microbial@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Eukaryotic Cells@Human?Pathogen@Total Nucleic Acid?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Eukaryotic Cells@Human?Pathogen@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
	},
	"Eukaryotic Cells@Human?Pathogen@Total Nucleic Acid?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Eukaryotic Cells@Human?Pathogen@Total Nucleic Acid?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Eukaryotic Cells@Human?Pathogen@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Eukaryotic Cells@Human?Pathogen@Total Nucleic Acid?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Eukaryotic Cells@Human?Pathogen@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Eukaryotic Cells@Human?Total@Total Nucleic Acid?DNA Methylation@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymo-seq-wgbs-library-kit,zymo-seq-rrbs-library-kit,pico-methyl-seq-library-prep-kit",
		"Application Kit Numbers":"D5465,D5460,D5461,D5455,D5456",
		"Application Kit 2 Handle":"ez-methylation-magprep-beads",
		"Application Kit 2 Numbers":"D4100-5-4,D4100-5-8,D4100-5-16",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Eukaryotic Cells@Human?Total@Total Nucleic Acid?Chromatin Analysis@NGS": {
		"Application Kit Handle":"zymo-seq-atac-library-kit",
		"Application Kit Numbers":"D5458",
	},
	"Eukaryotic Cells@Human?Total@Total Nucleic Acid?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Eukaryotic Cells@Human?Total@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
	},
	"Eukaryotic Cells@Human?Total@Total Nucleic Acid?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Eukaryotic Cells@Human?Total@Total Nucleic Acid?DNA Methylation@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Application Kit 2 Handle":"ez-dna-methylation-lightning-automation-kit",
		"Application Kit 2 Numbers":"D5049",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Eukaryotic Cells@Human?Total@Total Nucleic Acid?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Eukaryotic Cells@Human?Total@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Eukaryotic Cells@Human?Total@Total Nucleic Acid?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Eukaryotic Cells@Human?Total@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Eukaryotic Cells@Human?Viral@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
	},
	"Eukaryotic Cells@Human?Viral@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Eukaryotic Cells@Human?Viral@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Eukaryotic Cells@Human?Microbial@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410,D6432",
	},
	"Eukaryotic Cells@Human?Microbial@Fractional (DNA & RNA Separate)?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410",
	},
	"Eukaryotic Cells@Human?Microbial@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Eukaryotic Cells@Human?Microbial@Fractional (DNA & RNA Separate)?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Eukaryotic Cells@Human?Microbial@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Eukaryotic Cells@Human?Pathogen@Fractional (DNA & RNA Separate)?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Eukaryotic Cells@Human?Pathogen@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
	},
	"Eukaryotic Cells@Human?Pathogen@Fractional (DNA & RNA Separate)?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410",
	},
	"Eukaryotic Cells@Human?Pathogen@Fractional (DNA & RNA Separate)?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Eukaryotic Cells@Human?Pathogen@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Eukaryotic Cells@Human?Pathogen@Fractional (DNA & RNA Separate)?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Eukaryotic Cells@Human?Pathogen@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Eukaryotic Cells@Human?Viral@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
	},
	"Eukaryotic Cells@Human?Viral@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Eukaryotic Cells@Human?Viral@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Eukaryotic Cells@Human?Total@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
	},
	"Eukaryotic Cells@Human?Total@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Eukaryotic Cells@Human?Total@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Buffy Coat@Human?High-Molecular Weight@DNA?DNA Methylation@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-hmw-magbead-kit",
		"Extraction/Purification Numbers":"D6060",
		"Application Kit Handle":"zymo-seq-wgbs-library-kit,zymo-seq-rrbs-library-kit,pico-methyl-seq-library-prep-kit",
		"Application Kit Numbers":"D5465,D5460,D5461,D5455,D5456",
		"Application Kit 2 Handle":"ez-methylation-magprep-beads",
		"Application Kit 2 Numbers":"D4100-5-4,D4100-5-8,D4100-5-16",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Buffy Coat@Human?High-Molecular Weight@DNA?Chromatin Analysis@NGS": {
		"Application Kit Handle":"zymo-seq-atac-library-kit",
		"Application Kit Numbers":"D5458",
	},
	"Buffy Coat@Human?High-Molecular Weight@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-hmw-magbead-kit",
		"Extraction/Purification Numbers":"D6060",
	},
	"Buffy Coat@Human?High-Molecular Weight@DNA?DNA Methylation@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-hmw-magbead-kit",
		"Extraction/Purification Numbers":"D6060",
		"Application Kit Handle":"zymotaq-premix,zymotaq-dna-polymerase,zymotaq-qpcr-premix",
		"Application Kit Numbers":"E2003,E2004,E2001,E2002,E2054,E2055",
		"Application Kit 2 Handle":"ez-dna-methylation-lightning-automation-kit",
		"Application Kit 2 Numbers":"D5049",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Buffy Coat@Human?High-Molecular Weight@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-hmw-magbead-kit",
		"Extraction/Purification Numbers":"D6060",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Buffy Coat@Human?High-Molecular Weight@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Buffy Coat@Human?Microbial@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Buffy Coat@Human?Microbial@DNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Buffy Coat@Human?Microbial@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Buffy Coat@Human?Microbial@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Buffy Coat@Human?Microbial@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Buffy Coat@Human?Pathogen@DNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Buffy Coat@Human?Pathogen@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
	},
	"Buffy Coat@Human?Pathogen@DNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Buffy Coat@Human?Pathogen@DNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Buffy Coat@Human?Pathogen@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Buffy Coat@Human?Pathogen@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Buffy Coat@Human?Pathogen@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Buffy Coat@Human?Total@DNA?DNA Methylation@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
		"Application Kit Handle":"zymo-seq-wgbs-library-kit,zymo-seq-rrbs-library-kit,pico-methyl-seq-library-prep-kit",
		"Application Kit Numbers":"D5465,D5460,D5461,D5455,D5456",
		"Application Kit 2 Handle":"ez-methylation-magprep-beads",
		"Application Kit 2 Numbers":"D4100-5-4,D4100-5-8,D4100-5-16",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Buffy Coat@Human?Total@DNA?Chromatin Analysis@NGS": {
		"Application Kit Handle":"zymo-seq-atac-library-kit",
		"Application Kit Numbers":"D5458",
	},
	"Buffy Coat@Human?Total@DNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
	},
	"Buffy Coat@Human?Total@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
	},
	"Buffy Coat@Human?Total@DNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Buffy Coat@Human?Total@DNA?DNA Methylation@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
		"Application Kit Handle":"zymotaq-premix,zymotaq-dna-polymerase,zymotaq-qpcr-premix",
		"Application Kit Numbers":"E2003,E2004,E2001,E2002,E2054,E2055",
		"Application Kit 2 Handle":"ez-dna-methylation-lightning-automation-kit",
		"Application Kit 2 Numbers":"D5049",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Buffy Coat@Human?Total@DNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Buffy Coat@Human?Total@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Buffy Coat@Human?Total@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Buffy Coat@Human?Total@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Buffy Coat@Human?Viral@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
	},
	"Buffy Coat@Human?Viral@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Buffy Coat@Human?Viral@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Buffy Coat@Human?Microbial@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Buffy Coat@Human?Microbial@RNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Buffy Coat@Human?Microbial@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Buffy Coat@Human?Microbial@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Buffy Coat@Human?Microbial@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Buffy Coat@Human?micro-RNA@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Buffy Coat@Human?micro-RNA@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Buffy Coat@Human?Pathogen@RNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Buffy Coat@Human?Pathogen@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Buffy Coat@Human?Pathogen@RNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Buffy Coat@Human?Pathogen@RNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Buffy Coat@Human?Pathogen@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Buffy Coat@Human?Pathogen@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Buffy Coat@Human?Pathogen@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Buffy Coat@Human?Total@RNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Buffy Coat@Human?Total@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Buffy Coat@Human?Total@RNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Buffy Coat@Human?Total@RNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Buffy Coat@Human?Total@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Buffy Coat@Human?Total@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Buffy Coat@Human?Total@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Buffy Coat@Human?Viral@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Buffy Coat@Human?Viral@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Buffy Coat@Human?Viral@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Buffy Coat@Human?Microbial@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410,D6432",
	},
	"Buffy Coat@Human?Microbial@Total Nucleic Acid?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Buffy Coat@Human?Microbial@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Buffy Coat@Human?Microbial@Total Nucleic Acid?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Buffy Coat@Human?Microbial@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Buffy Coat@Human?Pathogen@Total Nucleic Acid?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Buffy Coat@Human?Pathogen@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
	},
	"Buffy Coat@Human?Pathogen@Total Nucleic Acid?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Buffy Coat@Human?Pathogen@Total Nucleic Acid?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Buffy Coat@Human?Pathogen@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Buffy Coat@Human?Pathogen@Total Nucleic Acid?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Buffy Coat@Human?Pathogen@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Buffy Coat@Human?Total@Total Nucleic Acid?DNA Methylation@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymo-seq-wgbs-library-kit,zymo-seq-rrbs-library-kit,pico-methyl-seq-library-prep-kit",
		"Application Kit Numbers":"D5465,D5460,D5461,D5455,D5456",
		"Application Kit 2 Handle":"ez-methylation-magprep-beads",
		"Application Kit 2 Numbers":"D4100-5-4,D4100-5-8,D4100-5-16",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Buffy Coat@Human?Total@Total Nucleic Acid?Chromatin Analysis@NGS": {
		"Application Kit Handle":"zymo-seq-atac-library-kit",
		"Application Kit Numbers":"D5458",
	},
	"Buffy Coat@Human?Total@Total Nucleic Acid?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Buffy Coat@Human?Total@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
	},
	"Buffy Coat@Human?Total@Total Nucleic Acid?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Buffy Coat@Human?Total@Total Nucleic Acid?DNA Methylation@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Application Kit 2 Handle":"ez-dna-methylation-lightning-automation-kit",
		"Application Kit 2 Numbers":"D5049",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Buffy Coat@Human?Total@Total Nucleic Acid?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Buffy Coat@Human?Total@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Buffy Coat@Human?Total@Total Nucleic Acid?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Buffy Coat@Human?Total@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Buffy Coat@Human?Viral@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
	},
	"Buffy Coat@Human?Viral@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Buffy Coat@Human?Viral@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Buffy Coat@Human?Microbial@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410,D6432",
	},
	"Buffy Coat@Human?Microbial@Fractional (DNA & RNA Separate)?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410",
	},
	"Buffy Coat@Human?Microbial@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Buffy Coat@Human?Microbial@Fractional (DNA & RNA Separate)?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Buffy Coat@Human?Microbial@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Buffy Coat@Human?Pathogen@Fractional (DNA & RNA Separate)?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Buffy Coat@Human?Pathogen@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
	},
	"Buffy Coat@Human?Pathogen@Fractional (DNA & RNA Separate)?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410",
	},
	"Buffy Coat@Human?Pathogen@Fractional (DNA & RNA Separate)?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Buffy Coat@Human?Pathogen@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Buffy Coat@Human?Pathogen@Fractional (DNA & RNA Separate)?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Buffy Coat@Human?Pathogen@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Buffy Coat@Human?Viral@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
	},
	"Buffy Coat@Human?Viral@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Buffy Coat@Human?Viral@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Buffy Coat@Human?Total@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
	},
	"Buffy Coat@Human?Total@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Buffy Coat@Human?Total@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Lymphocytes@Human?High-Molecular Weight@DNA?DNA Methylation@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Extraction/Purification Handle":"quick-dna-hmw-magbead-kit",
		"Extraction/Purification Numbers":"D6060",
		"Application Kit Handle":"zymo-seq-wgbs-library-kit,zymo-seq-rrbs-library-kit,pico-methyl-seq-library-prep-kit",
		"Application Kit Numbers":"D5465,D5460,D5461,D5455,D5456",
		"Application Kit 2 Handle":"ez-methylation-magprep-beads",
		"Application Kit 2 Numbers":"D4100-5-4,D4100-5-8,D4100-5-16",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Lymphocytes@Human?High-Molecular Weight@DNA?Chromatin Analysis@NGS": {
		"Application Kit Handle":"zymo-seq-atac-library-kit",
		"Application Kit Numbers":"D5458",
	},
	"Lymphocytes@Human?High-Molecular Weight@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-hmw-magbead-kit",
		"Extraction/Purification Numbers":"D6060",
	},
	"Lymphocytes@Human?High-Molecular Weight@DNA?DNA Methylation@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Extraction/Purification Handle":"quick-dna-hmw-magbead-kit",
		"Extraction/Purification Numbers":"D6060",
		"Application Kit Handle":"zymotaq-premix,zymotaq-dna-polymerase,zymotaq-qpcr-premix",
		"Application Kit Numbers":"E2003,E2004,E2001,E2002,E2054,E2055",
		"Application Kit 2 Handle":"ez-dna-methylation-lightning-automation-kit",
		"Application Kit 2 Numbers":"D5049",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Lymphocytes@Human?High-Molecular Weight@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-hmw-magbead-kit",
		"Extraction/Purification Numbers":"D6060",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Lymphocytes@Human?High-Molecular Weight@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Lymphocytes@Human?Microbial@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Lymphocytes@Human?Microbial@DNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Lymphocytes@Human?Microbial@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Lymphocytes@Human?Microbial@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Lymphocytes@Human?Microbial@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Lymphocytes@Human?Pathogen@DNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Lymphocytes@Human?Pathogen@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
	},
	"Lymphocytes@Human?Pathogen@DNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Lymphocytes@Human?Pathogen@DNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Lymphocytes@Human?Pathogen@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Lymphocytes@Human?Pathogen@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Lymphocytes@Human?Pathogen@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Lymphocytes@Human?Total@DNA?DNA Methylation@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
		"Application Kit Handle":"zymo-seq-wgbs-library-kit,zymo-seq-rrbs-library-kit,pico-methyl-seq-library-prep-kit",
		"Application Kit Numbers":"D5465,D5460,D5461,D5455,D5456",
		"Application Kit 2 Handle":"ez-methylation-magprep-beads",
		"Application Kit 2 Numbers":"D4100-5-4,D4100-5-8,D4100-5-16",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Lymphocytes@Human?Total@DNA?Chromatin Analysis@NGS": {
		"Application Kit Handle":"zymo-seq-atac-library-kit",
		"Application Kit Numbers":"D5458",
	},
	"Lymphocytes@Human?Total@DNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
	},
	"Lymphocytes@Human?Total@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
	},
	"Lymphocytes@Human?Total@DNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Lymphocytes@Human?Total@DNA?DNA Methylation@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
		"Application Kit Handle":"zymotaq-premix,zymotaq-dna-polymerase,zymotaq-qpcr-premix",
		"Application Kit Numbers":"E2003,E2004,E2001,E2002,E2054,E2055",
		"Application Kit 2 Handle":"ez-dna-methylation-lightning-automation-kit",
		"Application Kit 2 Numbers":"D5049",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Lymphocytes@Human?Total@DNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Lymphocytes@Human?Total@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Lymphocytes@Human?Total@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Lymphocytes@Human?Total@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Lymphocytes@Human?Viral@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
	},
	"Lymphocytes@Human?Viral@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Lymphocytes@Human?Viral@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Lymphocytes@Human?Microbial@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Lymphocytes@Human?Microbial@RNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Lymphocytes@Human?Microbial@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Lymphocytes@Human?Microbial@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Lymphocytes@Human?Microbial@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Lymphocytes@Human?micro-RNA@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Lymphocytes@Human?micro-RNA@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Lymphocytes@Human?Pathogen@RNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Lymphocytes@Human?Pathogen@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Lymphocytes@Human?Pathogen@RNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Lymphocytes@Human?Pathogen@RNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Lymphocytes@Human?Pathogen@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Lymphocytes@Human?Pathogen@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Lymphocytes@Human?Pathogen@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Lymphocytes@Human?Total@RNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Lymphocytes@Human?Total@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Lymphocytes@Human?Total@RNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Lymphocytes@Human?Total@RNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Lymphocytes@Human?Total@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Lymphocytes@Human?Total@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Lymphocytes@Human?Total@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Lymphocytes@Human?Viral@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Lymphocytes@Human?Viral@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Lymphocytes@Human?Viral@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Lymphocytes@Human?Microbial@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410,D6432",
	},
	"Lymphocytes@Human?Microbial@Total Nucleic Acid?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Lymphocytes@Human?Microbial@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Lymphocytes@Human?Microbial@Total Nucleic Acid?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Lymphocytes@Human?Microbial@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Lymphocytes@Human?Pathogen@Total Nucleic Acid?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Lymphocytes@Human?Pathogen@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
	},
	"Lymphocytes@Human?Pathogen@Total Nucleic Acid?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Lymphocytes@Human?Pathogen@Total Nucleic Acid?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Lymphocytes@Human?Pathogen@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Lymphocytes@Human?Pathogen@Total Nucleic Acid?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Lymphocytes@Human?Pathogen@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Lymphocytes@Human?Total@Total Nucleic Acid?DNA Methylation@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymo-seq-wgbs-library-kit,zymo-seq-rrbs-library-kit,pico-methyl-seq-library-prep-kit",
		"Application Kit Numbers":"D5465,D5460,D5461,D5455,D5456",
		"Application Kit 2 Handle":"ez-methylation-magprep-beads",
		"Application Kit 2 Numbers":"D4100-5-4,D4100-5-8,D4100-5-16",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Lymphocytes@Human?Total@Total Nucleic Acid?Chromatin Analysis@NGS": {
		"Application Kit Handle":"zymo-seq-atac-library-kit",
		"Application Kit Numbers":"D5458",
	},
	"Lymphocytes@Human?Total@Total Nucleic Acid?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Lymphocytes@Human?Total@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
	},
	"Lymphocytes@Human?Total@Total Nucleic Acid?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Lymphocytes@Human?Total@Total Nucleic Acid?DNA Methylation@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Application Kit 2 Handle":"ez-dna-methylation-lightning-automation-kit",
		"Application Kit 2 Numbers":"D5049",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Lymphocytes@Human?Total@Total Nucleic Acid?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Lymphocytes@Human?Total@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Lymphocytes@Human?Total@Total Nucleic Acid?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Lymphocytes@Human?Total@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Lymphocytes@Human?Viral@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
	},
	"Lymphocytes@Human?Viral@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Lymphocytes@Human?Viral@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Lymphocytes@Human?Microbial@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410,D6432",
	},
	"Lymphocytes@Human?Microbial@Fractional (DNA & RNA Separate)?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410",
	},
	"Lymphocytes@Human?Microbial@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Lymphocytes@Human?Microbial@Fractional (DNA & RNA Separate)?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Lymphocytes@Human?Microbial@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Lymphocytes@Human?Pathogen@Fractional (DNA & RNA Separate)?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Lymphocytes@Human?Pathogen@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
	},
	"Lymphocytes@Human?Pathogen@Fractional (DNA & RNA Separate)?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410",
	},
	"Lymphocytes@Human?Pathogen@Fractional (DNA & RNA Separate)?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Lymphocytes@Human?Pathogen@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Lymphocytes@Human?Pathogen@Fractional (DNA & RNA Separate)?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Lymphocytes@Human?Pathogen@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Lymphocytes@Human?Viral@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
	},
	"Lymphocytes@Human?Viral@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Lymphocytes@Human?Viral@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Lymphocytes@Human?Total@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
	},
	"Lymphocytes@Human?Total@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Lymphocytes@Human?Total@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Human?High-Molecular Weight@DNA?DNA Methylation@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"quick-dna-hmw-magbead-kit",
		"Extraction/Purification Numbers":"D6060",
		"Application Kit Handle":"zymo-seq-wgbs-library-kit,zymo-seq-rrbs-library-kit,pico-methyl-seq-library-prep-kit",
		"Application Kit Numbers":"D5465,D5460,D5461,D5455,D5456",
		"Application Kit 2 Handle":"ez-methylation-magprep-beads",
		"Application Kit 2 Numbers":"D4100-5-4,D4100-5-8,D4100-5-16",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Human?High-Molecular Weight@DNA?Chromatin Analysis@NGS": {
		"Application Kit Handle":"zymo-seq-atac-library-kit",
		"Application Kit Numbers":"D5458",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Human?High-Molecular Weight@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"quick-dna-hmw-magbead-kit",
		"Extraction/Purification Numbers":"D6060",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Human?High-Molecular Weight@DNA?DNA Methylation@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"quick-dna-hmw-magbead-kit",
		"Extraction/Purification Numbers":"D6060",
		"Application Kit Handle":"zymotaq-premix,zymotaq-dna-polymerase,zymotaq-qpcr-premix",
		"Application Kit Numbers":"E2003,E2004,E2001,E2002,E2054,E2055",
		"Application Kit 2 Handle":"ez-dna-methylation-lightning-automation-kit",
		"Application Kit 2 Numbers":"D5049",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Human?High-Molecular Weight@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"quick-dna-hmw-magbead-kit",
		"Extraction/Purification Numbers":"D6060",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Human?High-Molecular Weight@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Human?Microbial@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Human?Microbial@DNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Human?Microbial@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Human?Microbial@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Human?Microbial@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Human?Pathogen@DNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Human?Pathogen@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Human?Pathogen@DNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Human?Pathogen@DNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Human?Pathogen@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Human?Pathogen@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Human?Pathogen@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Human?Total@DNA?DNA Methylation@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
		"Application Kit Handle":"zymo-seq-wgbs-library-kit,zymo-seq-rrbs-library-kit,pico-methyl-seq-library-prep-kit",
		"Application Kit Numbers":"D5465,D5460,D5461,D5455,D5456",
		"Application Kit 2 Handle":"ez-methylation-magprep-beads",
		"Application Kit 2 Numbers":"D4100-5-4,D4100-5-8,D4100-5-16",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Human?Total@DNA?Chromatin Analysis@NGS": {
		"Application Kit Handle":"zymo-seq-atac-library-kit",
		"Application Kit Numbers":"D5458",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Human?Total@DNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Human?Total@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Human?Total@DNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Human?Total@DNA?DNA Methylation@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
		"Application Kit Handle":"zymotaq-premix,zymotaq-dna-polymerase,zymotaq-qpcr-premix",
		"Application Kit Numbers":"E2003,E2004,E2001,E2002,E2054,E2055",
		"Application Kit 2 Handle":"ez-dna-methylation-lightning-automation-kit",
		"Application Kit 2 Numbers":"D5049",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Human?Total@DNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Human?Total@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Human?Total@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Human?Total@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Human?Viral@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Human?Viral@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Human?Viral@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Human?Microbial@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Human?Microbial@RNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Human?Microbial@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Human?Microbial@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Human?Microbial@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Human?micro-RNA@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Human?micro-RNA@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Human?Pathogen@RNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Human?Pathogen@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Human?Pathogen@RNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Human?Pathogen@RNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Human?Pathogen@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Human?Pathogen@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Human?Pathogen@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Human?Total@RNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Human?Total@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Human?Total@RNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Human?Total@RNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Human?Total@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Human?Total@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Human?Total@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Human?Viral@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Human?Viral@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Human?Viral@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Human?Microbial@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410,D6432",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Human?Microbial@Total Nucleic Acid?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Human?Microbial@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Human?Microbial@Total Nucleic Acid?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Human?Microbial@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Human?Pathogen@Total Nucleic Acid?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Human?Pathogen@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Human?Pathogen@Total Nucleic Acid?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Human?Pathogen@Total Nucleic Acid?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Human?Pathogen@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Human?Pathogen@Total Nucleic Acid?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Human?Pathogen@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Human?Total@Total Nucleic Acid?DNA Methylation@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymo-seq-wgbs-library-kit,zymo-seq-rrbs-library-kit,pico-methyl-seq-library-prep-kit",
		"Application Kit Numbers":"D5465,D5460,D5461,D5455,D5456",
		"Application Kit 2 Handle":"ez-methylation-magprep-beads",
		"Application Kit 2 Numbers":"D4100-5-4,D4100-5-8,D4100-5-16",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Human?Total@Total Nucleic Acid?Chromatin Analysis@NGS": {
		"Application Kit Handle":"zymo-seq-atac-library-kit",
		"Application Kit Numbers":"D5458",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Human?Total@Total Nucleic Acid?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Human?Total@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Human?Total@Total Nucleic Acid?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Human?Total@Total Nucleic Acid?DNA Methylation@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Application Kit 2 Handle":"ez-dna-methylation-lightning-automation-kit",
		"Application Kit 2 Numbers":"D5049",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Human?Total@Total Nucleic Acid?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Human?Total@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Human?Total@Total Nucleic Acid?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Human?Total@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Human?Viral@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Human?Viral@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Human?Viral@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Human?Microbial@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410,D6432",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Human?Microbial@Fractional (DNA & RNA Separate)?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Human?Microbial@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Human?Microbial@Fractional (DNA & RNA Separate)?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Human?Microbial@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Human?Pathogen@Fractional (DNA & RNA Separate)?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Human?Pathogen@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Human?Pathogen@Fractional (DNA & RNA Separate)?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Human?Pathogen@Fractional (DNA & RNA Separate)?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Human?Pathogen@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Human?Pathogen@Fractional (DNA & RNA Separate)?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Human?Pathogen@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Human?Viral@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Human?Viral@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Human?Viral@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Human?Total@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Human?Total@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Human?Total@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Plasma@Human?Cell-Free@DNA?DNA Methylation@NGS": {
		"Extraction/Purification Handle":"magicbead-cfdna-isolation-kit",
		"Extraction/Purification Numbers":"D4086",
		"Application Kit Handle":"zymo-seq-cell-free-dna-wgbs-library-kit",
		"Application Kit Numbers":"D5462,D5463",
		"Application Kit 2 Handle":"ez-methylation-magprep-beads",
		"Application Kit 2 Numbers":"D4100-5-4,D4100-5-8,D4100-5-16",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Plasma@Human?Cell-Free@DNA?Fungal Sequencing@NGS": {
		"Extraction/Purification Handle":"magicbead-cfdna-isolation-kit",
		"Extraction/Purification Numbers":"D4086",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Plasma@Human?Cell-Free@DNA?General/Other@NGS": {
		"Extraction/Purification Handle":"magicbead-cfdna-isolation-kit",
		"Extraction/Purification Numbers":"D4086",
		"Application Kit Handle":"zymo-seq-cell-free-dna-wgbs-library-kit",
		"Application Kit Numbers":"D5462,D5463",
	},
	"Plasma@Human?Cell-Free@DNA?Microbial Sequencing@NGS": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"magicbead-cfdna-isolation-kit",
		"Extraction/Purification Numbers":"D4086",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Plasma@Human?Cell-Free@DNA?DNA Methylation@PCR/rt-PCR": {
		"Extraction/Purification Handle":"magicbead-cfdna-isolation-kit",
		"Extraction/Purification Numbers":"D4086",
		"Application Kit Handle":"zymotaq-premix,zymotaq-dna-polymerase,zymotaq-qpcr-premix",
		"Application Kit Numbers":"E2003,E2004,E2001,E2002,E2054,E2055",
		"Application Kit 2 Handle":"ez-dna-methylation-lightning-automation-kit",
		"Application Kit 2 Numbers":"D5049",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Plasma@Human?Cell-Free@DNA?Fungal Sequencing@PCR/rt-PCR": {
		"Extraction/Purification Handle":"magicbead-cfdna-isolation-kit",
		"Extraction/Purification Numbers":"D4086",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Plasma@Human?Cell-Free@DNA?General/Other@PCR/rt-PCR": {
		"Extraction/Purification Handle":"magicbead-cfdna-isolation-kit",
		"Extraction/Purification Numbers":"D4086",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Plasma@Human?Cell-Free@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"magicbead-cfdna-isolation-kit",
		"Extraction/Purification Numbers":"D4086",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Plasma@Human?Cell-Free@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Plasma@Human?Microbial@DNA?General/Other@NGS": {
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Plasma@Human?Microbial@DNA?Microbial Sequencing@NGS": {
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Plasma@Human?Microbial@DNA?General/Other@PCR/rt-PCR": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Plasma@Human?Microbial@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Plasma@Human?Microbial@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Plasma@Human?Pathogen@DNA?Fungal Sequencing@NGS": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Plasma@Human?Pathogen@DNA?General/Other@NGS": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
	},
	"Plasma@Human?Pathogen@DNA?Microbial Sequencing@NGS": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Plasma@Human?Pathogen@DNA?Fungal Sequencing@PCR/rt-PCR": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Plasma@Human?Pathogen@DNA?General/Other@PCR/rt-PCR": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Plasma@Human?Pathogen@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Plasma@Human?Pathogen@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Plasma@Human?Total@DNA?DNA Methylation@NGS": {
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
		"Application Kit Handle":"zymo-seq-wgbs-library-kit,zymo-seq-rrbs-library-kit,pico-methyl-seq-library-prep-kit",
		"Application Kit Numbers":"D5465,D5460,D5461,D5455,D5456",
		"Application Kit 2 Handle":"ez-methylation-magprep-beads",
		"Application Kit 2 Numbers":"D4100-5-4,D4100-5-8,D4100-5-16",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Plasma@Human?Total@DNA?Chromatin Analysis@NGS": {
		"Application Kit Handle":"zymo-seq-atac-library-kit",
		"Application Kit Numbers":"D5458",
	},
	"Plasma@Human?Total@DNA?Fungal Sequencing@NGS": {
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
	},
	"Plasma@Human?Total@DNA?General/Other@NGS": {
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
	},
	"Plasma@Human?Total@DNA?Microbial Sequencing@NGS": {
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Plasma@Human?Total@DNA?DNA Methylation@PCR/rt-PCR": {
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
		"Application Kit Handle":"zymotaq-premix,zymotaq-dna-polymerase,zymotaq-qpcr-premix",
		"Application Kit Numbers":"E2003,E2004,E2001,E2002,E2054,E2055",
		"Application Kit 2 Handle":"ez-dna-methylation-lightning-automation-kit",
		"Application Kit 2 Numbers":"D5049",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Plasma@Human?Total@DNA?Fungal Sequencing@PCR/rt-PCR": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Plasma@Human?Total@DNA?General/Other@PCR/rt-PCR": {
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Plasma@Human?Total@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Plasma@Human?Total@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Plasma@Human?Viral@DNA?General/Other@NGS": {
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
	},
	"Plasma@Human?Viral@DNA?General/Other@PCR/rt-PCR": {
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Plasma@Human?Viral@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Plasma@Human?Microbial@RNA?General/Other@NGS": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Plasma@Human?Microbial@RNA?Microbial Sequencing@NGS": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Plasma@Human?Microbial@RNA?General/Other@PCR/rt-PCR": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Plasma@Human?Microbial@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Plasma@Human?Microbial@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Plasma@Human?micro-RNA@RNA?General/Other@NGS": {
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Plasma@Human?micro-RNA@RNA?General/Other@PCR/rt-PCR": {
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Plasma@Human?Pathogen@RNA?Fungal Sequencing@NGS": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Plasma@Human?Pathogen@RNA?General/Other@NGS": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Plasma@Human?Pathogen@RNA?Microbial Sequencing@NGS": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Plasma@Human?Pathogen@RNA?Fungal Sequencing@PCR/rt-PCR": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Plasma@Human?Pathogen@RNA?General/Other@PCR/rt-PCR": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Plasma@Human?Pathogen@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Plasma@Human?Pathogen@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Plasma@Human?Total@RNA?Fungal Sequencing@NGS": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Plasma@Human?Total@RNA?General/Other@NGS": {
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Plasma@Human?Total@RNA?Microbial Sequencing@NGS": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Plasma@Human?Total@RNA?Fungal Sequencing@PCR/rt-PCR": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Plasma@Human?Total@RNA?General/Other@PCR/rt-PCR": {
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Plasma@Human?Total@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Plasma@Human?Total@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Plasma@Human?Viral@RNA?General/Other@NGS": {
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Plasma@Human?Viral@RNA?General/Other@PCR/rt-PCR": {
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Plasma@Human?Viral@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Plasma@Human?Microbial@Total Nucleic Acid?General/Other@NGS": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410,D6432",
	},
	"Plasma@Human?Microbial@Total Nucleic Acid?Microbial Sequencing@NGS": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Plasma@Human?Microbial@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Plasma@Human?Microbial@Total Nucleic Acid?Microbial Sequencing@PCR/rt-PCR": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Plasma@Human?Microbial@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Plasma@Human?Pathogen@Total Nucleic Acid?Fungal Sequencing@NGS": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Plasma@Human?Pathogen@Total Nucleic Acid?General/Other@NGS": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
	},
	"Plasma@Human?Pathogen@Total Nucleic Acid?Microbial Sequencing@NGS": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Plasma@Human?Pathogen@Total Nucleic Acid?Fungal Sequencing@PCR/rt-PCR": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Plasma@Human?Pathogen@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Plasma@Human?Pathogen@Total Nucleic Acid?Microbial Sequencing@PCR/rt-PCR": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Plasma@Human?Pathogen@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Plasma@Human?Total@Total Nucleic Acid?DNA Methylation@NGS": {
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymo-seq-wgbs-library-kit,zymo-seq-rrbs-library-kit,pico-methyl-seq-library-prep-kit",
		"Application Kit Numbers":"D5465,D5460,D5461,D5455,D5456",
		"Application Kit 2 Handle":"ez-methylation-magprep-beads",
		"Application Kit 2 Numbers":"D4100-5-4,D4100-5-8,D4100-5-16",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Plasma@Human?Total@Total Nucleic Acid?Chromatin Analysis@NGS": {
		"Application Kit Handle":"zymo-seq-atac-library-kit",
		"Application Kit Numbers":"D5458",
	},
	"Plasma@Human?Total@Total Nucleic Acid?Fungal Sequencing@NGS": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Plasma@Human?Total@Total Nucleic Acid?General/Other@NGS": {
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
	},
	"Plasma@Human?Total@Total Nucleic Acid?Microbial Sequencing@NGS": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Plasma@Human?Total@Total Nucleic Acid?DNA Methylation@PCR/rt-PCR": {
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Application Kit 2 Handle":"ez-dna-methylation-lightning-automation-kit",
		"Application Kit 2 Numbers":"D5049",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Plasma@Human?Total@Total Nucleic Acid?Fungal Sequencing@PCR/rt-PCR": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Plasma@Human?Total@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Plasma@Human?Total@Total Nucleic Acid?Microbial Sequencing@PCR/rt-PCR": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Plasma@Human?Total@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Plasma@Human?Viral@Total Nucleic Acid?General/Other@NGS": {
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
	},
	"Plasma@Human?Viral@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Plasma@Human?Viral@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Plasma@Human?Microbial@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410,D6432",
	},
	"Plasma@Human?Microbial@Fractional (DNA & RNA Separate)?Microbial Sequencing@NGS": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410",
	},
	"Plasma@Human?Microbial@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Plasma@Human?Microbial@Fractional (DNA & RNA Separate)?Microbial Sequencing@PCR/rt-PCR": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Plasma@Human?Microbial@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Plasma@Human?Pathogen@Fractional (DNA & RNA Separate)?Fungal Sequencing@NGS": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Plasma@Human?Pathogen@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
	},
	"Plasma@Human?Pathogen@Fractional (DNA & RNA Separate)?Microbial Sequencing@NGS": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410",
	},
	"Plasma@Human?Pathogen@Fractional (DNA & RNA Separate)?Fungal Sequencing@PCR/rt-PCR": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Plasma@Human?Pathogen@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Plasma@Human?Pathogen@Fractional (DNA & RNA Separate)?Microbial Sequencing@PCR/rt-PCR": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Plasma@Human?Pathogen@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Plasma@Human?Viral@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
	},
	"Plasma@Human?Viral@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Plasma@Human?Viral@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Serum@Human?Cell-Free@DNA?DNA Methylation@NGS": {
		"Extraction/Purification Handle":"magicbead-cfdna-isolation-kit",
		"Extraction/Purification Numbers":"D4086",
		"Application Kit Handle":"zymo-seq-cell-free-dna-wgbs-library-kit",
		"Application Kit Numbers":"D5462,D5463",
		"Application Kit 2 Handle":"ez-methylation-magprep-beads",
		"Application Kit 2 Numbers":"D4100-5-4,D4100-5-8,D4100-5-16",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Serum@Human?Cell-Free@DNA?Fungal Sequencing@NGS": {
		"Extraction/Purification Handle":"magicbead-cfdna-isolation-kit",
		"Extraction/Purification Numbers":"D4086",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Serum@Human?Cell-Free@DNA?General/Other@NGS": {
		"Extraction/Purification Handle":"magicbead-cfdna-isolation-kit",
		"Extraction/Purification Numbers":"D4086",
		"Application Kit Handle":"zymo-seq-cell-free-dna-wgbs-library-kit",
		"Application Kit Numbers":"D5462,D5463",
	},
	"Serum@Human?Cell-Free@DNA?Microbial Sequencing@NGS": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"magicbead-cfdna-isolation-kit",
		"Extraction/Purification Numbers":"D4086",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Serum@Human?Cell-Free@DNA?DNA Methylation@PCR/rt-PCR": {
		"Extraction/Purification Handle":"magicbead-cfdna-isolation-kit",
		"Extraction/Purification Numbers":"D4086",
		"Application Kit Handle":"zymotaq-premix,zymotaq-dna-polymerase,zymotaq-qpcr-premix",
		"Application Kit Numbers":"E2003,E2004,E2001,E2002,E2054,E2055",
		"Application Kit 2 Handle":"ez-dna-methylation-lightning-automation-kit",
		"Application Kit 2 Numbers":"D5049",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Serum@Human?Cell-Free@DNA?Fungal Sequencing@PCR/rt-PCR": {
		"Extraction/Purification Handle":"magicbead-cfdna-isolation-kit",
		"Extraction/Purification Numbers":"D4086",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Serum@Human?Cell-Free@DNA?General/Other@PCR/rt-PCR": {
		"Extraction/Purification Handle":"magicbead-cfdna-isolation-kit",
		"Extraction/Purification Numbers":"D4086",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Serum@Human?Cell-Free@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"magicbead-cfdna-isolation-kit",
		"Extraction/Purification Numbers":"D4086",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Serum@Human?Cell-Free@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Serum@Human?Microbial@DNA?General/Other@NGS": {
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Serum@Human?Microbial@DNA?Microbial Sequencing@NGS": {
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Serum@Human?Microbial@DNA?General/Other@PCR/rt-PCR": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Serum@Human?Microbial@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Serum@Human?Microbial@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Serum@Human?Pathogen@DNA?Fungal Sequencing@NGS": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Serum@Human?Pathogen@DNA?General/Other@NGS": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
	},
	"Serum@Human?Pathogen@DNA?Microbial Sequencing@NGS": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Serum@Human?Pathogen@DNA?Fungal Sequencing@PCR/rt-PCR": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Serum@Human?Pathogen@DNA?General/Other@PCR/rt-PCR": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Serum@Human?Pathogen@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Serum@Human?Pathogen@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Serum@Human?Total@DNA?DNA Methylation@NGS": {
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
		"Application Kit Handle":"zymo-seq-wgbs-library-kit,zymo-seq-rrbs-library-kit,pico-methyl-seq-library-prep-kit",
		"Application Kit Numbers":"D5465,D5460,D5461,D5455,D5456",
		"Application Kit 2 Handle":"ez-methylation-magprep-beads",
		"Application Kit 2 Numbers":"D4100-5-4,D4100-5-8,D4100-5-16",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Serum@Human?Total@DNA?Chromatin Analysis@NGS": {
		"Application Kit Handle":"zymo-seq-atac-library-kit",
		"Application Kit Numbers":"D5458",
	},
	"Serum@Human?Total@DNA?Fungal Sequencing@NGS": {
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
	},
	"Serum@Human?Total@DNA?General/Other@NGS": {
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
	},
	"Serum@Human?Total@DNA?Microbial Sequencing@NGS": {
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Serum@Human?Total@DNA?DNA Methylation@PCR/rt-PCR": {
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
		"Application Kit Handle":"zymotaq-premix,zymotaq-dna-polymerase,zymotaq-qpcr-premix",
		"Application Kit Numbers":"E2003,E2004,E2001,E2002,E2054,E2055",
		"Application Kit 2 Handle":"ez-dna-methylation-lightning-automation-kit",
		"Application Kit 2 Numbers":"D5049",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Serum@Human?Total@DNA?Fungal Sequencing@PCR/rt-PCR": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Serum@Human?Total@DNA?General/Other@PCR/rt-PCR": {
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Serum@Human?Total@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Serum@Human?Total@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Serum@Human?Viral@DNA?General/Other@NGS": {
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
	},
	"Serum@Human?Viral@DNA?General/Other@PCR/rt-PCR": {
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Serum@Human?Viral@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Serum@Human?Microbial@RNA?General/Other@NGS": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Serum@Human?Microbial@RNA?Microbial Sequencing@NGS": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Serum@Human?Microbial@RNA?General/Other@PCR/rt-PCR": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Serum@Human?Microbial@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Serum@Human?Microbial@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Serum@Human?micro-RNA@RNA?General/Other@NGS": {
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Serum@Human?micro-RNA@RNA?General/Other@PCR/rt-PCR": {
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Serum@Human?Pathogen@RNA?Fungal Sequencing@NGS": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Serum@Human?Pathogen@RNA?General/Other@NGS": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Serum@Human?Pathogen@RNA?Microbial Sequencing@NGS": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Serum@Human?Pathogen@RNA?Fungal Sequencing@PCR/rt-PCR": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Serum@Human?Pathogen@RNA?General/Other@PCR/rt-PCR": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Serum@Human?Pathogen@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Serum@Human?Pathogen@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Serum@Human?Total@RNA?Fungal Sequencing@NGS": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Serum@Human?Total@RNA?General/Other@NGS": {
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Serum@Human?Total@RNA?Microbial Sequencing@NGS": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Serum@Human?Total@RNA?Fungal Sequencing@PCR/rt-PCR": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Serum@Human?Total@RNA?General/Other@PCR/rt-PCR": {
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Serum@Human?Total@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Serum@Human?Total@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Serum@Human?Viral@RNA?General/Other@NGS": {
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Serum@Human?Viral@RNA?General/Other@PCR/rt-PCR": {
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Serum@Human?Viral@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Serum@Human?Microbial@Total Nucleic Acid?General/Other@NGS": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410,D6432",
	},
	"Serum@Human?Microbial@Total Nucleic Acid?Microbial Sequencing@NGS": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Serum@Human?Microbial@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Serum@Human?Microbial@Total Nucleic Acid?Microbial Sequencing@PCR/rt-PCR": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Serum@Human?Microbial@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Serum@Human?Pathogen@Total Nucleic Acid?Fungal Sequencing@NGS": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Serum@Human?Pathogen@Total Nucleic Acid?General/Other@NGS": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
	},
	"Serum@Human?Pathogen@Total Nucleic Acid?Microbial Sequencing@NGS": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Serum@Human?Pathogen@Total Nucleic Acid?Fungal Sequencing@PCR/rt-PCR": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Serum@Human?Pathogen@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Serum@Human?Pathogen@Total Nucleic Acid?Microbial Sequencing@PCR/rt-PCR": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Serum@Human?Pathogen@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Serum@Human?Total@Total Nucleic Acid?DNA Methylation@NGS": {
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymo-seq-wgbs-library-kit,zymo-seq-rrbs-library-kit,pico-methyl-seq-library-prep-kit",
		"Application Kit Numbers":"D5465,D5460,D5461,D5455,D5456",
		"Application Kit 2 Handle":"ez-methylation-magprep-beads",
		"Application Kit 2 Numbers":"D4100-5-4,D4100-5-8,D4100-5-16",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Serum@Human?Total@Total Nucleic Acid?Chromatin Analysis@NGS": {
		"Application Kit Handle":"zymo-seq-atac-library-kit",
		"Application Kit Numbers":"D5458",
	},
	"Serum@Human?Total@Total Nucleic Acid?Fungal Sequencing@NGS": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Serum@Human?Total@Total Nucleic Acid?General/Other@NGS": {
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
	},
	"Serum@Human?Total@Total Nucleic Acid?Microbial Sequencing@NGS": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Serum@Human?Total@Total Nucleic Acid?DNA Methylation@PCR/rt-PCR": {
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Application Kit 2 Handle":"ez-dna-methylation-lightning-automation-kit",
		"Application Kit 2 Numbers":"D5049",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Serum@Human?Total@Total Nucleic Acid?Fungal Sequencing@PCR/rt-PCR": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Serum@Human?Total@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Serum@Human?Total@Total Nucleic Acid?Microbial Sequencing@PCR/rt-PCR": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Serum@Human?Total@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Serum@Human?Viral@Total Nucleic Acid?General/Other@NGS": {
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
	},
	"Serum@Human?Viral@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Serum@Human?Viral@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Serum@Human?Microbial@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410,D6432",
	},
	"Serum@Human?Microbial@Fractional (DNA & RNA Separate)?Microbial Sequencing@NGS": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410",
	},
	"Serum@Human?Microbial@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Serum@Human?Microbial@Fractional (DNA & RNA Separate)?Microbial Sequencing@PCR/rt-PCR": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Serum@Human?Microbial@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Serum@Human?Pathogen@Fractional (DNA & RNA Separate)?Fungal Sequencing@NGS": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Serum@Human?Pathogen@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
	},
	"Serum@Human?Pathogen@Fractional (DNA & RNA Separate)?Microbial Sequencing@NGS": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410",
	},
	"Serum@Human?Pathogen@Fractional (DNA & RNA Separate)?Fungal Sequencing@PCR/rt-PCR": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Serum@Human?Pathogen@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Serum@Human?Pathogen@Fractional (DNA & RNA Separate)?Microbial Sequencing@PCR/rt-PCR": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Serum@Human?Pathogen@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Serum@Human?Viral@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
	},
	"Serum@Human?Viral@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Serum@Human?Viral@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Serum@Human?Total@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
	},
	"Serum@Human?Total@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Serum@Human?Total@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Milk@Human?Cell-Free@DNA?DNA Methylation@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Extraction/Purification Handle":"magicbead-cfdna-isolation-kit",
		"Extraction/Purification Numbers":"D4086",
		"Application Kit Handle":"zymo-seq-cell-free-dna-wgbs-library-kit",
		"Application Kit Numbers":"D5462,D5463",
		"Application Kit 2 Handle":"ez-methylation-magprep-beads",
		"Application Kit 2 Numbers":"D4100-5-4,D4100-5-8,D4100-5-16",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Milk@Human?Cell-Free@DNA?Fungal Sequencing@NGS": {
		"Extraction/Purification Handle":"magicbead-cfdna-isolation-kit",
		"Extraction/Purification Numbers":"D4086",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Milk@Human?Cell-Free@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"magicbead-cfdna-isolation-kit",
		"Extraction/Purification Numbers":"D4086",
		"Application Kit Handle":"zymo-seq-cell-free-dna-wgbs-library-kit",
		"Application Kit Numbers":"D5462,D5463",
	},
	"Milk@Human?Cell-Free@DNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"magicbead-cfdna-isolation-kit",
		"Extraction/Purification Numbers":"D4086",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Milk@Human?Cell-Free@DNA?DNA Methylation@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Extraction/Purification Handle":"magicbead-cfdna-isolation-kit",
		"Extraction/Purification Numbers":"D4086",
		"Application Kit Handle":"zymotaq-premix,zymotaq-dna-polymerase,zymotaq-qpcr-premix",
		"Application Kit Numbers":"E2003,E2004,E2001,E2002,E2054,E2055",
		"Application Kit 2 Handle":"ez-dna-methylation-lightning-automation-kit",
		"Application Kit 2 Numbers":"D5049",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Milk@Human?Cell-Free@DNA?Fungal Sequencing@PCR/rt-PCR": {
		"Extraction/Purification Handle":"magicbead-cfdna-isolation-kit",
		"Extraction/Purification Numbers":"D4086",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Milk@Human?Cell-Free@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"magicbead-cfdna-isolation-kit",
		"Extraction/Purification Numbers":"D4086",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Milk@Human?Cell-Free@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"magicbead-cfdna-isolation-kit",
		"Extraction/Purification Numbers":"D4086",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Milk@Human?Cell-Free@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Milk@Human?Microbial@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Milk@Human?Microbial@DNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Milk@Human?Microbial@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Milk@Human?Microbial@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Milk@Human?Microbial@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Milk@Human?Pathogen@DNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Milk@Human?Pathogen@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
	},
	"Milk@Human?Pathogen@DNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Milk@Human?Pathogen@DNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Milk@Human?Pathogen@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Milk@Human?Pathogen@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Milk@Human?Pathogen@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Milk@Human?Total@DNA?DNA Methylation@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
		"Application Kit Handle":"zymo-seq-wgbs-library-kit,zymo-seq-rrbs-library-kit,pico-methyl-seq-library-prep-kit",
		"Application Kit Numbers":"D5465,D5460,D5461,D5455,D5456",
		"Application Kit 2 Handle":"ez-methylation-magprep-beads",
		"Application Kit 2 Numbers":"D4100-5-4,D4100-5-8,D4100-5-16",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Milk@Human?Total@DNA?Chromatin Analysis@NGS": {
		"Application Kit Handle":"zymo-seq-atac-library-kit",
		"Application Kit Numbers":"D5458",
	},
	"Milk@Human?Total@DNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
	},
	"Milk@Human?Total@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
	},
	"Milk@Human?Total@DNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Milk@Human?Total@DNA?DNA Methylation@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
		"Application Kit Handle":"zymotaq-premix,zymotaq-dna-polymerase,zymotaq-qpcr-premix",
		"Application Kit Numbers":"E2003,E2004,E2001,E2002,E2054,E2055",
		"Application Kit 2 Handle":"ez-dna-methylation-lightning-automation-kit",
		"Application Kit 2 Numbers":"D5049",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Milk@Human?Total@DNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Milk@Human?Total@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Milk@Human?Total@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Milk@Human?Total@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Milk@Human?Viral@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
	},
	"Milk@Human?Viral@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Milk@Human?Viral@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Milk@Human?Microbial@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Milk@Human?Microbial@RNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Milk@Human?Microbial@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Milk@Human?Microbial@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Milk@Human?Microbial@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Milk@Human?micro-RNA@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Milk@Human?micro-RNA@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Milk@Human?Pathogen@RNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Milk@Human?Pathogen@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Milk@Human?Pathogen@RNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Milk@Human?Pathogen@RNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Milk@Human?Pathogen@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Milk@Human?Pathogen@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Milk@Human?Pathogen@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Milk@Human?Total@RNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Milk@Human?Total@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Milk@Human?Total@RNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Milk@Human?Total@RNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Milk@Human?Total@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Milk@Human?Total@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Milk@Human?Total@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Milk@Human?Viral@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Milk@Human?Viral@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Milk@Human?Viral@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Milk@Human?Microbial@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410,D6432",
	},
	"Milk@Human?Microbial@Total Nucleic Acid?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Milk@Human?Microbial@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Milk@Human?Microbial@Total Nucleic Acid?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Milk@Human?Microbial@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Milk@Human?Pathogen@Total Nucleic Acid?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Milk@Human?Pathogen@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
	},
	"Milk@Human?Pathogen@Total Nucleic Acid?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Milk@Human?Pathogen@Total Nucleic Acid?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Milk@Human?Pathogen@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Milk@Human?Pathogen@Total Nucleic Acid?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Milk@Human?Pathogen@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Milk@Human?Total@Total Nucleic Acid?DNA Methylation@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymo-seq-wgbs-library-kit,zymo-seq-rrbs-library-kit,pico-methyl-seq-library-prep-kit",
		"Application Kit Numbers":"D5465,D5460,D5461,D5455,D5456",
		"Application Kit 2 Handle":"ez-methylation-magprep-beads",
		"Application Kit 2 Numbers":"D4100-5-4,D4100-5-8,D4100-5-16",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Milk@Human?Total@Total Nucleic Acid?Chromatin Analysis@NGS": {
		"Application Kit Handle":"zymo-seq-atac-library-kit",
		"Application Kit Numbers":"D5458",
	},
	"Milk@Human?Total@Total Nucleic Acid?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Milk@Human?Total@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
	},
	"Milk@Human?Total@Total Nucleic Acid?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Milk@Human?Total@Total Nucleic Acid?DNA Methylation@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Application Kit 2 Handle":"ez-dna-methylation-lightning-automation-kit",
		"Application Kit 2 Numbers":"D5049",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Milk@Human?Total@Total Nucleic Acid?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Milk@Human?Total@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Milk@Human?Total@Total Nucleic Acid?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Milk@Human?Total@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Milk@Human?Viral@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
	},
	"Milk@Human?Viral@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Milk@Human?Viral@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Milk@Human?Microbial@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410,D6432",
	},
	"Milk@Human?Microbial@Fractional (DNA & RNA Separate)?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410",
	},
	"Milk@Human?Microbial@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Milk@Human?Microbial@Fractional (DNA & RNA Separate)?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Milk@Human?Microbial@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Milk@Human?Pathogen@Fractional (DNA & RNA Separate)?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Milk@Human?Pathogen@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
	},
	"Milk@Human?Pathogen@Fractional (DNA & RNA Separate)?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410",
	},
	"Milk@Human?Pathogen@Fractional (DNA & RNA Separate)?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Milk@Human?Pathogen@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Milk@Human?Pathogen@Fractional (DNA & RNA Separate)?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Milk@Human?Pathogen@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Milk@Human?Viral@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
	},
	"Milk@Human?Viral@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Milk@Human?Viral@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Milk@Human?Total@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
	},
	"Milk@Human?Total@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Milk@Human?Total@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"FFPE@Animal?Microbial@DNA?Fungal Sequencing@NGS": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep 2 Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"FFPE@Animal?Microbial@DNA?Microbial Sequencing@NGS": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep 2 Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"FFPE@Animal?Microbial@DNA?General/Other@NGS": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep 2 Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"FFPE@Animal?Microbial@DNA?Fungal Sequencing@PCR/rt-PCR": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep 2 Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"FFPE@Animal?Microbial@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep 2 Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"FFPE@Animal?Microbial@DNA?General/Other@PCR/rt-PCR": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep 2 Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"FFPE@Animal?Microbial@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"FFPE@Animal?Pathogen@DNA?Fungal Sequencing@NGS": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep 2 Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"FFPE@Animal?Pathogen@DNA?Microbial Sequencing@NGS": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep 2 Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"FFPE@Animal?Pathogen@DNA?General/Other@NGS": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep 2 Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"FFPE@Animal?Pathogen@DNA?Fungal Sequencing@PCR/rt-PCR": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep 2 Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"FFPE@Animal?Pathogen@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep 2 Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"FFPE@Animal?Pathogen@DNA?General/Other@PCR/rt-PCR": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep 2 Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"FFPE@Animal?Pathogen@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"FFPE@Animal?Total@DNA?DNA Methylation@NGS": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"2x-digestion-buffer",
		"Sample Prep 2 Numbers":"D3050-1-20",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymo-seq-wgbs-library-kit,zymo-seq-rrbs-library-kit,pico-methyl-seq-library-prep-kit",
		"Application Kit Numbers":"D5465,D5460,D5461,D5455,D5456",
		"Application Kit 2 Handle":"ez-methylation-magprep-beads",
		"Application Kit 2 Numbers":"D4100-5-4,D4100-5-8,D4100-5-16",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"FFPE@Animal?Total@DNA?Chromatin Analysis@NGS": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"2x-digestion-buffer",
		"Sample Prep 2 Numbers":"D3050-1-20",
		"Application Kit Handle":"zymo-seq-atac-library-kit",
		"Application Kit Numbers":"D5458",
	},
	"FFPE@Animal?Total@DNA?General/Other@NGS": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"2x-digestion-buffer",
		"Sample Prep 2 Numbers":"D3050-1-20",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
	},
	"FFPE@Animal?Total@DNA?DNA Methylation@PCR/rt-PCR": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"2x-digestion-buffer",
		"Sample Prep 2 Numbers":"D3050-1-20",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymotaq-dna-polymerase,zymotaq-qpcr-premix",
		"Application Kit Numbers":"E2003,E2004,E2001,E2002,E2054,E2055",
		"Application Kit 2 Handle":"ez-dna-methylation-lightning-automation-kit",
		"Application Kit 2 Numbers":"D5049",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"FFPE@Animal?Total@DNA?General/Other@PCR/rt-PCR": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"2x-digestion-buffer",
		"Sample Prep 2 Numbers":"D3050-1-20",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"FFPE@Animal?Total@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"FFPE@Animal?Viral@DNA?General/Other@NGS": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"2x-digestion-buffer",
		"Sample Prep 2 Numbers":"D3050-1-20",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
	},
	"FFPE@Animal?Viral@DNA?General/Other@PCR/rt-PCR": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"2x-digestion-buffer",
		"Sample Prep 2 Numbers":"D3050-1-20",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"FFPE@Animal?Viral@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"FFPE@Animal?Microbial@RNA?Fungal Sequencing@NGS": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep 2 Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"FFPE@Animal?Microbial@RNA?General/Other@NGS": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep 2 Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"FFPE@Animal?Microbial@RNA?Microbial Sequencing@NGS": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep 2 Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"FFPE@Animal?Microbial@RNA?Fungal Sequencing@PCR/rt-PCR": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep 2 Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"FFPE@Animal?Microbial@RNA?General/Other@PCR/rt-PCR": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep 2 Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"FFPE@Animal?Microbial@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep 2 Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"FFPE@Animal?Microbial@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"FFPE@Animal?micro-RNA@RNA?General/Other@NGS": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"2x-digestion-buffer",
		"Sample Prep 2 Numbers":"D3050-1-20",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"FFPE@Animal?micro-RNA@RNA?General/Other@PCR/rt-PCR": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"2x-digestion-buffer",
		"Sample Prep 2 Numbers":"D3050-1-20",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"FFPE@Animal?micro-RNA@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"FFPE@Animal?Pathogen@RNA?Fungal Sequencing@NGS": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep 2 Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"FFPE@Animal?Pathogen@RNA?Microbial Sequencing@NGS": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep 2 Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"FFPE@Animal?Pathogen@RNA?General/Other@NGS": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep 2 Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"FFPE@Animal?Pathogen@RNA?Fungal Sequencing@PCR/rt-PCR": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep 2 Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"FFPE@Animal?Pathogen@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep 2 Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"FFPE@Animal?Pathogen@RNA?General/Other@PCR/rt-PCR": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep 2 Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"FFPE@Animal?Pathogen@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"FFPE@Animal?Total@RNA?General/Other@NGS": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"2x-digestion-buffer",
		"Sample Prep 2 Numbers":"D3050-1-20",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"FFPE@Animal?Total@RNA?General/Other@PCR/rt-PCR": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"2x-digestion-buffer",
		"Sample Prep 2 Numbers":"D3050-1-20",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"FFPE@Animal?Total@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"FFPE@Animal?Viral@RNA?General/Other@NGS": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"2x-digestion-buffer",
		"Sample Prep 2 Numbers":"D3050-1-20",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"FFPE@Animal?Viral@RNA?General/Other@PCR/rt-PCR": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"2x-digestion-buffer",
		"Sample Prep 2 Numbers":"D3050-1-20",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"FFPE@Animal?Viral@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"FFPE@Animal?Microbial@Total Nucleic Acid?Fungal Sequencing@NGS": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep 2 Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"FFPE@Animal?Microbial@Total Nucleic Acid?Microbial Sequencing@NGS": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep 2 Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"FFPE@Animal?Microbial@Total Nucleic Acid?General/Other@NGS": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep 2 Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410,D6432",
	},
	"FFPE@Animal?Microbial@Total Nucleic Acid?Fungal Sequencing@PCR/rt-PCR": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep 2 Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"FFPE@Animal?Microbial@Total Nucleic Acid?Microbial Sequencing@PCR/rt-PCR": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep 2 Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"FFPE@Animal?Microbial@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep 2 Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"FFPE@Animal?Microbial@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"FFPE@Animal?Pathogen@Total Nucleic Acid?Fungal Sequencing@NGS": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep 2 Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"FFPE@Animal?Pathogen@Total Nucleic Acid?Microbial Sequencing@NGS": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep 2 Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"FFPE@Animal?Pathogen@Total Nucleic Acid?General/Other@NGS": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep 2 Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
	},
	"FFPE@Animal?Pathogen@Total Nucleic Acid?Fungal Sequencing@PCR/rt-PCR": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep 2 Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"FFPE@Animal?Pathogen@Total Nucleic Acid?Microbial Sequencing@PCR/rt-PCR": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep 2 Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"FFPE@Animal?Pathogen@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep 2 Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"FFPE@Animal?Pathogen@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"FFPE@Animal?Total@Total Nucleic Acid?DNA Methylation@NGS": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"2x-digestion-buffer",
		"Sample Prep 2 Numbers":"D3050-1-20",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymo-seq-wgbs-library-kit,zymo-seq-rrbs-library-kit,pico-methyl-seq-library-prep-kit",
		"Application Kit Numbers":"D5465,D5460,D5461,D5455,D5456",
		"Application Kit 2 Handle":"ez-methylation-magprep-beads",
		"Application Kit 2 Numbers":"D4100-5-4,D4100-5-8,D4100-5-16",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"FFPE@Animal?Total@Total Nucleic Acid?Chromatin Analysis@NGS": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"2x-digestion-buffer",
		"Sample Prep 2 Numbers":"D3050-1-20",
		"Application Kit Handle":"zymo-seq-atac-library-kit",
		"Application Kit Numbers":"D5458",
	},
	"FFPE@Animal?Total@Total Nucleic Acid?General/Other@NGS": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"2x-digestion-buffer",
		"Sample Prep 2 Numbers":"D3050-1-20",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
	},
	"FFPE@Animal?Total@Total Nucleic Acid?DNA Methylation@PCR/rt-PCR": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"2x-digestion-buffer",
		"Sample Prep 2 Numbers":"D3050-1-20",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Application Kit 2 Handle":"ez-dna-methylation-lightning-automation-kit",
		"Application Kit 2 Numbers":"D5049",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"FFPE@Animal?Total@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"2x-digestion-buffer",
		"Sample Prep 2 Numbers":"D3050-1-20",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"FFPE@Animal?Total@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"FFPE@Animal?Viral@Total Nucleic Acid?General/Other@NGS": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"2x-digestion-buffer",
		"Sample Prep 2 Numbers":"D3050-1-20",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
	},
	"FFPE@Animal?Viral@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"2x-digestion-buffer",
		"Sample Prep 2 Numbers":"D3050-1-20",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"FFPE@Animal?Viral@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"FFPE@Animal?Microbial@Fractional (DNA & RNA Separate)?Fungal Sequencing@NGS": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep 2 Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"FFPE@Animal?Microbial@Fractional (DNA & RNA Separate)?Microbial Sequencing@NGS": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep 2 Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410",
	},
	"FFPE@Animal?Microbial@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep 2 Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410,D6432",
	},
	"FFPE@Animal?Microbial@Fractional (DNA & RNA Separate)?Fungal Sequencing@PCR/rt-PCR": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep 2 Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"FFPE@Animal?Microbial@Fractional (DNA & RNA Separate)?Microbial Sequencing@PCR/rt-PCR": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep 2 Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"FFPE@Animal?Microbial@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep 2 Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"FFPE@Animal?Microbial@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"FFPE@Animal?Pathogen@Fractional (DNA & RNA Separate)?Fungal Sequencing@NGS": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep 2 Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"FFPE@Animal?Pathogen@Fractional (DNA & RNA Separate)?Microbial Sequencing@NGS": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep 2 Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410",
	},
	"FFPE@Animal?Pathogen@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep 2 Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
	},
	"FFPE@Animal?Pathogen@Fractional (DNA & RNA Separate)?Fungal Sequencing@PCR/rt-PCR": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep 2 Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"FFPE@Animal?Pathogen@Fractional (DNA & RNA Separate)?Microbial Sequencing@PCR/rt-PCR": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep 2 Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"FFPE@Animal?Pathogen@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep 2 Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"FFPE@Animal?Pathogen@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"FFPE@Animal?Total@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"2x-digestion-buffer",
		"Sample Prep 2 Numbers":"D3050-1-20",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
	},
	"FFPE@Animal?Total@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Sample Prep Handle":"deparaffinization-solution",
		"Sample Prep Numbers":"D3067-1-20",
		"Sample Prep 2 Handle":"2x-digestion-buffer",
		"Sample Prep 2 Numbers":"D3050-1-20",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"FFPE@Animal?Total@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Tissue@Animal?High-Molecular Weight@DNA?DNA Methylation@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-hmw-magbead-kit",
		"Extraction/Purification Numbers":"D6060",
		"Application Kit Handle":"zymo-seq-wgbs-library-kit,zymo-seq-rrbs-library-kit,pico-methyl-seq-library-prep-kit",
		"Application Kit Numbers":"D5465,D5460,D5461,D5455,D5456",
		"Application Kit 2 Handle":"ez-methylation-magprep-beads",
		"Application Kit 2 Numbers":"D4100-5-4,D4100-5-8,D4100-5-16",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Tissue@Animal?High-Molecular Weight@DNA?Chromatin Analysis@NGS": {
		"Application Kit Handle":"zymo-seq-atac-library-kit",
		"Application Kit Numbers":"D5458",
	},
	"Tissue@Animal?High-Molecular Weight@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-dna-hmw-magbead-kit",
		"Extraction/Purification Numbers":"D6060",
	},
	"Tissue@Animal?High-Molecular Weight@DNA?DNA Methylation@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-hmw-magbead-kit",
		"Extraction/Purification Numbers":"D6060",
		"Application Kit Handle":"zymotaq-premix,zymotaq-dna-polymerase,zymotaq-qpcr-premix",
		"Application Kit Numbers":"E2003,E2004,E2001,E2002,E2054,E2055",
		"Application Kit 2 Handle":"ez-dna-methylation-lightning-automation-kit",
		"Application Kit 2 Numbers":"D5049",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Tissue@Animal?High-Molecular Weight@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-dna-hmw-magbead-kit",
		"Extraction/Purification Numbers":"D6060",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Tissue@Animal?High-Molecular Weight@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Tissue@Animal?Microbial@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Tissue@Animal?Microbial@DNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Tissue@Animal?Microbial@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Tissue@Animal?Microbial@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Tissue@Animal?Microbial@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Tissue@Animal?Pathogen@DNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Tissue@Animal?Pathogen@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
	},
	"Tissue@Animal?Pathogen@DNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Tissue@Animal?Pathogen@DNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Tissue@Animal?Pathogen@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Tissue@Animal?Pathogen@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Tissue@Animal?Pathogen@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Tissue@Animal?Total@DNA?DNA Methylation@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
		"Application Kit Handle":"zymo-seq-wgbs-library-kit,zymo-seq-rrbs-library-kit,pico-methyl-seq-library-prep-kit",
		"Application Kit Numbers":"D5465,D5460,D5461,D5455,D5456",
		"Application Kit 2 Handle":"ez-methylation-magprep-beads",
		"Application Kit 2 Numbers":"D4100-5-4,D4100-5-8,D4100-5-16",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Tissue@Animal?Total@DNA?Chromatin Analysis@NGS": {
		"Application Kit Handle":"zymo-seq-atac-library-kit",
		"Application Kit Numbers":"D5458",
	},
	"Tissue@Animal?Total@DNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
	},
	"Tissue@Animal?Total@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
	},
	"Tissue@Animal?Total@DNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Tissue@Animal?Total@DNA?DNA Methylation@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
		"Application Kit Handle":"zymotaq-premix,zymotaq-dna-polymerase,zymotaq-qpcr-premix",
		"Application Kit Numbers":"E2003,E2004,E2001,E2002,E2054,E2055",
		"Application Kit 2 Handle":"ez-dna-methylation-lightning-automation-kit",
		"Application Kit 2 Numbers":"D5049",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Tissue@Animal?Total@DNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Tissue@Animal?Total@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Tissue@Animal?Total@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Tissue@Animal?Total@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Tissue@Animal?Viral@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
	},
	"Tissue@Animal?Viral@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Tissue@Animal?Viral@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Tissue@Animal?Microbial@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Tissue@Animal?Microbial@RNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Tissue@Animal?Microbial@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Tissue@Animal?Microbial@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Tissue@Animal?Microbial@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Tissue@Animal?micro-RNA@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Tissue@Animal?micro-RNA@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Tissue@Animal?Pathogen@RNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Tissue@Animal?Pathogen@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Tissue@Animal?Pathogen@RNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Tissue@Animal?Pathogen@RNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Tissue@Animal?Pathogen@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Tissue@Animal?Pathogen@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Tissue@Animal?Pathogen@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Tissue@Animal?Total@RNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Tissue@Animal?Total@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Tissue@Animal?Total@RNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Tissue@Animal?Total@RNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Tissue@Animal?Total@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Tissue@Animal?Total@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Tissue@Animal?Total@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Tissue@Animal?Viral@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Tissue@Animal?Viral@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Tissue@Animal?Viral@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Tissue@Animal?Microbial@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410,D6432",
	},
	"Tissue@Animal?Microbial@Total Nucleic Acid?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Tissue@Animal?Microbial@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Tissue@Animal?Microbial@Total Nucleic Acid?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Tissue@Animal?Microbial@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Tissue@Animal?Pathogen@Total Nucleic Acid?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Tissue@Animal?Pathogen@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
	},
	"Tissue@Animal?Pathogen@Total Nucleic Acid?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Tissue@Animal?Pathogen@Total Nucleic Acid?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Tissue@Animal?Pathogen@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Tissue@Animal?Pathogen@Total Nucleic Acid?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Tissue@Animal?Pathogen@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Tissue@Animal?Total@Total Nucleic Acid?DNA Methylation@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymo-seq-wgbs-library-kit,zymo-seq-rrbs-library-kit,pico-methyl-seq-library-prep-kit",
		"Application Kit Numbers":"D5465,D5460,D5461,D5455,D5456",
		"Application Kit 2 Handle":"ez-methylation-magprep-beads",
		"Application Kit 2 Numbers":"D4100-5-4,D4100-5-8,D4100-5-16",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Tissue@Animal?Total@Total Nucleic Acid?Chromatin Analysis@NGS": {
		"Application Kit Handle":"zymo-seq-atac-library-kit",
		"Application Kit Numbers":"D5458",
	},
	"Tissue@Animal?Total@Total Nucleic Acid?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Tissue@Animal?Total@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
	},
	"Tissue@Animal?Total@Total Nucleic Acid?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Tissue@Animal?Total@Total Nucleic Acid?DNA Methylation@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Application Kit 2 Handle":"ez-dna-methylation-lightning-automation-kit",
		"Application Kit 2 Numbers":"D5049",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Tissue@Animal?Total@Total Nucleic Acid?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Tissue@Animal?Total@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Tissue@Animal?Total@Total Nucleic Acid?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Tissue@Animal?Total@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Tissue@Animal?Viral@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
	},
	"Tissue@Animal?Viral@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Tissue@Animal?Viral@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Tissue@Animal?Microbial@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410,D6432",
	},
	"Tissue@Animal?Microbial@Fractional (DNA & RNA Separate)?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410",
	},
	"Tissue@Animal?Microbial@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Tissue@Animal?Microbial@Fractional (DNA & RNA Separate)?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Tissue@Animal?Microbial@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Tissue@Animal?Pathogen@Fractional (DNA & RNA Separate)?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Tissue@Animal?Pathogen@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
	},
	"Tissue@Animal?Pathogen@Fractional (DNA & RNA Separate)?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410",
	},
	"Tissue@Animal?Pathogen@Fractional (DNA & RNA Separate)?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Tissue@Animal?Pathogen@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Tissue@Animal?Pathogen@Fractional (DNA & RNA Separate)?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Tissue@Animal?Pathogen@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Tissue@Animal?Viral@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
	},
	"Tissue@Animal?Viral@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Tissue@Animal?Viral@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Tissue@Animal?Total@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
	},
	"Tissue@Animal?Total@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Tissue@Animal?Total@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Rodent Tail@Animal?High-Molecular Weight@DNA?DNA Methylation@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-dna-hmw-magbead-kit",
		"Extraction/Purification Numbers":"D6060",
		"Application Kit Handle":"zymo-seq-wgbs-library-kit,zymo-seq-rrbs-library-kit,pico-methyl-seq-library-prep-kit",
		"Application Kit Numbers":"D5465,D5460,D5461,D5455,D5456",
		"Application Kit 2 Handle":"ez-methylation-magprep-beads",
		"Application Kit 2 Numbers":"D4100-5-4,D4100-5-8,D4100-5-16",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Rodent Tail@Animal?High-Molecular Weight@DNA?Chromatin Analysis@NGS": {
		"Application Kit Handle":"zymo-seq-atac-library-kit",
		"Application Kit Numbers":"D5458",
	},
	"Rodent Tail@Animal?High-Molecular Weight@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-dna-hmw-magbead-kit",
		"Extraction/Purification Numbers":"D6060",
	},
	"Rodent Tail@Animal?High-Molecular Weight@DNA?DNA Methylation@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-dna-hmw-magbead-kit",
		"Extraction/Purification Numbers":"D6060",
		"Application Kit Handle":"zymotaq-premix,zymotaq-dna-polymerase,zymotaq-qpcr-premix",
		"Application Kit Numbers":"E2003,E2004,E2001,E2002,E2054,E2055",
		"Application Kit 2 Handle":"ez-dna-methylation-lightning-automation-kit",
		"Application Kit 2 Numbers":"D5049",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Rodent Tail@Animal?High-Molecular Weight@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-dna-hmw-magbead-kit",
		"Extraction/Purification Numbers":"D6060",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Rodent Tail@Animal?High-Molecular Weight@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Rodent Tail@Animal?Microbial@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Rodent Tail@Animal?Microbial@DNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Rodent Tail@Animal?Microbial@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Rodent Tail@Animal?Microbial@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Rodent Tail@Animal?Microbial@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Rodent Tail@Animal?Pathogen@DNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Rodent Tail@Animal?Pathogen@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
	},
	"Rodent Tail@Animal?Pathogen@DNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Rodent Tail@Animal?Pathogen@DNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Rodent Tail@Animal?Pathogen@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Rodent Tail@Animal?Pathogen@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Rodent Tail@Animal?Pathogen@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Rodent Tail@Animal?Total@DNA?DNA Methylation@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
		"Application Kit Handle":"zymo-seq-wgbs-library-kit,zymo-seq-rrbs-library-kit,pico-methyl-seq-library-prep-kit",
		"Application Kit Numbers":"D5465,D5460,D5461,D5455,D5456",
		"Application Kit 2 Handle":"ez-methylation-magprep-beads",
		"Application Kit 2 Numbers":"D4100-5-4,D4100-5-8,D4100-5-16",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Rodent Tail@Animal?Total@DNA?Chromatin Analysis@NGS": {
		"Application Kit Handle":"zymo-seq-atac-library-kit",
		"Application Kit Numbers":"D5458",
	},
	"Rodent Tail@Animal?Total@DNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
	},
	"Rodent Tail@Animal?Total@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
	},
	"Rodent Tail@Animal?Total@DNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Rodent Tail@Animal?Total@DNA?DNA Methylation@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
		"Application Kit Handle":"zymotaq-premix,zymotaq-dna-polymerase,zymotaq-qpcr-premix",
		"Application Kit Numbers":"E2003,E2004,E2001,E2002,E2054,E2055",
		"Application Kit 2 Handle":"ez-dna-methylation-lightning-automation-kit",
		"Application Kit 2 Numbers":"D5049",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Rodent Tail@Animal?Total@DNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Rodent Tail@Animal?Total@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Rodent Tail@Animal?Total@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Rodent Tail@Animal?Total@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Rodent Tail@Animal?Viral@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
	},
	"Rodent Tail@Animal?Viral@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Rodent Tail@Animal?Viral@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Rodent Tail@Animal?Microbial@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Rodent Tail@Animal?Microbial@RNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Rodent Tail@Animal?Microbial@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Rodent Tail@Animal?Microbial@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Rodent Tail@Animal?Microbial@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Rodent Tail@Animal?micro-RNA@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Rodent Tail@Animal?micro-RNA@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Rodent Tail@Animal?Pathogen@RNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Rodent Tail@Animal?Pathogen@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Rodent Tail@Animal?Pathogen@RNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Rodent Tail@Animal?Pathogen@RNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Rodent Tail@Animal?Pathogen@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Rodent Tail@Animal?Pathogen@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Rodent Tail@Animal?Pathogen@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Rodent Tail@Animal?Total@RNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Rodent Tail@Animal?Total@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Rodent Tail@Animal?Total@RNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Rodent Tail@Animal?Total@RNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Rodent Tail@Animal?Total@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Rodent Tail@Animal?Total@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Rodent Tail@Animal?Total@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Rodent Tail@Animal?Viral@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Rodent Tail@Animal?Viral@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Rodent Tail@Animal?Viral@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Rodent Tail@Animal?Microbial@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410,D6432",
	},
	"Rodent Tail@Animal?Microbial@Total Nucleic Acid?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Rodent Tail@Animal?Microbial@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Rodent Tail@Animal?Microbial@Total Nucleic Acid?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Rodent Tail@Animal?Microbial@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Rodent Tail@Animal?Pathogen@Total Nucleic Acid?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Rodent Tail@Animal?Pathogen@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
	},
	"Rodent Tail@Animal?Pathogen@Total Nucleic Acid?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Rodent Tail@Animal?Pathogen@Total Nucleic Acid?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Rodent Tail@Animal?Pathogen@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Rodent Tail@Animal?Pathogen@Total Nucleic Acid?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Rodent Tail@Animal?Pathogen@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Rodent Tail@Animal?Total@Total Nucleic Acid?DNA Methylation@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymo-seq-wgbs-library-kit,zymo-seq-rrbs-library-kit,pico-methyl-seq-library-prep-kit",
		"Application Kit Numbers":"D5465,D5460,D5461,D5455,D5456",
		"Application Kit 2 Handle":"ez-methylation-magprep-beads",
		"Application Kit 2 Numbers":"D4100-5-4,D4100-5-8,D4100-5-16",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Rodent Tail@Animal?Total@Total Nucleic Acid?Chromatin Analysis@NGS": {
		"Application Kit Handle":"zymo-seq-atac-library-kit",
		"Application Kit Numbers":"D5458",
	},
	"Rodent Tail@Animal?Total@Total Nucleic Acid?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Rodent Tail@Animal?Total@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
	},
	"Rodent Tail@Animal?Total@Total Nucleic Acid?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Rodent Tail@Animal?Total@Total Nucleic Acid?DNA Methylation@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Application Kit 2 Handle":"ez-dna-methylation-lightning-automation-kit",
		"Application Kit 2 Numbers":"D5049",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Rodent Tail@Animal?Total@Total Nucleic Acid?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Rodent Tail@Animal?Total@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Rodent Tail@Animal?Total@Total Nucleic Acid?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Rodent Tail@Animal?Total@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Rodent Tail@Animal?Viral@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
	},
	"Rodent Tail@Animal?Viral@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Rodent Tail@Animal?Viral@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Rodent Tail@Animal?Microbial@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410,D6432",
	},
	"Rodent Tail@Animal?Microbial@Fractional (DNA & RNA Separate)?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410",
	},
	"Rodent Tail@Animal?Microbial@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Rodent Tail@Animal?Microbial@Fractional (DNA & RNA Separate)?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Rodent Tail@Animal?Microbial@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Rodent Tail@Animal?Pathogen@Fractional (DNA & RNA Separate)?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Rodent Tail@Animal?Pathogen@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
	},
	"Rodent Tail@Animal?Pathogen@Fractional (DNA & RNA Separate)?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410",
	},
	"Rodent Tail@Animal?Pathogen@Fractional (DNA & RNA Separate)?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Rodent Tail@Animal?Pathogen@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Rodent Tail@Animal?Pathogen@Fractional (DNA & RNA Separate)?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Rodent Tail@Animal?Pathogen@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Rodent Tail@Animal?Viral@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
	},
	"Rodent Tail@Animal?Viral@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Rodent Tail@Animal?Viral@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Rodent Tail@Animal?Total@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
	},
	"Rodent Tail@Animal?Total@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Rodent Tail@Animal?Total@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Insects@Animal?High-Molecular Weight@DNA?DNA Methylation@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-2-0-mm",
		"Sample Prep Numbers":"S6014-50",
		"Extraction/Purification Handle":"quick-dna-hmw-magbead-kit",
		"Extraction/Purification Numbers":"D6060",
		"Application Kit Handle":"zymo-seq-wgbs-library-kit,zymo-seq-rrbs-library-kit,pico-methyl-seq-library-prep-kit",
		"Application Kit Numbers":"D5465,D5460,D5461,D5455,D5456",
		"Application Kit 2 Handle":"ez-methylation-magprep-beads",
		"Application Kit 2 Numbers":"D4100-5-4,D4100-5-8,D4100-5-16",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Insects@Animal?High-Molecular Weight@DNA?Chromatin Analysis@NGS": {
		"Application Kit Handle":"zymo-seq-atac-library-kit",
		"Application Kit Numbers":"D5458",
	},
	"Insects@Animal?High-Molecular Weight@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-2-0-mm",
		"Sample Prep Numbers":"S6014-50",
		"Extraction/Purification Handle":"quick-dna-hmw-magbead-kit",
		"Extraction/Purification Numbers":"D6060",
	},
	"Insects@Animal?High-Molecular Weight@DNA?DNA Methylation@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-2-0-mm",
		"Sample Prep Numbers":"S6014-50",
		"Extraction/Purification Handle":"quick-dna-hmw-magbead-kit",
		"Extraction/Purification Numbers":"D6060",
		"Application Kit Handle":"zymotaq-premix,zymotaq-dna-polymerase,zymotaq-qpcr-premix",
		"Application Kit Numbers":"E2003,E2004,E2001,E2002,E2054,E2055",
		"Application Kit 2 Handle":"ez-dna-methylation-lightning-automation-kit",
		"Application Kit 2 Numbers":"D5049",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Insects@Animal?High-Molecular Weight@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-2-0-mm",
		"Sample Prep Numbers":"S6014-50",
		"Extraction/Purification Handle":"quick-dna-hmw-magbead-kit",
		"Extraction/Purification Numbers":"D6060",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Insects@Animal?High-Molecular Weight@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Insects@Animal?Microbial@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Insects@Animal?Microbial@DNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Insects@Animal?Microbial@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Insects@Animal?Microbial@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Insects@Animal?Microbial@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Insects@Animal?Pathogen@DNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-2-0-mm",
		"Sample Prep Numbers":"S6014-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Insects@Animal?Pathogen@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
	},
	"Insects@Animal?Pathogen@DNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Insects@Animal?Pathogen@DNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-2-0-mm",
		"Sample Prep Numbers":"S6014-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Insects@Animal?Pathogen@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Insects@Animal?Pathogen@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Insects@Animal?Pathogen@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Insects@Animal?Total@DNA?DNA Methylation@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-2-0-mm",
		"Sample Prep Numbers":"S6014-50",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
		"Application Kit Handle":"zymo-seq-wgbs-library-kit,zymo-seq-rrbs-library-kit,pico-methyl-seq-library-prep-kit",
		"Application Kit Numbers":"D5465,D5460,D5461,D5455,D5456",
		"Application Kit 2 Handle":"ez-methylation-magprep-beads",
		"Application Kit 2 Numbers":"D4100-5-4,D4100-5-8,D4100-5-16",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Insects@Animal?Total@DNA?Chromatin Analysis@NGS": {
		"Application Kit Handle":"zymo-seq-atac-library-kit",
		"Application Kit Numbers":"D5458",
	},
	"Insects@Animal?Total@DNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
	},
	"Insects@Animal?Total@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-2-0-mm",
		"Sample Prep Numbers":"S6014-50",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
	},
	"Insects@Animal?Total@DNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Insects@Animal?Total@DNA?DNA Methylation@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-2-0-mm",
		"Sample Prep Numbers":"S6014-50",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
		"Application Kit Handle":"zymotaq-premix,zymotaq-dna-polymerase,zymotaq-qpcr-premix",
		"Application Kit Numbers":"E2003,E2004,E2001,E2002,E2054,E2055",
		"Application Kit 2 Handle":"ez-dna-methylation-lightning-automation-kit",
		"Application Kit 2 Numbers":"D5049",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Insects@Animal?Total@DNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-2-0-mm",
		"Sample Prep Numbers":"S6014-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Insects@Animal?Total@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-2-0-mm",
		"Sample Prep Numbers":"S6014-50",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Insects@Animal?Total@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Insects@Animal?Total@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Insects@Animal?Viral@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-2-0-mm",
		"Sample Prep Numbers":"S6014-50",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
	},
	"Insects@Animal?Viral@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-2-0-mm",
		"Sample Prep Numbers":"S6014-50",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Insects@Animal?Viral@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Insects@Animal?Microbial@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Insects@Animal?Microbial@RNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Insects@Animal?Microbial@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Insects@Animal?Microbial@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Insects@Animal?Microbial@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Insects@Animal?micro-RNA@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-2-0-mm",
		"Sample Prep Numbers":"S6014-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Insects@Animal?micro-RNA@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-2-0-mm",
		"Sample Prep Numbers":"S6014-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Insects@Animal?Pathogen@RNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-2-0-mm",
		"Sample Prep Numbers":"S6014-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Insects@Animal?Pathogen@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Insects@Animal?Pathogen@RNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Insects@Animal?Pathogen@RNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-2-0-mm",
		"Sample Prep Numbers":"S6014-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Insects@Animal?Pathogen@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Insects@Animal?Pathogen@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Insects@Animal?Pathogen@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Insects@Animal?Total@RNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-2-0-mm",
		"Sample Prep Numbers":"S6014-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Insects@Animal?Total@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-2-0-mm",
		"Sample Prep Numbers":"S6014-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Insects@Animal?Total@RNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Insects@Animal?Total@RNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-2-0-mm",
		"Sample Prep Numbers":"S6014-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Insects@Animal?Total@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-2-0-mm",
		"Sample Prep Numbers":"S6014-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Insects@Animal?Total@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Insects@Animal?Total@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Insects@Animal?Viral@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-2-0-mm",
		"Sample Prep Numbers":"S6014-50",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Insects@Animal?Viral@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-2-0-mm",
		"Sample Prep Numbers":"S6014-50",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Insects@Animal?Viral@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Insects@Animal?Microbial@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410,D6432",
	},
	"Insects@Animal?Microbial@Total Nucleic Acid?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Insects@Animal?Microbial@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Insects@Animal?Microbial@Total Nucleic Acid?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Insects@Animal?Microbial@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Insects@Animal?Pathogen@Total Nucleic Acid?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-2-0-mm",
		"Sample Prep Numbers":"S6014-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Insects@Animal?Pathogen@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
	},
	"Insects@Animal?Pathogen@Total Nucleic Acid?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Insects@Animal?Pathogen@Total Nucleic Acid?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-2-0-mm",
		"Sample Prep Numbers":"S6014-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Insects@Animal?Pathogen@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Insects@Animal?Pathogen@Total Nucleic Acid?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Insects@Animal?Pathogen@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Insects@Animal?Total@Total Nucleic Acid?DNA Methylation@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-2-0-mm",
		"Sample Prep Numbers":"S6014-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymo-seq-wgbs-library-kit,zymo-seq-rrbs-library-kit,pico-methyl-seq-library-prep-kit",
		"Application Kit Numbers":"D5465,D5460,D5461,D5455,D5456",
		"Application Kit 2 Handle":"ez-methylation-magprep-beads",
		"Application Kit 2 Numbers":"D4100-5-4,D4100-5-8,D4100-5-16",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Insects@Animal?Total@Total Nucleic Acid?Chromatin Analysis@NGS": {
		"Application Kit Handle":"zymo-seq-atac-library-kit",
		"Application Kit Numbers":"D5458",
	},
	"Insects@Animal?Total@Total Nucleic Acid?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Insects@Animal?Total@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-2-0-mm",
		"Sample Prep Numbers":"S6014-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
	},
	"Insects@Animal?Total@Total Nucleic Acid?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Insects@Animal?Total@Total Nucleic Acid?DNA Methylation@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-2-0-mm",
		"Sample Prep Numbers":"S6014-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Application Kit 2 Handle":"ez-dna-methylation-lightning-automation-kit",
		"Application Kit 2 Numbers":"D5049",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Insects@Animal?Total@Total Nucleic Acid?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Insects@Animal?Total@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-2-0-mm",
		"Sample Prep Numbers":"S6014-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Insects@Animal?Total@Total Nucleic Acid?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Insects@Animal?Total@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Insects@Animal?Viral@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-2-0-mm",
		"Sample Prep Numbers":"S6014-50",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
	},
	"Insects@Animal?Viral@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-2-0-mm",
		"Sample Prep Numbers":"S6014-50",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Insects@Animal?Viral@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Insects@Animal?Microbial@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410,D6432",
	},
	"Insects@Animal?Microbial@Fractional (DNA & RNA Separate)?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410",
	},
	"Insects@Animal?Microbial@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Insects@Animal?Microbial@Fractional (DNA & RNA Separate)?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Insects@Animal?Microbial@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Insects@Animal?Pathogen@Fractional (DNA & RNA Separate)?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-2-0-mm",
		"Sample Prep Numbers":"S6014-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Insects@Animal?Pathogen@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
	},
	"Insects@Animal?Pathogen@Fractional (DNA & RNA Separate)?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410",
	},
	"Insects@Animal?Pathogen@Fractional (DNA & RNA Separate)?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-2-0-mm",
		"Sample Prep Numbers":"S6014-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Insects@Animal?Pathogen@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Insects@Animal?Pathogen@Fractional (DNA & RNA Separate)?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Insects@Animal?Pathogen@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Insects@Animal?Viral@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-2-0-mm",
		"Sample Prep Numbers":"S6014-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
	},
	"Insects@Animal?Viral@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-2-0-mm",
		"Sample Prep Numbers":"S6014-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Insects@Animal?Viral@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Insects@Animal?Total@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-2-0-mm",
		"Sample Prep Numbers":"S6014-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
	},
	"Insects@Animal?Total@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-2-0-mm",
		"Sample Prep Numbers":"S6014-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Insects@Animal?Total@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Saliva@Animal?Cell-Free@DNA?DNA Methylation@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"magicbead-cfdna-isolation-kit",
		"Extraction/Purification Numbers":"D4086",
		"Application Kit Handle":"zymo-seq-cell-free-dna-wgbs-library-kit",
		"Application Kit Numbers":"D5462,D5463",
		"Application Kit 2 Handle":"ez-methylation-magprep-beads",
		"Application Kit 2 Numbers":"D4100-5-4,D4100-5-8,D4100-5-16",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Saliva@Animal?Cell-Free@DNA?Fungal Sequencing@NGS": {
		"Extraction/Purification Handle":"magicbead-cfdna-isolation-kit",
		"Extraction/Purification Numbers":"D4086",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Saliva@Animal?Cell-Free@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"magicbead-cfdna-isolation-kit",
		"Extraction/Purification Numbers":"D4086",
		"Application Kit Handle":"zymo-seq-cell-free-dna-wgbs-library-kit",
		"Application Kit Numbers":"D5462,D5463",
	},
	"Saliva@Animal?Cell-Free@DNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"magicbead-cfdna-isolation-kit",
		"Extraction/Purification Numbers":"D4086",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Saliva@Animal?Cell-Free@DNA?DNA Methylation@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"magicbead-cfdna-isolation-kit",
		"Extraction/Purification Numbers":"D4086",
		"Application Kit Handle":"zymotaq-premix,zymotaq-dna-polymerase,zymotaq-qpcr-premix",
		"Application Kit Numbers":"E2003,E2004,E2001,E2002,E2054,E2055",
		"Application Kit 2 Handle":"ez-dna-methylation-lightning-automation-kit",
		"Application Kit 2 Numbers":"D5049",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Saliva@Animal?Cell-Free@DNA?Fungal Sequencing@PCR/rt-PCR": {
		"Extraction/Purification Handle":"magicbead-cfdna-isolation-kit",
		"Extraction/Purification Numbers":"D4086",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Saliva@Animal?Cell-Free@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"magicbead-cfdna-isolation-kit",
		"Extraction/Purification Numbers":"D4086",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Saliva@Animal?Cell-Free@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"magicbead-cfdna-isolation-kit",
		"Extraction/Purification Numbers":"D4086",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Saliva@Animal?Cell-Free@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Saliva@Animal?Microbial@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Saliva@Animal?Microbial@DNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Saliva@Animal?Microbial@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Saliva@Animal?Microbial@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Saliva@Animal?Microbial@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Saliva@Animal?Pathogen@DNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Saliva@Animal?Pathogen@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
	},
	"Saliva@Animal?Pathogen@DNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Saliva@Animal?Pathogen@DNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Saliva@Animal?Pathogen@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Saliva@Animal?Pathogen@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Saliva@Animal?Pathogen@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Saliva@Animal?Total@DNA?DNA Methylation@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
		"Application Kit Handle":"zymo-seq-wgbs-library-kit,zymo-seq-rrbs-library-kit,pico-methyl-seq-library-prep-kit",
		"Application Kit Numbers":"D5465,D5460,D5461,D5455,D5456",
		"Application Kit 2 Handle":"ez-methylation-magprep-beads",
		"Application Kit 2 Numbers":"D4100-5-4,D4100-5-8,D4100-5-16",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Saliva@Animal?Total@DNA?Chromatin Analysis@NGS": {
		"Application Kit Handle":"zymo-seq-atac-library-kit",
		"Application Kit Numbers":"D5458",
	},
	"Saliva@Animal?Total@DNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
	},
	"Saliva@Animal?Total@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
	},
	"Saliva@Animal?Total@DNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Saliva@Animal?Total@DNA?DNA Methylation@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
		"Application Kit Handle":"zymotaq-premix,zymotaq-dna-polymerase,zymotaq-qpcr-premix",
		"Application Kit Numbers":"E2003,E2004,E2001,E2002,E2054,E2055",
		"Application Kit 2 Handle":"ez-dna-methylation-lightning-automation-kit",
		"Application Kit 2 Numbers":"D5049",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Saliva@Animal?Total@DNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Saliva@Animal?Total@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Saliva@Animal?Total@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Saliva@Animal?Total@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Saliva@Animal?Viral@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
	},
	"Saliva@Animal?Viral@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Saliva@Animal?Viral@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Saliva@Animal?Microbial@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Saliva@Animal?Microbial@RNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Saliva@Animal?Microbial@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Saliva@Animal?Microbial@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Saliva@Animal?Microbial@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Saliva@Animal?micro-RNA@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Saliva@Animal?micro-RNA@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Saliva@Animal?Pathogen@RNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Saliva@Animal?Pathogen@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Saliva@Animal?Pathogen@RNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Saliva@Animal?Pathogen@RNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Saliva@Animal?Pathogen@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Saliva@Animal?Pathogen@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Saliva@Animal?Pathogen@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Saliva@Animal?Total@RNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Saliva@Animal?Total@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Saliva@Animal?Total@RNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Saliva@Animal?Total@RNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Saliva@Animal?Total@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Saliva@Animal?Total@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Saliva@Animal?Total@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Saliva@Animal?Viral@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Saliva@Animal?Viral@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Saliva@Animal?Viral@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Saliva@Animal?Microbial@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410,D6432",
	},
	"Saliva@Animal?Microbial@Total Nucleic Acid?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Saliva@Animal?Microbial@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Saliva@Animal?Microbial@Total Nucleic Acid?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Saliva@Animal?Microbial@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Saliva@Animal?Pathogen@Total Nucleic Acid?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Saliva@Animal?Pathogen@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
	},
	"Saliva@Animal?Pathogen@Total Nucleic Acid?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Saliva@Animal?Pathogen@Total Nucleic Acid?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Saliva@Animal?Pathogen@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Saliva@Animal?Pathogen@Total Nucleic Acid?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Saliva@Animal?Pathogen@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Saliva@Animal?Total@Total Nucleic Acid?DNA Methylation@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymo-seq-wgbs-library-kit,zymo-seq-rrbs-library-kit,pico-methyl-seq-library-prep-kit",
		"Application Kit Numbers":"D5465,D5460,D5461,D5455,D5456",
		"Application Kit 2 Handle":"ez-methylation-magprep-beads",
		"Application Kit 2 Numbers":"D4100-5-4,D4100-5-8,D4100-5-16",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Saliva@Animal?Total@Total Nucleic Acid?Chromatin Analysis@NGS": {
		"Application Kit Handle":"zymo-seq-atac-library-kit",
		"Application Kit Numbers":"D5458",
	},
	"Saliva@Animal?Total@Total Nucleic Acid?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Saliva@Animal?Total@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
	},
	"Saliva@Animal?Total@Total Nucleic Acid?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Saliva@Animal?Total@Total Nucleic Acid?DNA Methylation@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Application Kit 2 Handle":"ez-dna-methylation-lightning-automation-kit",
		"Application Kit 2 Numbers":"D5049",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Saliva@Animal?Total@Total Nucleic Acid?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Saliva@Animal?Total@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Saliva@Animal?Total@Total Nucleic Acid?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Saliva@Animal?Total@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Saliva@Animal?Viral@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
	},
	"Saliva@Animal?Viral@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Saliva@Animal?Viral@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Saliva@Animal?Microbial@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410,D6432",
	},
	"Saliva@Animal?Microbial@Fractional (DNA & RNA Separate)?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410",
	},
	"Saliva@Animal?Microbial@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Saliva@Animal?Microbial@Fractional (DNA & RNA Separate)?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Saliva@Animal?Microbial@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Saliva@Animal?Pathogen@Fractional (DNA & RNA Separate)?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Saliva@Animal?Pathogen@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
	},
	"Saliva@Animal?Pathogen@Fractional (DNA & RNA Separate)?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410",
	},
	"Saliva@Animal?Pathogen@Fractional (DNA & RNA Separate)?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Saliva@Animal?Pathogen@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Saliva@Animal?Pathogen@Fractional (DNA & RNA Separate)?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Saliva@Animal?Pathogen@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Saliva@Animal?Viral@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
	},
	"Saliva@Animal?Viral@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Saliva@Animal?Viral@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Saliva@Animal?Total@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
	},
	"Saliva@Animal?Total@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Saliva@Animal?Total@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Stool@Animal?High-Molecular Weight@DNA?DNA Methylation@NGS": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Extraction/Purification Handle":"quick-dna-hmw-magbead-kit",
		"Extraction/Purification Numbers":"D6060",
		"Application Kit Handle":"zymo-seq-wgbs-library-kit,zymo-seq-rrbs-library-kit,pico-methyl-seq-library-prep-kit",
		"Application Kit Numbers":"D5465,D5460,D5461,D5455,D5456",
		"Application Kit 2 Handle":"ez-methylation-magprep-beads",
		"Application Kit 2 Numbers":"D4100-5-4,D4100-5-8,D4100-5-16",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Stool@Animal?High-Molecular Weight@DNA?Chromatin Analysis@NGS": {
		"Application Kit Handle":"zymo-seq-atac-library-kit",
		"Application Kit Numbers":"D5458",
	},
	"Stool@Animal?High-Molecular Weight@DNA?General/Other@NGS": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-hmw-magbead-kit",
		"Extraction/Purification Numbers":"D6060",
	},
	"Stool@Animal?High-Molecular Weight@DNA?DNA Methylation@PCR/rt-PCR": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Extraction/Purification Handle":"quick-dna-hmw-magbead-kit",
		"Extraction/Purification Numbers":"D6060",
		"Application Kit Handle":"zymotaq-premix,zymotaq-dna-polymerase,zymotaq-qpcr-premix",
		"Application Kit Numbers":"E2003,E2004,E2001,E2002,E2054,E2055",
		"Application Kit 2 Handle":"ez-dna-methylation-lightning-automation-kit",
		"Application Kit 2 Numbers":"D5049",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Stool@Animal?High-Molecular Weight@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-hmw-magbead-kit",
		"Extraction/Purification Numbers":"D6060",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Stool@Animal?High-Molecular Weight@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Stool@Animal?Microbial@DNA?General/Other@NGS": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Stool@Animal?Microbial@DNA?Microbial Sequencing@NGS": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Stool@Animal?Microbial@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Stool@Animal?Microbial@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Stool@Animal?Microbial@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Stool@Animal?Pathogen@DNA?Fungal Sequencing@NGS": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Stool@Animal?Pathogen@DNA?General/Other@NGS": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
	},
	"Stool@Animal?Pathogen@DNA?Microbial Sequencing@NGS": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Stool@Animal?Pathogen@DNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Stool@Animal?Pathogen@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Stool@Animal?Pathogen@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Stool@Animal?Pathogen@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Stool@Animal?Total@DNA?DNA Methylation@NGS": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
		"Application Kit Handle":"zymo-seq-wgbs-library-kit,zymo-seq-rrbs-library-kit,pico-methyl-seq-library-prep-kit",
		"Application Kit Numbers":"D5465,D5460,D5461,D5455,D5456",
		"Application Kit 2 Handle":"ez-methylation-magprep-beads",
		"Application Kit 2 Numbers":"D4100-5-4,D4100-5-8,D4100-5-16",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Stool@Animal?Total@DNA?Chromatin Analysis@NGS": {
		"Application Kit Handle":"zymo-seq-atac-library-kit",
		"Application Kit Numbers":"D5458",
	},
	"Stool@Animal?Total@DNA?Fungal Sequencing@NGS": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
	},
	"Stool@Animal?Total@DNA?General/Other@NGS": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
	},
	"Stool@Animal?Total@DNA?Microbial Sequencing@NGS": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Stool@Animal?Total@DNA?DNA Methylation@PCR/rt-PCR": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
		"Application Kit Handle":"zymotaq-premix,zymotaq-dna-polymerase,zymotaq-qpcr-premix",
		"Application Kit Numbers":"E2003,E2004,E2001,E2002,E2054,E2055",
		"Application Kit 2 Handle":"ez-dna-methylation-lightning-automation-kit",
		"Application Kit 2 Numbers":"D5049",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Stool@Animal?Total@DNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Stool@Animal?Total@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Stool@Animal?Total@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Stool@Animal?Total@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Stool@Animal?Viral@DNA?General/Other@NGS": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
	},
	"Stool@Animal?Viral@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Stool@Animal?Viral@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Stool@Animal?Microbial@RNA?General/Other@NGS": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Stool@Animal?Microbial@RNA?Microbial Sequencing@NGS": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Stool@Animal?Microbial@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Stool@Animal?Microbial@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Stool@Animal?Microbial@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Stool@Animal?micro-RNA@RNA?General/Other@NGS": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Stool@Animal?micro-RNA@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Stool@Animal?Pathogen@RNA?Fungal Sequencing@NGS": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Stool@Animal?Pathogen@RNA?General/Other@NGS": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Stool@Animal?Pathogen@RNA?Microbial Sequencing@NGS": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Stool@Animal?Pathogen@RNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Stool@Animal?Pathogen@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Stool@Animal?Pathogen@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Stool@Animal?Pathogen@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Stool@Animal?Total@RNA?Fungal Sequencing@NGS": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Stool@Animal?Total@RNA?General/Other@NGS": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Stool@Animal?Total@RNA?Microbial Sequencing@NGS": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Stool@Animal?Total@RNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Stool@Animal?Total@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Stool@Animal?Total@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Stool@Animal?Total@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Stool@Animal?Viral@RNA?General/Other@NGS": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Stool@Animal?Viral@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Stool@Animal?Viral@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Stool@Animal?Microbial@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4,zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1,R3000,R3001",
	},
	"Stool@Animal?Microbial@Total Nucleic Acid?Microbial Sequencing@NGS": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4,zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1,R3000,R3001",
	},
	"Stool@Animal?Microbial@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Stool@Animal?Microbial@Total Nucleic Acid?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Stool@Animal?Microbial@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Stool@Animal?Pathogen@Total Nucleic Acid?Fungal Sequencing@NGS": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Stool@Animal?Pathogen@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
	},
	"Stool@Animal?Pathogen@Total Nucleic Acid?Microbial Sequencing@NGS": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Stool@Animal?Pathogen@Total Nucleic Acid?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Stool@Animal?Pathogen@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Stool@Animal?Pathogen@Total Nucleic Acid?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Stool@Animal?Pathogen@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Stool@Animal?Total@Total Nucleic Acid?DNA Methylation@NGS": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymo-seq-wgbs-library-kit,zymo-seq-rrbs-library-kit,pico-methyl-seq-library-prep-kit",
		"Application Kit Numbers":"D5465,D5460,D5461,D5455,D5456",
		"Application Kit 2 Handle":"ez-methylation-magprep-beads",
		"Application Kit 2 Numbers":"D4100-5-4,D4100-5-8,D4100-5-16",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Stool@Animal?Total@Total Nucleic Acid?Chromatin Analysis@NGS": {
		"Application Kit Handle":"zymo-seq-atac-library-kit",
		"Application Kit Numbers":"D5458",
	},
	"Stool@Animal?Total@Total Nucleic Acid?Fungal Sequencing@NGS": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Stool@Animal?Total@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
	},
	"Stool@Animal?Total@Total Nucleic Acid?Microbial Sequencing@NGS": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Stool@Animal?Total@Total Nucleic Acid?DNA Methylation@PCR/rt-PCR": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Application Kit 2 Handle":"ez-dna-methylation-lightning-automation-kit",
		"Application Kit 2 Numbers":"D5049",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Stool@Animal?Total@Total Nucleic Acid?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Stool@Animal?Total@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Stool@Animal?Total@Total Nucleic Acid?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Stool@Animal?Total@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Stool@Animal?Viral@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
	},
	"Stool@Animal?Viral@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Stool@Animal?Viral@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Stool@Animal?Microbial@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4,zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1,R3000,R3001",
	},
	"Stool@Animal?Microbial@Fractional (DNA & RNA Separate)?Microbial Sequencing@NGS": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4,zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1,R3000,R3001",
	},
	"Stool@Animal?Microbial@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Stool@Animal?Microbial@Fractional (DNA & RNA Separate)?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Stool@Animal?Microbial@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Stool@Animal?Pathogen@Fractional (DNA & RNA Separate)?Fungal Sequencing@NGS": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Stool@Animal?Pathogen@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
	},
	"Stool@Animal?Pathogen@Fractional (DNA & RNA Separate)?Microbial Sequencing@NGS": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410",
	},
	"Stool@Animal?Pathogen@Fractional (DNA & RNA Separate)?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Stool@Animal?Pathogen@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Stool@Animal?Pathogen@Fractional (DNA & RNA Separate)?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Stool@Animal?Pathogen@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Stool@Animal?Viral@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
	},
	"Stool@Animal?Viral@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Stool@Animal?Viral@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Stool@Animal?Total@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
	},
	"Stool@Animal?Total@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"bunny-wipe-fecal-sample-collector",
		"Collection Numbers":"R1101",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Stool@Animal?Total@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Buccal@Animal?High-Molecular Weight@DNA?DNA Methylation@NGS": {
		"Collection Handle":"dna-rna-shield-safecollect-swab-collection-kit,dna-rna-shield-collection-tube-w-swab,dna-rna-shield",
		"Collection Numbers":"R1160-E,R1161-E,R1160,R1161,R1107-E,R1109-E,R1106,R1107,R1108,R1109,R1100-50,R1100-250,R1200-25,R1200-125",
		"Extraction/Purification Handle":"quick-dna-hmw-magbead-kit",
		"Extraction/Purification Numbers":"D6060",
		"Application Kit Handle":"zymo-seq-wgbs-library-kit,zymo-seq-rrbs-library-kit,pico-methyl-seq-library-prep-kit",
		"Application Kit Numbers":"D5465,D5460,D5461,D5455,D5456",
		"Application Kit 2 Handle":"ez-methylation-magprep-beads",
		"Application Kit 2 Numbers":"D4100-5-4,D4100-5-8,D4100-5-16",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Buccal@Animal?High-Molecular Weight@DNA?Chromatin Analysis@NGS": {
		"Application Kit Handle":"zymo-seq-atac-library-kit",
		"Application Kit Numbers":"D5458",
	},
	"Buccal@Animal?High-Molecular Weight@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-safecollect-swab-collection-kit,dna-rna-shield-collection-tube-w-swab,dna-rna-shield",
		"Collection Numbers":"R1160-E,R1161-E,R1160,R1161,R1107-E,R1109-E,R1106,R1107,R1108,R1109,R1100-50,R1100-250,R1200-25,R1200-125",
		"Extraction/Purification Handle":"quick-dna-hmw-magbead-kit",
		"Extraction/Purification Numbers":"D6060",
	},
	"Buccal@Animal?High-Molecular Weight@DNA?DNA Methylation@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-safecollect-swab-collection-kit,dna-rna-shield-collection-tube-w-swab,dna-rna-shield",
		"Collection Numbers":"R1160-E,R1161-E,R1160,R1161,R1107-E,R1109-E,R1106,R1107,R1108,R1109,R1100-50,R1100-250,R1200-25,R1200-125",
		"Extraction/Purification Handle":"quick-dna-hmw-magbead-kit",
		"Extraction/Purification Numbers":"D6060",
		"Application Kit Handle":"zymotaq-premix,zymotaq-dna-polymerase,zymotaq-qpcr-premix",
		"Application Kit Numbers":"E2003,E2004,E2001,E2002,E2054,E2055",
		"Application Kit 2 Handle":"ez-dna-methylation-lightning-automation-kit",
		"Application Kit 2 Numbers":"D5049",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Buccal@Animal?High-Molecular Weight@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-safecollect-swab-collection-kit,dna-rna-shield-collection-tube-w-swab,dna-rna-shield",
		"Collection Numbers":"R1160-E,R1161-E,R1160,R1161,R1107-E,R1109-E,R1106,R1107,R1108,R1109,R1100-50,R1100-250,R1200-25,R1200-125",
		"Extraction/Purification Handle":"quick-dna-hmw-magbead-kit",
		"Extraction/Purification Numbers":"D6060",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Buccal@Animal?High-Molecular Weight@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Buccal@Animal?Microbial@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-safecollect-swab-collection-kit,dna-rna-shield-collection-tube-w-swab,dna-rna-shield",
		"Collection Numbers":"R1160-E,R1161-E,R1160,R1161,R1107-E,R1109-E,R1106,R1107,R1108,R1109,R1100-50,R1100-250,R1200-25,R1200-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Buccal@Animal?Microbial@DNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-safecollect-swab-collection-kit,dna-rna-shield-collection-tube-w-swab,dna-rna-shield",
		"Collection Numbers":"R1160-E,R1161-E,R1160,R1161,R1107-E,R1109-E,R1106,R1107,R1108,R1109,R1100-50,R1100-250,R1200-25,R1200-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Buccal@Animal?Microbial@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-safecollect-swab-collection-kit,dna-rna-shield-collection-tube-w-swab,dna-rna-shield",
		"Collection Numbers":"R1160-E,R1161-E,R1160,R1161,R1107-E,R1109-E,R1106,R1107,R1108,R1109,R1100-50,R1100-250,R1200-25,R1200-125",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Buccal@Animal?Microbial@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-safecollect-swab-collection-kit,dna-rna-shield-collection-tube-w-swab,dna-rna-shield",
		"Collection Numbers":"R1160-E,R1161-E,R1160,R1161,R1107-E,R1109-E,R1106,R1107,R1108,R1109,R1100-50,R1100-250,R1200-25,R1200-125",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Buccal@Animal?Microbial@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Buccal@Animal?Pathogen@DNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-safecollect-swab-collection-kit,dna-rna-shield-collection-tube-w-swab,dna-rna-shield",
		"Collection Numbers":"R1160-E,R1161-E,R1160,R1161,R1107-E,R1109-E,R1106,R1107,R1108,R1109,R1100-50,R1100-250,R1200-25,R1200-125",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Buccal@Animal?Pathogen@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-safecollect-swab-collection-kit,dna-rna-shield-collection-tube-w-swab,dna-rna-shield",
		"Collection Numbers":"R1160-E,R1161-E,R1160,R1161,R1107-E,R1109-E,R1106,R1107,R1108,R1109,R1100-50,R1100-250,R1200-25,R1200-125",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
	},
	"Buccal@Animal?Pathogen@DNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-safecollect-swab-collection-kit,dna-rna-shield-collection-tube-w-swab,dna-rna-shield",
		"Collection Numbers":"R1160-E,R1161-E,R1160,R1161,R1107-E,R1109-E,R1106,R1107,R1108,R1109,R1100-50,R1100-250,R1200-25,R1200-125",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Buccal@Animal?Pathogen@DNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-safecollect-swab-collection-kit,dna-rna-shield-collection-tube-w-swab,dna-rna-shield",
		"Collection Numbers":"R1160-E,R1161-E,R1160,R1161,R1107-E,R1109-E,R1106,R1107,R1108,R1109,R1100-50,R1100-250,R1200-25,R1200-125",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Buccal@Animal?Pathogen@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-safecollect-swab-collection-kit,dna-rna-shield-collection-tube-w-swab,dna-rna-shield",
		"Collection Numbers":"R1160-E,R1161-E,R1160,R1161,R1107-E,R1109-E,R1106,R1107,R1108,R1109,R1100-50,R1100-250,R1200-25,R1200-125",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Buccal@Animal?Pathogen@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-safecollect-swab-collection-kit,dna-rna-shield-collection-tube-w-swab,dna-rna-shield",
		"Collection Numbers":"R1160-E,R1161-E,R1160,R1161,R1107-E,R1109-E,R1106,R1107,R1108,R1109,R1100-50,R1100-250,R1200-25,R1200-125",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Buccal@Animal?Pathogen@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Buccal@Animal?Total@DNA?DNA Methylation@NGS": {
		"Collection Handle":"dna-rna-shield-safecollect-swab-collection-kit,dna-rna-shield-collection-tube-w-swab,dna-rna-shield",
		"Collection Numbers":"R1160-E,R1161-E,R1160,R1161,R1107-E,R1109-E,R1106,R1107,R1108,R1109,R1100-50,R1100-250,R1200-25,R1200-125",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
		"Application Kit Handle":"zymo-seq-wgbs-library-kit,zymo-seq-rrbs-library-kit,pico-methyl-seq-library-prep-kit",
		"Application Kit Numbers":"D5465,D5460,D5461,D5455,D5456",
		"Application Kit 2 Handle":"ez-methylation-magprep-beads",
		"Application Kit 2 Numbers":"D4100-5-4,D4100-5-8,D4100-5-16",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Buccal@Animal?Total@DNA?Chromatin Analysis@NGS": {
		"Application Kit Handle":"zymo-seq-atac-library-kit",
		"Application Kit Numbers":"D5458",
	},
	"Buccal@Animal?Total@DNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
	},
	"Buccal@Animal?Total@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
	},
	"Buccal@Animal?Total@DNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Buccal@Animal?Total@DNA?DNA Methylation@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-safecollect-swab-collection-kit,dna-rna-shield-collection-tube-w-swab,dna-rna-shield",
		"Collection Numbers":"R1160-E,R1161-E,R1160,R1161,R1107-E,R1109-E,R1106,R1107,R1108,R1109,R1100-50,R1100-250,R1200-25,R1200-125",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
		"Application Kit Handle":"zymotaq-premix,zymotaq-dna-polymerase,zymotaq-qpcr-premix",
		"Application Kit Numbers":"E2003,E2004,E2001,E2002,E2054,E2055",
		"Application Kit 2 Handle":"ez-dna-methylation-lightning-automation-kit",
		"Application Kit 2 Numbers":"D5049",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Buccal@Animal?Total@DNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Buccal@Animal?Total@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Buccal@Animal?Total@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Buccal@Animal?Total@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Buccal@Animal?Viral@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-safecollect-swab-collection-kit,dna-rna-shield-collection-tube-w-swab,dna-rna-shield",
		"Collection Numbers":"R1160-E,R1161-E,R1160,R1161,R1107-E,R1109-E,R1106,R1107,R1108,R1109,R1100-50,R1100-250,R1200-25,R1200-125",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
	},
	"Buccal@Animal?Viral@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-safecollect-swab-collection-kit,dna-rna-shield-collection-tube-w-swab,dna-rna-shield",
		"Collection Numbers":"R1160-E,R1161-E,R1160,R1161,R1107-E,R1109-E,R1106,R1107,R1108,R1109,R1100-50,R1100-250,R1200-25,R1200-125",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Buccal@Animal?Viral@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Buccal@Animal?Microbial@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-safecollect-swab-collection-kit,dna-rna-shield-collection-tube-w-swab,dna-rna-shield",
		"Collection Numbers":"R1160-E,R1161-E,R1160,R1161,R1107-E,R1109-E,R1106,R1107,R1108,R1109,R1100-50,R1100-250,R1200-25,R1200-125",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Buccal@Animal?Microbial@RNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-safecollect-swab-collection-kit,dna-rna-shield-collection-tube-w-swab,dna-rna-shield",
		"Collection Numbers":"R1160-E,R1161-E,R1160,R1161,R1107-E,R1109-E,R1106,R1107,R1108,R1109,R1100-50,R1100-250,R1200-25,R1200-125",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Buccal@Animal?Microbial@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-safecollect-swab-collection-kit,dna-rna-shield-collection-tube-w-swab,dna-rna-shield",
		"Collection Numbers":"R1160-E,R1161-E,R1160,R1161,R1107-E,R1109-E,R1106,R1107,R1108,R1109,R1100-50,R1100-250,R1200-25,R1200-125",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Buccal@Animal?Microbial@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-safecollect-swab-collection-kit,dna-rna-shield-collection-tube-w-swab,dna-rna-shield",
		"Collection Numbers":"R1160-E,R1161-E,R1160,R1161,R1107-E,R1109-E,R1106,R1107,R1108,R1109,R1100-50,R1100-250,R1200-25,R1200-125",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Buccal@Animal?Microbial@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Buccal@Animal?micro-RNA@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-safecollect-swab-collection-kit,dna-rna-shield-collection-tube-w-swab,dna-rna-shield",
		"Collection Numbers":"R1160-E,R1161-E,R1160,R1161,R1107-E,R1109-E,R1106,R1107,R1108,R1109,R1100-50,R1100-250,R1200-25,R1200-125",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Buccal@Animal?micro-RNA@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-safecollect-swab-collection-kit,dna-rna-shield-collection-tube-w-swab,dna-rna-shield",
		"Collection Numbers":"R1160-E,R1161-E,R1160,R1161,R1107-E,R1109-E,R1106,R1107,R1108,R1109,R1100-50,R1100-250,R1200-25,R1200-125",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Buccal@Animal?Pathogen@RNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-safecollect-swab-collection-kit,dna-rna-shield-collection-tube-w-swab,dna-rna-shield",
		"Collection Numbers":"R1160-E,R1161-E,R1160,R1161,R1107-E,R1109-E,R1106,R1107,R1108,R1109,R1100-50,R1100-250,R1200-25,R1200-125",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Buccal@Animal?Pathogen@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-safecollect-swab-collection-kit,dna-rna-shield-collection-tube-w-swab,dna-rna-shield",
		"Collection Numbers":"R1160-E,R1161-E,R1160,R1161,R1107-E,R1109-E,R1106,R1107,R1108,R1109,R1100-50,R1100-250,R1200-25,R1200-125",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Buccal@Animal?Pathogen@RNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-safecollect-swab-collection-kit,dna-rna-shield-collection-tube-w-swab,dna-rna-shield",
		"Collection Numbers":"R1160-E,R1161-E,R1160,R1161,R1107-E,R1109-E,R1106,R1107,R1108,R1109,R1100-50,R1100-250,R1200-25,R1200-125",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Buccal@Animal?Pathogen@RNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-safecollect-swab-collection-kit,dna-rna-shield-collection-tube-w-swab,dna-rna-shield",
		"Collection Numbers":"R1160-E,R1161-E,R1160,R1161,R1107-E,R1109-E,R1106,R1107,R1108,R1109,R1100-50,R1100-250,R1200-25,R1200-125",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Buccal@Animal?Pathogen@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-safecollect-swab-collection-kit,dna-rna-shield-collection-tube-w-swab,dna-rna-shield",
		"Collection Numbers":"R1160-E,R1161-E,R1160,R1161,R1107-E,R1109-E,R1106,R1107,R1108,R1109,R1100-50,R1100-250,R1200-25,R1200-125",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Buccal@Animal?Pathogen@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-safecollect-swab-collection-kit,dna-rna-shield-collection-tube-w-swab,dna-rna-shield",
		"Collection Numbers":"R1160-E,R1161-E,R1160,R1161,R1107-E,R1109-E,R1106,R1107,R1108,R1109,R1100-50,R1100-250,R1200-25,R1200-125",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Buccal@Animal?Pathogen@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Buccal@Animal?Total@RNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Buccal@Animal?Total@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Buccal@Animal?Total@RNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Buccal@Animal?Total@RNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Buccal@Animal?Total@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Buccal@Animal?Total@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Buccal@Animal?Total@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Buccal@Animal?Viral@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-safecollect-swab-collection-kit,dna-rna-shield-collection-tube-w-swab,dna-rna-shield",
		"Collection Numbers":"R1160-E,R1161-E,R1160,R1161,R1107-E,R1109-E,R1106,R1107,R1108,R1109,R1100-50,R1100-250,R1200-25,R1200-125",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Buccal@Animal?Viral@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-safecollect-swab-collection-kit,dna-rna-shield-collection-tube-w-swab,dna-rna-shield",
		"Collection Numbers":"R1160-E,R1161-E,R1160,R1161,R1107-E,R1109-E,R1106,R1107,R1108,R1109,R1100-50,R1100-250,R1200-25,R1200-125",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Buccal@Animal?Viral@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Buccal@Animal?Microbial@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410,D6432",
	},
	"Buccal@Animal?Microbial@Total Nucleic Acid?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-safecollect-swab-collection-kit,dna-rna-shield-collection-tube-w-swab,dna-rna-shield",
		"Collection Numbers":"R1160-E,R1161-E,R1160,R1161,R1107-E,R1109-E,R1106,R1107,R1108,R1109,R1100-50,R1100-250,R1200-25,R1200-125",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Buccal@Animal?Microbial@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-safecollect-swab-collection-kit,dna-rna-shield-collection-tube-w-swab,dna-rna-shield",
		"Collection Numbers":"R1160-E,R1161-E,R1160,R1161,R1107-E,R1109-E,R1106,R1107,R1108,R1109,R1100-50,R1100-250,R1200-25,R1200-125",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Buccal@Animal?Microbial@Total Nucleic Acid?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-safecollect-swab-collection-kit,dna-rna-shield-collection-tube-w-swab,dna-rna-shield",
		"Collection Numbers":"R1160-E,R1161-E,R1160,R1161,R1107-E,R1109-E,R1106,R1107,R1108,R1109,R1100-50,R1100-250,R1200-25,R1200-125",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Buccal@Animal?Microbial@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Buccal@Animal?Pathogen@Total Nucleic Acid?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-safecollect-swab-collection-kit,dna-rna-shield-collection-tube-w-swab,dna-rna-shield",
		"Collection Numbers":"R1160-E,R1161-E,R1160,R1161,R1107-E,R1109-E,R1106,R1107,R1108,R1109,R1100-50,R1100-250,R1200-25,R1200-125",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Buccal@Animal?Pathogen@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-safecollect-swab-collection-kit,dna-rna-shield-collection-tube-w-swab,dna-rna-shield",
		"Collection Numbers":"R1160-E,R1161-E,R1160,R1161,R1107-E,R1109-E,R1106,R1107,R1108,R1109,R1100-50,R1100-250,R1200-25,R1200-125",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
	},
	"Buccal@Animal?Pathogen@Total Nucleic Acid?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-safecollect-swab-collection-kit,dna-rna-shield-collection-tube-w-swab,dna-rna-shield",
		"Collection Numbers":"R1160-E,R1161-E,R1160,R1161,R1107-E,R1109-E,R1106,R1107,R1108,R1109,R1100-50,R1100-250,R1200-25,R1200-125",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Buccal@Animal?Pathogen@Total Nucleic Acid?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-safecollect-swab-collection-kit,dna-rna-shield-collection-tube-w-swab,dna-rna-shield",
		"Collection Numbers":"R1160-E,R1161-E,R1160,R1161,R1107-E,R1109-E,R1106,R1107,R1108,R1109,R1100-50,R1100-250,R1200-25,R1200-125",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Buccal@Animal?Pathogen@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-safecollect-swab-collection-kit,dna-rna-shield-collection-tube-w-swab,dna-rna-shield",
		"Collection Numbers":"R1160-E,R1161-E,R1160,R1161,R1107-E,R1109-E,R1106,R1107,R1108,R1109,R1100-50,R1100-250,R1200-25,R1200-125",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Buccal@Animal?Pathogen@Total Nucleic Acid?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-safecollect-swab-collection-kit,dna-rna-shield-collection-tube-w-swab,dna-rna-shield",
		"Collection Numbers":"R1160-E,R1161-E,R1160,R1161,R1107-E,R1109-E,R1106,R1107,R1108,R1109,R1100-50,R1100-250,R1200-25,R1200-125",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Buccal@Animal?Pathogen@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Buccal@Animal?Total@Total Nucleic Acid?DNA Methylation@NGS": {
		"Collection Handle":"dna-rna-shield-safecollect-swab-collection-kit,dna-rna-shield-collection-tube-w-swab,dna-rna-shield",
		"Collection Numbers":"R1160-E,R1161-E,R1160,R1161,R1107-E,R1109-E,R1106,R1107,R1108,R1109,R1100-50,R1100-250,R1200-25,R1200-125",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymo-seq-wgbs-library-kit,zymo-seq-rrbs-library-kit,pico-methyl-seq-library-prep-kit",
		"Application Kit Numbers":"D5465,D5460,D5461,D5455,D5456",
		"Application Kit 2 Handle":"ez-methylation-magprep-beads",
		"Application Kit 2 Numbers":"D4100-5-4,D4100-5-8,D4100-5-16",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Buccal@Animal?Total@Total Nucleic Acid?Chromatin Analysis@NGS": {
		"Application Kit Handle":"zymo-seq-atac-library-kit",
		"Application Kit Numbers":"D5458",
	},
	"Buccal@Animal?Total@Total Nucleic Acid?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Buccal@Animal?Total@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
	},
	"Buccal@Animal?Total@Total Nucleic Acid?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Buccal@Animal?Total@Total Nucleic Acid?DNA Methylation@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-safecollect-swab-collection-kit,dna-rna-shield-collection-tube-w-swab,dna-rna-shield",
		"Collection Numbers":"R1160-E,R1161-E,R1160,R1161,R1107-E,R1109-E,R1106,R1107,R1108,R1109,R1100-50,R1100-250,R1200-25,R1200-125",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Application Kit 2 Handle":"ez-dna-methylation-lightning-automation-kit",
		"Application Kit 2 Numbers":"D5049",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Buccal@Animal?Total@Total Nucleic Acid?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Buccal@Animal?Total@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Buccal@Animal?Total@Total Nucleic Acid?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Buccal@Animal?Total@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Buccal@Animal?Viral@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-safecollect-swab-collection-kit,dna-rna-shield-collection-tube-w-swab,dna-rna-shield",
		"Collection Numbers":"R1160-E,R1161-E,R1160,R1161,R1107-E,R1109-E,R1106,R1107,R1108,R1109,R1100-50,R1100-250,R1200-25,R1200-125",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
	},
	"Buccal@Animal?Viral@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-safecollect-swab-collection-kit,dna-rna-shield-collection-tube-w-swab,dna-rna-shield",
		"Collection Numbers":"R1160-E,R1161-E,R1160,R1161,R1107-E,R1109-E,R1106,R1107,R1108,R1109,R1100-50,R1100-250,R1200-25,R1200-125",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Buccal@Animal?Viral@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Buccal@Animal?Microbial@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-safecollect-swab-collection-kit,dna-rna-shield-collection-tube-w-swab,dna-rna-shield",
		"Collection Numbers":"R1160-E,R1161-E,R1160,R1161,R1107-E,R1109-E,R1106,R1107,R1108,R1109,R1100-50,R1100-250,R1200-25,R1200-125",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410,D6432",
	},
	"Buccal@Animal?Microbial@Fractional (DNA & RNA Separate)?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-safecollect-swab-collection-kit,dna-rna-shield-collection-tube-w-swab,dna-rna-shield",
		"Collection Numbers":"R1160-E,R1161-E,R1160,R1161,R1107-E,R1109-E,R1106,R1107,R1108,R1109,R1100-50,R1100-250,R1200-25,R1200-125",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410",
	},
	"Buccal@Animal?Microbial@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-safecollect-swab-collection-kit,dna-rna-shield-collection-tube-w-swab,dna-rna-shield",
		"Collection Numbers":"R1160-E,R1161-E,R1160,R1161,R1107-E,R1109-E,R1106,R1107,R1108,R1109,R1100-50,R1100-250,R1200-25,R1200-125",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Buccal@Animal?Microbial@Fractional (DNA & RNA Separate)?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-safecollect-swab-collection-kit,dna-rna-shield-collection-tube-w-swab,dna-rna-shield",
		"Collection Numbers":"R1160-E,R1161-E,R1160,R1161,R1107-E,R1109-E,R1106,R1107,R1108,R1109,R1100-50,R1100-250,R1200-25,R1200-125",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Buccal@Animal?Microbial@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Buccal@Animal?Pathogen@Fractional (DNA & RNA Separate)?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-safecollect-swab-collection-kit,dna-rna-shield-collection-tube-w-swab,dna-rna-shield",
		"Collection Numbers":"R1160-E,R1161-E,R1160,R1161,R1107-E,R1109-E,R1106,R1107,R1108,R1109,R1100-50,R1100-250,R1200-25,R1200-125",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Buccal@Animal?Pathogen@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-safecollect-swab-collection-kit,dna-rna-shield-collection-tube-w-swab,dna-rna-shield",
		"Collection Numbers":"R1160-E,R1161-E,R1160,R1161,R1107-E,R1109-E,R1106,R1107,R1108,R1109,R1100-50,R1100-250,R1200-25,R1200-125",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
	},
	"Buccal@Animal?Pathogen@Fractional (DNA & RNA Separate)?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-safecollect-swab-collection-kit,dna-rna-shield-collection-tube-w-swab,dna-rna-shield",
		"Collection Numbers":"R1160-E,R1161-E,R1160,R1161,R1107-E,R1109-E,R1106,R1107,R1108,R1109,R1100-50,R1100-250,R1200-25,R1200-125",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410",
	},
	"Buccal@Animal?Pathogen@Fractional (DNA & RNA Separate)?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-safecollect-swab-collection-kit,dna-rna-shield-collection-tube-w-swab,dna-rna-shield",
		"Collection Numbers":"R1160-E,R1161-E,R1160,R1161,R1107-E,R1109-E,R1106,R1107,R1108,R1109,R1100-50,R1100-250,R1200-25,R1200-125",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Buccal@Animal?Pathogen@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-safecollect-swab-collection-kit,dna-rna-shield-collection-tube-w-swab,dna-rna-shield",
		"Collection Numbers":"R1160-E,R1161-E,R1160,R1161,R1107-E,R1109-E,R1106,R1107,R1108,R1109,R1100-50,R1100-250,R1200-25,R1200-125",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Buccal@Animal?Pathogen@Fractional (DNA & RNA Separate)?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-safecollect-swab-collection-kit,dna-rna-shield-collection-tube-w-swab,dna-rna-shield",
		"Collection Numbers":"R1160-E,R1161-E,R1160,R1161,R1107-E,R1109-E,R1106,R1107,R1108,R1109,R1100-50,R1100-250,R1200-25,R1200-125",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Buccal@Animal?Pathogen@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Buccal@Animal?Viral@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-safecollect-swab-collection-kit,dna-rna-shield-collection-tube-w-swab,dna-rna-shield",
		"Collection Numbers":"R1160-E,R1161-E,R1160,R1161,R1107-E,R1109-E,R1106,R1107,R1108,R1109,R1100-50,R1100-250,R1200-25,R1200-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
	},
	"Buccal@Animal?Viral@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-safecollect-swab-collection-kit,dna-rna-shield-collection-tube-w-swab,dna-rna-shield",
		"Collection Numbers":"R1160-E,R1161-E,R1160,R1161,R1107-E,R1109-E,R1106,R1107,R1108,R1109,R1100-50,R1100-250,R1200-25,R1200-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Buccal@Animal?Viral@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Buccal@Animal?Total@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
	},
	"Buccal@Animal?Total@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Buccal@Animal?Total@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Urine@Animal?Cell-Free@DNA?DNA Methylation@NGS": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Extraction/Purification Handle":"magicbead-cfdna-isolation-kit",
		"Extraction/Purification Numbers":"D4086",
		"Application Kit Handle":"zymo-seq-cell-free-dna-wgbs-library-kit",
		"Application Kit Numbers":"D5462,D5463",
		"Application Kit 2 Handle":"ez-methylation-magprep-beads",
		"Application Kit 2 Numbers":"D4100-5-4,D4100-5-8,D4100-5-16",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Urine@Animal?Cell-Free@DNA?Fungal Sequencing@NGS": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Extraction/Purification Handle":"magicbead-cfdna-isolation-kit",
		"Extraction/Purification Numbers":"D4086",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Urine@Animal?Cell-Free@DNA?General/Other@NGS": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Extraction/Purification Handle":"magicbead-cfdna-isolation-kit",
		"Extraction/Purification Numbers":"D4086",
		"Application Kit Handle":"zymo-seq-cell-free-dna-wgbs-library-kit",
		"Application Kit Numbers":"D5462,D5463",
	},
	"Urine@Animal?Cell-Free@DNA?Microbial Sequencing@NGS": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"magicbead-cfdna-isolation-kit",
		"Extraction/Purification Numbers":"D4086",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Urine@Animal?Cell-Free@DNA?DNA Methylation@PCR/rt-PCR": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Extraction/Purification Handle":"magicbead-cfdna-isolation-kit",
		"Extraction/Purification Numbers":"D4086",
		"Application Kit Handle":"zymotaq-premix,zymotaq-dna-polymerase,zymotaq-qpcr-premix",
		"Application Kit Numbers":"E2003,E2004,E2001,E2002,E2054,E2055",
		"Application Kit 2 Handle":"ez-dna-methylation-lightning-automation-kit",
		"Application Kit 2 Numbers":"D5049",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Urine@Animal?Cell-Free@DNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Extraction/Purification Handle":"magicbead-cfdna-isolation-kit",
		"Extraction/Purification Numbers":"D4086",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Urine@Animal?Cell-Free@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Extraction/Purification Handle":"magicbead-cfdna-isolation-kit",
		"Extraction/Purification Numbers":"D4086",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Urine@Animal?Cell-Free@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"magicbead-cfdna-isolation-kit",
		"Extraction/Purification Numbers":"D4086",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Urine@Animal?Cell-Free@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Urine@Animal?Microbial@DNA?General/Other@NGS": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Urine@Animal?Microbial@DNA?Microbial Sequencing@NGS": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Urine@Animal?Microbial@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Urine@Animal?Microbial@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Urine@Animal?Microbial@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Urine@Animal?Pathogen@DNA?Fungal Sequencing@NGS": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Urine@Animal?Pathogen@DNA?General/Other@NGS": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
	},
	"Urine@Animal?Pathogen@DNA?Microbial Sequencing@NGS": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Urine@Animal?Pathogen@DNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Urine@Animal?Pathogen@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Urine@Animal?Pathogen@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Urine@Animal?Pathogen@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Urine@Animal?Total@DNA?DNA Methylation@NGS": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
		"Application Kit Handle":"zymo-seq-wgbs-library-kit,zymo-seq-rrbs-library-kit,pico-methyl-seq-library-prep-kit",
		"Application Kit Numbers":"D5465,D5460,D5461,D5455,D5456",
		"Application Kit 2 Handle":"ez-methylation-magprep-beads",
		"Application Kit 2 Numbers":"D4100-5-4,D4100-5-8,D4100-5-16",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Urine@Animal?Total@DNA?Chromatin Analysis@NGS": {
		"Application Kit Handle":"zymo-seq-atac-library-kit",
		"Application Kit Numbers":"D5458",
	},
	"Urine@Animal?Total@DNA?Fungal Sequencing@NGS": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
	},
	"Urine@Animal?Total@DNA?General/Other@NGS": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
	},
	"Urine@Animal?Total@DNA?Microbial Sequencing@NGS": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Urine@Animal?Total@DNA?DNA Methylation@PCR/rt-PCR": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
		"Application Kit Handle":"zymotaq-premix,zymotaq-dna-polymerase,zymotaq-qpcr-premix",
		"Application Kit Numbers":"E2003,E2004,E2001,E2002,E2054,E2055",
		"Application Kit 2 Handle":"ez-dna-methylation-lightning-automation-kit",
		"Application Kit 2 Numbers":"D5049",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Urine@Animal?Total@DNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Urine@Animal?Total@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Urine@Animal?Total@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Urine@Animal?Total@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Urine@Animal?Viral@DNA?General/Other@NGS": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
	},
	"Urine@Animal?Viral@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Urine@Animal?Viral@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Urine@Animal?Microbial@RNA?General/Other@NGS": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Urine@Animal?Microbial@RNA?Microbial Sequencing@NGS": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Urine@Animal?Microbial@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Urine@Animal?Microbial@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Urine@Animal?Microbial@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Urine@Animal?micro-RNA@RNA?General/Other@NGS": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Urine@Animal?micro-RNA@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Urine@Animal?Pathogen@RNA?Fungal Sequencing@NGS": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Urine@Animal?Pathogen@RNA?General/Other@NGS": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Urine@Animal?Pathogen@RNA?Microbial Sequencing@NGS": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Urine@Animal?Pathogen@RNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Urine@Animal?Pathogen@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Urine@Animal?Pathogen@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Urine@Animal?Pathogen@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Urine@Animal?Total@RNA?Fungal Sequencing@NGS": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Urine@Animal?Total@RNA?General/Other@NGS": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Urine@Animal?Total@RNA?Microbial Sequencing@NGS": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Urine@Animal?Total@RNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Urine@Animal?Total@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Urine@Animal?Total@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Urine@Animal?Total@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Urine@Animal?Viral@RNA?General/Other@NGS": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Urine@Animal?Viral@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Urine@Animal?Viral@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Urine@Animal?Microbial@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410,D6432",
	},
	"Urine@Animal?Microbial@Total Nucleic Acid?Microbial Sequencing@NGS": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Urine@Animal?Microbial@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Urine@Animal?Microbial@Total Nucleic Acid?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Urine@Animal?Microbial@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Urine@Animal?Pathogen@Total Nucleic Acid?Fungal Sequencing@NGS": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Urine@Animal?Pathogen@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
	},
	"Urine@Animal?Pathogen@Total Nucleic Acid?Microbial Sequencing@NGS": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Urine@Animal?Pathogen@Total Nucleic Acid?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Urine@Animal?Pathogen@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Urine@Animal?Pathogen@Total Nucleic Acid?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Urine@Animal?Pathogen@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Urine@Animal?Total@Total Nucleic Acid?DNA Methylation@NGS": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymo-seq-wgbs-library-kit,zymo-seq-rrbs-library-kit,pico-methyl-seq-library-prep-kit",
		"Application Kit Numbers":"D5465,D5460,D5461,D5455,D5456",
		"Application Kit 2 Handle":"ez-methylation-magprep-beads",
		"Application Kit 2 Numbers":"D4100-5-4,D4100-5-8,D4100-5-16",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Urine@Animal?Total@Total Nucleic Acid?Chromatin Analysis@NGS": {
		"Application Kit Handle":"zymo-seq-atac-library-kit",
		"Application Kit Numbers":"D5458",
	},
	"Urine@Animal?Total@Total Nucleic Acid?Fungal Sequencing@NGS": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Urine@Animal?Total@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
	},
	"Urine@Animal?Total@Total Nucleic Acid?Microbial Sequencing@NGS": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Urine@Animal?Total@Total Nucleic Acid?DNA Methylation@PCR/rt-PCR": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Application Kit 2 Handle":"ez-dna-methylation-lightning-automation-kit",
		"Application Kit 2 Numbers":"D5049",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Urine@Animal?Total@Total Nucleic Acid?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Urine@Animal?Total@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Urine@Animal?Total@Total Nucleic Acid?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Urine@Animal?Total@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Urine@Animal?Viral@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
	},
	"Urine@Animal?Viral@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Urine@Animal?Viral@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Urine@Animal?Microbial@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410,D6432",
	},
	"Urine@Animal?Microbial@Fractional (DNA & RNA Separate)?Microbial Sequencing@NGS": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410",
	},
	"Urine@Animal?Microbial@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Urine@Animal?Microbial@Fractional (DNA & RNA Separate)?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Urine@Animal?Microbial@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Urine@Animal?Pathogen@Fractional (DNA & RNA Separate)?Fungal Sequencing@NGS": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Urine@Animal?Pathogen@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
	},
	"Urine@Animal?Pathogen@Fractional (DNA & RNA Separate)?Microbial Sequencing@NGS": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410",
	},
	"Urine@Animal?Pathogen@Fractional (DNA & RNA Separate)?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Urine@Animal?Pathogen@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Urine@Animal?Pathogen@Fractional (DNA & RNA Separate)?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Urine@Animal?Pathogen@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Urine@Animal?Viral@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
	},
	"Urine@Animal?Viral@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Urine@Animal?Viral@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Urine@Animal?Total@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
	},
	"Urine@Animal?Total@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"urine-collection-kit",
		"Collection Numbers":"D3062",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Urine@Animal?Total@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Whole Blood@Animal?High-Molecular Weight@DNA?DNA Methylation@NGS": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Extraction/Purification Handle":"quick-dna-hmw-magbead-kit",
		"Extraction/Purification Numbers":"D6060",
		"Application Kit Handle":"zymo-seq-wgbs-library-kit,zymo-seq-rrbs-library-kit,pico-methyl-seq-library-prep-kit",
		"Application Kit Numbers":"D5465,D5460,D5461,D5455,D5456",
		"Application Kit 2 Handle":"ez-methylation-magprep-beads",
		"Application Kit 2 Numbers":"D4100-5-4,D4100-5-8,D4100-5-16",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Whole Blood@Animal?High-Molecular Weight@DNA?Chromatin Analysis@NGS": {
		"Application Kit Handle":"zymo-seq-atac-library-kit",
		"Application Kit Numbers":"D5458",
	},
	"Whole Blood@Animal?High-Molecular Weight@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Extraction/Purification Handle":"quick-dna-hmw-magbead-kit",
		"Extraction/Purification Numbers":"D6060",
	},
	"Whole Blood@Animal?High-Molecular Weight@DNA?DNA Methylation@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Extraction/Purification Handle":"quick-dna-hmw-magbead-kit",
		"Extraction/Purification Numbers":"D6060",
		"Application Kit Handle":"zymotaq-premix,zymotaq-dna-polymerase,zymotaq-qpcr-premix",
		"Application Kit Numbers":"E2003,E2004,E2001,E2002,E2054,E2055",
		"Application Kit 2 Handle":"ez-dna-methylation-lightning-automation-kit",
		"Application Kit 2 Numbers":"D5049",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Whole Blood@Animal?High-Molecular Weight@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Extraction/Purification Handle":"quick-dna-hmw-magbead-kit",
		"Extraction/Purification Numbers":"D6060",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Whole Blood@Animal?High-Molecular Weight@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Whole Blood@Animal?Microbial@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Whole Blood@Animal?Microbial@DNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Whole Blood@Animal?Microbial@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Whole Blood@Animal?Microbial@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Whole Blood@Animal?Microbial@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Whole Blood@Animal?Pathogen@DNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Whole Blood@Animal?Pathogen@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
	},
	"Whole Blood@Animal?Pathogen@DNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Whole Blood@Animal?Pathogen@DNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Whole Blood@Animal?Pathogen@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Whole Blood@Animal?Pathogen@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Whole Blood@Animal?Pathogen@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Whole Blood@Animal?Total@DNA?DNA Methylation@NGS": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
		"Application Kit Handle":"zymo-seq-wgbs-library-kit,zymo-seq-rrbs-library-kit,pico-methyl-seq-library-prep-kit",
		"Application Kit Numbers":"D5465,D5460,D5461,D5455,D5456",
		"Application Kit 2 Handle":"ez-methylation-magprep-beads",
		"Application Kit 2 Numbers":"D4100-5-4,D4100-5-8,D4100-5-16",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Whole Blood@Animal?Total@DNA?Chromatin Analysis@NGS": {
		"Application Kit Handle":"zymo-seq-atac-library-kit",
		"Application Kit Numbers":"D5458",
	},
	"Whole Blood@Animal?Total@DNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
	},
	"Whole Blood@Animal?Total@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
	},
	"Whole Blood@Animal?Total@DNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Whole Blood@Animal?Total@DNA?DNA Methylation@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
		"Application Kit Handle":"zymotaq-premix,zymotaq-dna-polymerase,zymotaq-qpcr-premix",
		"Application Kit Numbers":"E2003,E2004,E2001,E2002,E2054,E2055",
		"Application Kit 2 Handle":"ez-dna-methylation-lightning-automation-kit",
		"Application Kit 2 Numbers":"D5049",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Whole Blood@Animal?Total@DNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Whole Blood@Animal?Total@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Whole Blood@Animal?Total@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Whole Blood@Animal?Total@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Whole Blood@Animal?Viral@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
	},
	"Whole Blood@Animal?Viral@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Whole Blood@Animal?Viral@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Whole Blood@Animal?Microbial@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Whole Blood@Animal?Microbial@RNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Whole Blood@Animal?Microbial@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Whole Blood@Animal?Microbial@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Whole Blood@Animal?Microbial@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Whole Blood@Animal?micro-RNA@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Whole Blood@Animal?micro-RNA@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Whole Blood@Animal?Pathogen@RNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Whole Blood@Animal?Pathogen@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Whole Blood@Animal?Pathogen@RNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Whole Blood@Animal?Pathogen@RNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Whole Blood@Animal?Pathogen@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Whole Blood@Animal?Pathogen@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Whole Blood@Animal?Pathogen@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Whole Blood@Animal?Total@RNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Whole Blood@Animal?Total@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Whole Blood@Animal?Total@RNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Whole Blood@Animal?Total@RNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Whole Blood@Animal?Total@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Whole Blood@Animal?Total@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Whole Blood@Animal?Total@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Whole Blood@Animal?Viral@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Whole Blood@Animal?Viral@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Whole Blood@Animal?Viral@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Whole Blood@Animal?Microbial@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410,D6432",
	},
	"Whole Blood@Animal?Microbial@Total Nucleic Acid?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Whole Blood@Animal?Microbial@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Whole Blood@Animal?Microbial@Total Nucleic Acid?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Whole Blood@Animal?Microbial@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Whole Blood@Animal?Pathogen@Total Nucleic Acid?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Whole Blood@Animal?Pathogen@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
	},
	"Whole Blood@Animal?Pathogen@Total Nucleic Acid?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Whole Blood@Animal?Pathogen@Total Nucleic Acid?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Whole Blood@Animal?Pathogen@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Whole Blood@Animal?Pathogen@Total Nucleic Acid?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Whole Blood@Animal?Pathogen@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Whole Blood@Animal?Total@Total Nucleic Acid?DNA Methylation@NGS": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymo-seq-wgbs-library-kit,zymo-seq-rrbs-library-kit,pico-methyl-seq-library-prep-kit",
		"Application Kit Numbers":"D5465,D5460,D5461,D5455,D5456",
		"Application Kit 2 Handle":"ez-methylation-magprep-beads",
		"Application Kit 2 Numbers":"D4100-5-4,D4100-5-8,D4100-5-16",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Whole Blood@Animal?Total@Total Nucleic Acid?Chromatin Analysis@NGS": {
		"Application Kit Handle":"zymo-seq-atac-library-kit",
		"Application Kit Numbers":"D5458",
	},
	"Whole Blood@Animal?Total@Total Nucleic Acid?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Whole Blood@Animal?Total@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
	},
	"Whole Blood@Animal?Total@Total Nucleic Acid?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Whole Blood@Animal?Total@Total Nucleic Acid?DNA Methylation@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Application Kit 2 Handle":"ez-dna-methylation-lightning-automation-kit",
		"Application Kit 2 Numbers":"D5049",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Whole Blood@Animal?Total@Total Nucleic Acid?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Whole Blood@Animal?Total@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Whole Blood@Animal?Total@Total Nucleic Acid?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Whole Blood@Animal?Total@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Whole Blood@Animal?Viral@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
	},
	"Whole Blood@Animal?Viral@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Whole Blood@Animal?Viral@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Whole Blood@Animal?Microbial@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410,D6432",
	},
	"Whole Blood@Animal?Microbial@Fractional (DNA & RNA Separate)?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410",
	},
	"Whole Blood@Animal?Microbial@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Whole Blood@Animal?Microbial@Fractional (DNA & RNA Separate)?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Whole Blood@Animal?Microbial@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Whole Blood@Animal?Pathogen@Fractional (DNA & RNA Separate)?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Whole Blood@Animal?Pathogen@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
	},
	"Whole Blood@Animal?Pathogen@Fractional (DNA & RNA Separate)?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410",
	},
	"Whole Blood@Animal?Pathogen@Fractional (DNA & RNA Separate)?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Whole Blood@Animal?Pathogen@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Whole Blood@Animal?Pathogen@Fractional (DNA & RNA Separate)?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Whole Blood@Animal?Pathogen@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Whole Blood@Animal?Viral@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
	},
	"Whole Blood@Animal?Viral@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Whole Blood@Animal?Viral@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Whole Blood@Animal?Total@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
	},
	"Whole Blood@Animal?Total@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield,dna-rna-shield-blood-collection-tube",
		"Collection Numbers":"R1100-50,R1100-250,R1150",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Whole Blood@Animal?Total@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Trizol@Animal?Microbial@RNA?General/Other@NGS": {
		"Collection Handle":"tri-reagent",
		"Collection Numbers":"R2050-1-200",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"direct-zol-96-magbead-rna",
		"Extraction/Purification Numbers":"R2100,R2101,R2102,R2103",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Trizol@Animal?Microbial@RNA?Microbial Sequencing@NGS": {
		"Collection Handle":"tri-reagent",
		"Collection Numbers":"R2050-1-200",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"direct-zol-96-magbead-rna",
		"Extraction/Purification Numbers":"R2100,R2101,R2102,R2103",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Trizol@Animal?Microbial@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"tri-reagent",
		"Collection Numbers":"R2050-1-200",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"direct-zol-96-magbead-rna",
		"Extraction/Purification Numbers":"R2100,R2101,R2102,R2103",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Trizol@Animal?Microbial@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"tri-reagent",
		"Collection Numbers":"R2050-1-200",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"direct-zol-96-magbead-rna",
		"Extraction/Purification Numbers":"R2100,R2101,R2102,R2103",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Trizol@Animal?Microbial@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Trizol@Animal?micro-RNA@RNA?General/Other@NGS": {
		"Collection Handle":"tri-reagent",
		"Collection Numbers":"R2050-1-200",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Trizol@Animal?micro-RNA@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"tri-reagent",
		"Collection Numbers":"R2050-1-200",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Trizol@Animal?Pathogen@RNA?Fungal Sequencing@NGS": {
		"Collection Handle":"tri-reagent",
		"Collection Numbers":"R2050-1-200",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Trizol@Animal?Pathogen@RNA?General/Other@NGS": {
		"Collection Handle":"tri-reagent",
		"Collection Numbers":"R2050-1-200",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Trizol@Animal?Pathogen@RNA?Microbial Sequencing@NGS": {
		"Collection Handle":"tri-reagent",
		"Collection Numbers":"R2050-1-200",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Trizol@Animal?Pathogen@RNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"tri-reagent",
		"Collection Numbers":"R2050-1-200",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Trizol@Animal?Pathogen@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"tri-reagent",
		"Collection Numbers":"R2050-1-200",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Trizol@Animal?Pathogen@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"tri-reagent",
		"Collection Numbers":"R2050-1-200",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Trizol@Animal?Pathogen@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Trizol@Animal?Total@RNA?Fungal Sequencing@NGS": {
		"Collection Handle":"tri-reagent",
		"Collection Numbers":"R2050-1-200",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"direct-zol-96-magbead-rna",
		"Extraction/Purification Numbers":"R2100,R2101,R2102,R2103",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Trizol@Animal?Total@RNA?General/Other@NGS": {
		"Collection Handle":"tri-reagent",
		"Collection Numbers":"R2050-1-200",
		"Extraction/Purification Handle":"direct-zol-96-magbead-rna",
		"Extraction/Purification Numbers":"R2100,R2101,R2102,R2103",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Trizol@Animal?Total@RNA?Microbial Sequencing@NGS": {
		"Collection Handle":"tri-reagent",
		"Collection Numbers":"R2050-1-200",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"direct-zol-96-magbead-rna",
		"Extraction/Purification Numbers":"R2100,R2101,R2102,R2103",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Trizol@Animal?Total@RNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"tri-reagent",
		"Collection Numbers":"R2050-1-200",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"direct-zol-96-magbead-rna",
		"Extraction/Purification Numbers":"R2100,R2101,R2102,R2103",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Trizol@Animal?Total@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"tri-reagent",
		"Collection Numbers":"R2050-1-200",
		"Extraction/Purification Handle":"direct-zol-96-magbead-rna",
		"Extraction/Purification Numbers":"R2100,R2101,R2102,R2103",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Trizol@Animal?Total@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"tri-reagent",
		"Collection Numbers":"R2050-1-200",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"direct-zol-96-magbead-rna",
		"Extraction/Purification Numbers":"R2100,R2101,R2102,R2103",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Trizol@Animal?Total@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Trizol@Animal?Viral@RNA?General/Other@NGS": {
		"Collection Handle":"tri-reagent",
		"Collection Numbers":"R2050-1-200",
		"Extraction/Purification Handle":"direct-zol-96-magbead-rna",
		"Extraction/Purification Numbers":"R2100,R2101,R2102,R2103",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Trizol@Animal?Viral@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"tri-reagent",
		"Collection Numbers":"R2050-1-200",
		"Extraction/Purification Handle":"direct-zol-96-magbead-rna",
		"Extraction/Purification Numbers":"R2100,R2101,R2102,R2103",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Trizol@Animal?Viral@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Eukaryotic Cells@Animal?High-Molecular Weight@DNA?DNA Methylation@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-hmw-magbead-kit",
		"Extraction/Purification Numbers":"D6060",
		"Application Kit Handle":"zymo-seq-wgbs-library-kit,zymo-seq-rrbs-library-kit,pico-methyl-seq-library-prep-kit",
		"Application Kit Numbers":"D5465,D5460,D5461,D5455,D5456",
		"Application Kit 2 Handle":"ez-methylation-magprep-beads",
		"Application Kit 2 Numbers":"D4100-5-4,D4100-5-8,D4100-5-16",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Eukaryotic Cells@Animal?High-Molecular Weight@DNA?Chromatin Analysis@NGS": {
		"Application Kit Handle":"zymo-seq-atac-library-kit",
		"Application Kit Numbers":"D5458",
	},
	"Eukaryotic Cells@Animal?High-Molecular Weight@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-hmw-magbead-kit",
		"Extraction/Purification Numbers":"D6060",
	},
	"Eukaryotic Cells@Animal?High-Molecular Weight@DNA?DNA Methylation@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-hmw-magbead-kit",
		"Extraction/Purification Numbers":"D6060",
		"Application Kit Handle":"zymotaq-premix,zymotaq-dna-polymerase,zymotaq-qpcr-premix",
		"Application Kit Numbers":"E2003,E2004,E2001,E2002,E2054,E2055",
		"Application Kit 2 Handle":"ez-dna-methylation-lightning-automation-kit",
		"Application Kit 2 Numbers":"D5049",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Eukaryotic Cells@Animal?High-Molecular Weight@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-hmw-magbead-kit",
		"Extraction/Purification Numbers":"D6060",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Eukaryotic Cells@Animal?High-Molecular Weight@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Eukaryotic Cells@Animal?Microbial@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Eukaryotic Cells@Animal?Microbial@DNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Eukaryotic Cells@Animal?Microbial@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Eukaryotic Cells@Animal?Microbial@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Eukaryotic Cells@Animal?Microbial@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Eukaryotic Cells@Animal?Pathogen@DNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Eukaryotic Cells@Animal?Pathogen@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
	},
	"Eukaryotic Cells@Animal?Pathogen@DNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Eukaryotic Cells@Animal?Pathogen@DNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Eukaryotic Cells@Animal?Pathogen@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Eukaryotic Cells@Animal?Pathogen@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Eukaryotic Cells@Animal?Pathogen@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Eukaryotic Cells@Animal?Total@DNA?DNA Methylation@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
		"Application Kit Handle":"zymo-seq-wgbs-library-kit,zymo-seq-rrbs-library-kit,pico-methyl-seq-library-prep-kit",
		"Application Kit Numbers":"D5465,D5460,D5461,D5455,D5456",
		"Application Kit 2 Handle":"ez-methylation-magprep-beads",
		"Application Kit 2 Numbers":"D4100-5-4,D4100-5-8,D4100-5-16",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Eukaryotic Cells@Animal?Total@DNA?Chromatin Analysis@NGS": {
		"Application Kit Handle":"zymo-seq-atac-library-kit",
		"Application Kit Numbers":"D5458",
	},
	"Eukaryotic Cells@Animal?Total@DNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
	},
	"Eukaryotic Cells@Animal?Total@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
	},
	"Eukaryotic Cells@Animal?Total@DNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Eukaryotic Cells@Animal?Total@DNA?DNA Methylation@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
		"Application Kit Handle":"zymotaq-premix,zymotaq-dna-polymerase,zymotaq-qpcr-premix",
		"Application Kit Numbers":"E2003,E2004,E2001,E2002,E2054,E2055",
		"Application Kit 2 Handle":"ez-dna-methylation-lightning-automation-kit",
		"Application Kit 2 Numbers":"D5049",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Eukaryotic Cells@Animal?Total@DNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Eukaryotic Cells@Animal?Total@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Eukaryotic Cells@Animal?Total@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Eukaryotic Cells@Animal?Total@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Eukaryotic Cells@Animal?Viral@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
	},
	"Eukaryotic Cells@Animal?Viral@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Eukaryotic Cells@Animal?Viral@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Eukaryotic Cells@Animal?Microbial@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Eukaryotic Cells@Animal?Microbial@RNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Eukaryotic Cells@Animal?Microbial@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Eukaryotic Cells@Animal?Microbial@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Eukaryotic Cells@Animal?Microbial@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Eukaryotic Cells@Animal?micro-RNA@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Eukaryotic Cells@Animal?micro-RNA@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Eukaryotic Cells@Animal?Pathogen@RNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Eukaryotic Cells@Animal?Pathogen@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Eukaryotic Cells@Animal?Pathogen@RNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Eukaryotic Cells@Animal?Pathogen@RNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Eukaryotic Cells@Animal?Pathogen@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Eukaryotic Cells@Animal?Pathogen@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Eukaryotic Cells@Animal?Pathogen@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Eukaryotic Cells@Animal?Total@RNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Eukaryotic Cells@Animal?Total@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Eukaryotic Cells@Animal?Total@RNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Eukaryotic Cells@Animal?Total@RNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Eukaryotic Cells@Animal?Total@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Eukaryotic Cells@Animal?Total@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Eukaryotic Cells@Animal?Total@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Eukaryotic Cells@Animal?Viral@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Eukaryotic Cells@Animal?Viral@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Eukaryotic Cells@Animal?Viral@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Eukaryotic Cells@Animal?Microbial@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410,D6432",
	},
	"Eukaryotic Cells@Animal?Microbial@Total Nucleic Acid?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Eukaryotic Cells@Animal?Microbial@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Eukaryotic Cells@Animal?Microbial@Total Nucleic Acid?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Eukaryotic Cells@Animal?Microbial@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Eukaryotic Cells@Animal?Pathogen@Total Nucleic Acid?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Eukaryotic Cells@Animal?Pathogen@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
	},
	"Eukaryotic Cells@Animal?Pathogen@Total Nucleic Acid?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Eukaryotic Cells@Animal?Pathogen@Total Nucleic Acid?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Eukaryotic Cells@Animal?Pathogen@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Eukaryotic Cells@Animal?Pathogen@Total Nucleic Acid?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Eukaryotic Cells@Animal?Pathogen@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Eukaryotic Cells@Animal?Total@Total Nucleic Acid?DNA Methylation@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymo-seq-wgbs-library-kit,zymo-seq-rrbs-library-kit,pico-methyl-seq-library-prep-kit",
		"Application Kit Numbers":"D5465,D5460,D5461,D5455,D5456",
		"Application Kit 2 Handle":"ez-methylation-magprep-beads",
		"Application Kit 2 Numbers":"D4100-5-4,D4100-5-8,D4100-5-16",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Eukaryotic Cells@Animal?Total@Total Nucleic Acid?Chromatin Analysis@NGS": {
		"Application Kit Handle":"zymo-seq-atac-library-kit",
		"Application Kit Numbers":"D5458",
	},
	"Eukaryotic Cells@Animal?Total@Total Nucleic Acid?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Eukaryotic Cells@Animal?Total@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
	},
	"Eukaryotic Cells@Animal?Total@Total Nucleic Acid?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Eukaryotic Cells@Animal?Total@Total Nucleic Acid?DNA Methylation@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Application Kit 2 Handle":"ez-dna-methylation-lightning-automation-kit",
		"Application Kit 2 Numbers":"D5049",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Eukaryotic Cells@Animal?Total@Total Nucleic Acid?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Eukaryotic Cells@Animal?Total@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Eukaryotic Cells@Animal?Total@Total Nucleic Acid?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Eukaryotic Cells@Animal?Total@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Eukaryotic Cells@Animal?Viral@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
	},
	"Eukaryotic Cells@Animal?Viral@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Eukaryotic Cells@Animal?Viral@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Eukaryotic Cells@Animal?Microbial@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410,D6432",
	},
	"Eukaryotic Cells@Animal?Microbial@Fractional (DNA & RNA Separate)?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410",
	},
	"Eukaryotic Cells@Animal?Microbial@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Eukaryotic Cells@Animal?Microbial@Fractional (DNA & RNA Separate)?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Eukaryotic Cells@Animal?Microbial@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Eukaryotic Cells@Animal?Pathogen@Fractional (DNA & RNA Separate)?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Eukaryotic Cells@Animal?Pathogen@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
	},
	"Eukaryotic Cells@Animal?Pathogen@Fractional (DNA & RNA Separate)?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410",
	},
	"Eukaryotic Cells@Animal?Pathogen@Fractional (DNA & RNA Separate)?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Eukaryotic Cells@Animal?Pathogen@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Eukaryotic Cells@Animal?Pathogen@Fractional (DNA & RNA Separate)?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Eukaryotic Cells@Animal?Pathogen@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Eukaryotic Cells@Animal?Viral@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
	},
	"Eukaryotic Cells@Animal?Viral@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Eukaryotic Cells@Animal?Viral@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Eukaryotic Cells@Animal?Total@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
	},
	"Eukaryotic Cells@Animal?Total@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Eukaryotic Cells@Animal?Total@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Buffy Coat@Animal?High-Molecular Weight@DNA?DNA Methylation@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-hmw-magbead-kit",
		"Extraction/Purification Numbers":"D6060",
		"Application Kit Handle":"zymo-seq-wgbs-library-kit,zymo-seq-rrbs-library-kit,pico-methyl-seq-library-prep-kit",
		"Application Kit Numbers":"D5465,D5460,D5461,D5455,D5456",
		"Application Kit 2 Handle":"ez-methylation-magprep-beads",
		"Application Kit 2 Numbers":"D4100-5-4,D4100-5-8,D4100-5-16",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Buffy Coat@Animal?High-Molecular Weight@DNA?Chromatin Analysis@NGS": {
		"Application Kit Handle":"zymo-seq-atac-library-kit",
		"Application Kit Numbers":"D5458",
	},
	"Buffy Coat@Animal?High-Molecular Weight@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-hmw-magbead-kit",
		"Extraction/Purification Numbers":"D6060",
	},
	"Buffy Coat@Animal?High-Molecular Weight@DNA?DNA Methylation@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-hmw-magbead-kit",
		"Extraction/Purification Numbers":"D6060",
		"Application Kit Handle":"zymotaq-premix,zymotaq-dna-polymerase,zymotaq-qpcr-premix",
		"Application Kit Numbers":"E2003,E2004,E2001,E2002,E2054,E2055",
		"Application Kit 2 Handle":"ez-dna-methylation-lightning-automation-kit",
		"Application Kit 2 Numbers":"D5049",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Buffy Coat@Animal?High-Molecular Weight@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-hmw-magbead-kit",
		"Extraction/Purification Numbers":"D6060",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Buffy Coat@Animal?High-Molecular Weight@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Buffy Coat@Animal?Microbial@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Buffy Coat@Animal?Microbial@DNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Buffy Coat@Animal?Microbial@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Buffy Coat@Animal?Microbial@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Buffy Coat@Animal?Microbial@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Buffy Coat@Animal?Pathogen@DNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Buffy Coat@Animal?Pathogen@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
	},
	"Buffy Coat@Animal?Pathogen@DNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Buffy Coat@Animal?Pathogen@DNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Buffy Coat@Animal?Pathogen@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Buffy Coat@Animal?Pathogen@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Buffy Coat@Animal?Pathogen@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Buffy Coat@Animal?Total@DNA?DNA Methylation@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
		"Application Kit Handle":"zymo-seq-wgbs-library-kit,zymo-seq-rrbs-library-kit,pico-methyl-seq-library-prep-kit",
		"Application Kit Numbers":"D5465,D5460,D5461,D5455,D5456",
		"Application Kit 2 Handle":"ez-methylation-magprep-beads",
		"Application Kit 2 Numbers":"D4100-5-4,D4100-5-8,D4100-5-16",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Buffy Coat@Animal?Total@DNA?Chromatin Analysis@NGS": {
		"Application Kit Handle":"zymo-seq-atac-library-kit",
		"Application Kit Numbers":"D5458",
	},
	"Buffy Coat@Animal?Total@DNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
	},
	"Buffy Coat@Animal?Total@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
	},
	"Buffy Coat@Animal?Total@DNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Buffy Coat@Animal?Total@DNA?DNA Methylation@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
		"Application Kit Handle":"zymotaq-premix,zymotaq-dna-polymerase,zymotaq-qpcr-premix",
		"Application Kit Numbers":"E2003,E2004,E2001,E2002,E2054,E2055",
		"Application Kit 2 Handle":"ez-dna-methylation-lightning-automation-kit",
		"Application Kit 2 Numbers":"D5049",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Buffy Coat@Animal?Total@DNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Buffy Coat@Animal?Total@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Buffy Coat@Animal?Total@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Buffy Coat@Animal?Total@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Buffy Coat@Animal?Viral@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
	},
	"Buffy Coat@Animal?Viral@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Buffy Coat@Animal?Viral@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Buffy Coat@Animal?Microbial@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Buffy Coat@Animal?Microbial@RNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Buffy Coat@Animal?Microbial@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Buffy Coat@Animal?Microbial@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Buffy Coat@Animal?Microbial@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Buffy Coat@Animal?micro-RNA@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Buffy Coat@Animal?micro-RNA@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Buffy Coat@Animal?Pathogen@RNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Buffy Coat@Animal?Pathogen@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Buffy Coat@Animal?Pathogen@RNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Buffy Coat@Animal?Pathogen@RNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Buffy Coat@Animal?Pathogen@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Buffy Coat@Animal?Pathogen@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Buffy Coat@Animal?Pathogen@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Buffy Coat@Animal?Total@RNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Buffy Coat@Animal?Total@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Buffy Coat@Animal?Total@RNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Buffy Coat@Animal?Total@RNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Buffy Coat@Animal?Total@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Buffy Coat@Animal?Total@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Buffy Coat@Animal?Total@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Buffy Coat@Animal?Viral@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Buffy Coat@Animal?Viral@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Buffy Coat@Animal?Viral@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Buffy Coat@Animal?Microbial@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410,D6432",
	},
	"Buffy Coat@Animal?Microbial@Total Nucleic Acid?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Buffy Coat@Animal?Microbial@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Buffy Coat@Animal?Microbial@Total Nucleic Acid?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Buffy Coat@Animal?Microbial@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Buffy Coat@Animal?Pathogen@Total Nucleic Acid?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Buffy Coat@Animal?Pathogen@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
	},
	"Buffy Coat@Animal?Pathogen@Total Nucleic Acid?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Buffy Coat@Animal?Pathogen@Total Nucleic Acid?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Buffy Coat@Animal?Pathogen@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Buffy Coat@Animal?Pathogen@Total Nucleic Acid?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Buffy Coat@Animal?Pathogen@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Buffy Coat@Animal?Total@Total Nucleic Acid?DNA Methylation@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymo-seq-wgbs-library-kit,zymo-seq-rrbs-library-kit,pico-methyl-seq-library-prep-kit",
		"Application Kit Numbers":"D5465,D5460,D5461,D5455,D5456",
		"Application Kit 2 Handle":"ez-methylation-magprep-beads",
		"Application Kit 2 Numbers":"D4100-5-4,D4100-5-8,D4100-5-16",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Buffy Coat@Animal?Total@Total Nucleic Acid?Chromatin Analysis@NGS": {
		"Application Kit Handle":"zymo-seq-atac-library-kit",
		"Application Kit Numbers":"D5458",
	},
	"Buffy Coat@Animal?Total@Total Nucleic Acid?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Buffy Coat@Animal?Total@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
	},
	"Buffy Coat@Animal?Total@Total Nucleic Acid?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Buffy Coat@Animal?Total@Total Nucleic Acid?DNA Methylation@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Application Kit 2 Handle":"ez-dna-methylation-lightning-automation-kit",
		"Application Kit 2 Numbers":"D5049",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Buffy Coat@Animal?Total@Total Nucleic Acid?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Buffy Coat@Animal?Total@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Buffy Coat@Animal?Total@Total Nucleic Acid?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Buffy Coat@Animal?Total@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Buffy Coat@Animal?Viral@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
	},
	"Buffy Coat@Animal?Viral@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Buffy Coat@Animal?Viral@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Buffy Coat@Animal?Microbial@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410,D6432",
	},
	"Buffy Coat@Animal?Microbial@Fractional (DNA & RNA Separate)?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410",
	},
	"Buffy Coat@Animal?Microbial@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Buffy Coat@Animal?Microbial@Fractional (DNA & RNA Separate)?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Buffy Coat@Animal?Microbial@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Buffy Coat@Animal?Pathogen@Fractional (DNA & RNA Separate)?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Buffy Coat@Animal?Pathogen@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
	},
	"Buffy Coat@Animal?Pathogen@Fractional (DNA & RNA Separate)?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410",
	},
	"Buffy Coat@Animal?Pathogen@Fractional (DNA & RNA Separate)?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Buffy Coat@Animal?Pathogen@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Buffy Coat@Animal?Pathogen@Fractional (DNA & RNA Separate)?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Buffy Coat@Animal?Pathogen@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Buffy Coat@Animal?Viral@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
	},
	"Buffy Coat@Animal?Viral@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Buffy Coat@Animal?Viral@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Buffy Coat@Animal?Total@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
	},
	"Buffy Coat@Animal?Total@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Buffy Coat@Animal?Total@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Lymphocytes@Animal?High-Molecular Weight@DNA?DNA Methylation@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Extraction/Purification Handle":"quick-dna-hmw-magbead-kit",
		"Extraction/Purification Numbers":"D6060",
		"Application Kit Handle":"zymo-seq-wgbs-library-kit,zymo-seq-rrbs-library-kit,pico-methyl-seq-library-prep-kit",
		"Application Kit Numbers":"D5465,D5460,D5461,D5455,D5456",
		"Application Kit 2 Handle":"ez-methylation-magprep-beads",
		"Application Kit 2 Numbers":"D4100-5-4,D4100-5-8,D4100-5-16",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Lymphocytes@Animal?High-Molecular Weight@DNA?Chromatin Analysis@NGS": {
		"Application Kit Handle":"zymo-seq-atac-library-kit",
		"Application Kit Numbers":"D5458",
	},
	"Lymphocytes@Animal?High-Molecular Weight@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-hmw-magbead-kit",
		"Extraction/Purification Numbers":"D6060",
	},
	"Lymphocytes@Animal?High-Molecular Weight@DNA?DNA Methylation@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Extraction/Purification Handle":"quick-dna-hmw-magbead-kit",
		"Extraction/Purification Numbers":"D6060",
		"Application Kit Handle":"zymotaq-premix,zymotaq-dna-polymerase,zymotaq-qpcr-premix",
		"Application Kit Numbers":"E2003,E2004,E2001,E2002,E2054,E2055",
		"Application Kit 2 Handle":"ez-dna-methylation-lightning-automation-kit",
		"Application Kit 2 Numbers":"D5049",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Lymphocytes@Animal?High-Molecular Weight@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-hmw-magbead-kit",
		"Extraction/Purification Numbers":"D6060",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Lymphocytes@Animal?High-Molecular Weight@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Lymphocytes@Animal?Microbial@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Lymphocytes@Animal?Microbial@DNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Lymphocytes@Animal?Microbial@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Lymphocytes@Animal?Microbial@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Lymphocytes@Animal?Microbial@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Lymphocytes@Animal?Pathogen@DNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Lymphocytes@Animal?Pathogen@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
	},
	"Lymphocytes@Animal?Pathogen@DNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Lymphocytes@Animal?Pathogen@DNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Lymphocytes@Animal?Pathogen@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Lymphocytes@Animal?Pathogen@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Lymphocytes@Animal?Pathogen@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Lymphocytes@Animal?Total@DNA?DNA Methylation@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
		"Application Kit Handle":"zymo-seq-wgbs-library-kit,zymo-seq-rrbs-library-kit,pico-methyl-seq-library-prep-kit",
		"Application Kit Numbers":"D5465,D5460,D5461,D5455,D5456",
		"Application Kit 2 Handle":"ez-methylation-magprep-beads",
		"Application Kit 2 Numbers":"D4100-5-4,D4100-5-8,D4100-5-16",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Lymphocytes@Animal?Total@DNA?Chromatin Analysis@NGS": {
		"Application Kit Handle":"zymo-seq-atac-library-kit",
		"Application Kit Numbers":"D5458",
	},
	"Lymphocytes@Animal?Total@DNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
	},
	"Lymphocytes@Animal?Total@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
	},
	"Lymphocytes@Animal?Total@DNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Lymphocytes@Animal?Total@DNA?DNA Methylation@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
		"Application Kit Handle":"zymotaq-premix,zymotaq-dna-polymerase,zymotaq-qpcr-premix",
		"Application Kit Numbers":"E2003,E2004,E2001,E2002,E2054,E2055",
		"Application Kit 2 Handle":"ez-dna-methylation-lightning-automation-kit",
		"Application Kit 2 Numbers":"D5049",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Lymphocytes@Animal?Total@DNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Lymphocytes@Animal?Total@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Lymphocytes@Animal?Total@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Lymphocytes@Animal?Total@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Lymphocytes@Animal?Viral@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
	},
	"Lymphocytes@Animal?Viral@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Lymphocytes@Animal?Viral@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Lymphocytes@Animal?Microbial@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Lymphocytes@Animal?Microbial@RNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Lymphocytes@Animal?Microbial@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Lymphocytes@Animal?Microbial@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Lymphocytes@Animal?Microbial@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Lymphocytes@Animal?micro-RNA@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Lymphocytes@Animal?micro-RNA@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Lymphocytes@Animal?Pathogen@RNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Lymphocytes@Animal?Pathogen@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Lymphocytes@Animal?Pathogen@RNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Lymphocytes@Animal?Pathogen@RNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Lymphocytes@Animal?Pathogen@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Lymphocytes@Animal?Pathogen@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Lymphocytes@Animal?Pathogen@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Lymphocytes@Animal?Total@RNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Lymphocytes@Animal?Total@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Lymphocytes@Animal?Total@RNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Lymphocytes@Animal?Total@RNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Lymphocytes@Animal?Total@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Lymphocytes@Animal?Total@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Lymphocytes@Animal?Total@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Lymphocytes@Animal?Viral@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Lymphocytes@Animal?Viral@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Lymphocytes@Animal?Viral@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Lymphocytes@Animal?Microbial@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410,D6432",
	},
	"Lymphocytes@Animal?Microbial@Total Nucleic Acid?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Lymphocytes@Animal?Microbial@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Lymphocytes@Animal?Microbial@Total Nucleic Acid?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Lymphocytes@Animal?Microbial@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Lymphocytes@Animal?Pathogen@Total Nucleic Acid?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Lymphocytes@Animal?Pathogen@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
	},
	"Lymphocytes@Animal?Pathogen@Total Nucleic Acid?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Lymphocytes@Animal?Pathogen@Total Nucleic Acid?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Lymphocytes@Animal?Pathogen@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Lymphocytes@Animal?Pathogen@Total Nucleic Acid?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Lymphocytes@Animal?Pathogen@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Lymphocytes@Animal?Total@Total Nucleic Acid?DNA Methylation@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymo-seq-wgbs-library-kit,zymo-seq-rrbs-library-kit,pico-methyl-seq-library-prep-kit",
		"Application Kit Numbers":"D5465,D5460,D5461,D5455,D5456",
		"Application Kit 2 Handle":"ez-methylation-magprep-beads",
		"Application Kit 2 Numbers":"D4100-5-4,D4100-5-8,D4100-5-16",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Lymphocytes@Animal?Total@Total Nucleic Acid?Chromatin Analysis@NGS": {
		"Application Kit Handle":"zymo-seq-atac-library-kit",
		"Application Kit Numbers":"D5458",
	},
	"Lymphocytes@Animal?Total@Total Nucleic Acid?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Lymphocytes@Animal?Total@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
	},
	"Lymphocytes@Animal?Total@Total Nucleic Acid?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Lymphocytes@Animal?Total@Total Nucleic Acid?DNA Methylation@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Application Kit 2 Handle":"ez-dna-methylation-lightning-automation-kit",
		"Application Kit 2 Numbers":"D5049",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Lymphocytes@Animal?Total@Total Nucleic Acid?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Lymphocytes@Animal?Total@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Lymphocytes@Animal?Total@Total Nucleic Acid?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Lymphocytes@Animal?Total@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Lymphocytes@Animal?Viral@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
	},
	"Lymphocytes@Animal?Viral@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Lymphocytes@Animal?Viral@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Lymphocytes@Animal?Microbial@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410,D6432",
	},
	"Lymphocytes@Animal?Microbial@Fractional (DNA & RNA Separate)?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410",
	},
	"Lymphocytes@Animal?Microbial@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Lymphocytes@Animal?Microbial@Fractional (DNA & RNA Separate)?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Lymphocytes@Animal?Microbial@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Lymphocytes@Animal?Pathogen@Fractional (DNA & RNA Separate)?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Lymphocytes@Animal?Pathogen@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
	},
	"Lymphocytes@Animal?Pathogen@Fractional (DNA & RNA Separate)?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410",
	},
	"Lymphocytes@Animal?Pathogen@Fractional (DNA & RNA Separate)?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Lymphocytes@Animal?Pathogen@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Lymphocytes@Animal?Pathogen@Fractional (DNA & RNA Separate)?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Lymphocytes@Animal?Pathogen@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Lymphocytes@Animal?Viral@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
	},
	"Lymphocytes@Animal?Viral@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Lymphocytes@Animal?Viral@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Lymphocytes@Animal?Total@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
	},
	"Lymphocytes@Animal?Total@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Lymphocytes@Animal?Total@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Animal?High-Molecular Weight@DNA?DNA Methylation@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"quick-dna-hmw-magbead-kit",
		"Extraction/Purification Numbers":"D6060",
		"Application Kit Handle":"zymo-seq-wgbs-library-kit,zymo-seq-rrbs-library-kit,pico-methyl-seq-library-prep-kit",
		"Application Kit Numbers":"D5465,D5460,D5461,D5455,D5456",
		"Application Kit 2 Handle":"ez-methylation-magprep-beads",
		"Application Kit 2 Numbers":"D4100-5-4,D4100-5-8,D4100-5-16",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Animal?High-Molecular Weight@DNA?Chromatin Analysis@NGS": {
		"Application Kit Handle":"zymo-seq-atac-library-kit",
		"Application Kit Numbers":"D5458",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Animal?High-Molecular Weight@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"quick-dna-hmw-magbead-kit",
		"Extraction/Purification Numbers":"D6060",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Animal?High-Molecular Weight@DNA?DNA Methylation@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"quick-dna-hmw-magbead-kit",
		"Extraction/Purification Numbers":"D6060",
		"Application Kit Handle":"zymotaq-premix,zymotaq-dna-polymerase,zymotaq-qpcr-premix",
		"Application Kit Numbers":"E2003,E2004,E2001,E2002,E2054,E2055",
		"Application Kit 2 Handle":"ez-dna-methylation-lightning-automation-kit",
		"Application Kit 2 Numbers":"D5049",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Animal?High-Molecular Weight@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"quick-dna-hmw-magbead-kit",
		"Extraction/Purification Numbers":"D6060",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Animal?High-Molecular Weight@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Animal?Microbial@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Animal?Microbial@DNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Animal?Microbial@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Animal?Microbial@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Animal?Microbial@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Animal?Pathogen@DNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Animal?Pathogen@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Animal?Pathogen@DNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Animal?Pathogen@DNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Animal?Pathogen@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Animal?Pathogen@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Animal?Pathogen@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Animal?Total@DNA?DNA Methylation@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
		"Application Kit Handle":"zymo-seq-wgbs-library-kit,zymo-seq-rrbs-library-kit,pico-methyl-seq-library-prep-kit",
		"Application Kit Numbers":"D5465,D5460,D5461,D5455,D5456",
		"Application Kit 2 Handle":"ez-methylation-magprep-beads",
		"Application Kit 2 Numbers":"D4100-5-4,D4100-5-8,D4100-5-16",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Animal?Total@DNA?Chromatin Analysis@NGS": {
		"Application Kit Handle":"zymo-seq-atac-library-kit",
		"Application Kit Numbers":"D5458",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Animal?Total@DNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Animal?Total@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Animal?Total@DNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Animal?Total@DNA?DNA Methylation@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
		"Application Kit Handle":"zymotaq-premix,zymotaq-dna-polymerase,zymotaq-qpcr-premix",
		"Application Kit Numbers":"E2003,E2004,E2001,E2002,E2054,E2055",
		"Application Kit 2 Handle":"ez-dna-methylation-lightning-automation-kit",
		"Application Kit 2 Numbers":"D5049",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Animal?Total@DNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Animal?Total@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Animal?Total@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Animal?Total@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Animal?Viral@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Animal?Viral@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Animal?Viral@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Animal?Microbial@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Animal?Microbial@RNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Animal?Microbial@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Animal?Microbial@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Animal?Microbial@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Animal?micro-RNA@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Animal?micro-RNA@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Animal?Pathogen@RNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Animal?Pathogen@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Animal?Pathogen@RNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Animal?Pathogen@RNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Animal?Pathogen@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Animal?Pathogen@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Animal?Pathogen@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Animal?Total@RNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Animal?Total@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Animal?Total@RNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Animal?Total@RNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Animal?Total@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Animal?Total@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Animal?Total@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Animal?Viral@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Animal?Viral@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Animal?Viral@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Animal?Microbial@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410,D6432",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Animal?Microbial@Total Nucleic Acid?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Animal?Microbial@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Animal?Microbial@Total Nucleic Acid?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Animal?Microbial@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Animal?Pathogen@Total Nucleic Acid?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Animal?Pathogen@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Animal?Pathogen@Total Nucleic Acid?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Animal?Pathogen@Total Nucleic Acid?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Animal?Pathogen@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Animal?Pathogen@Total Nucleic Acid?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Animal?Pathogen@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Animal?Total@Total Nucleic Acid?DNA Methylation@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymo-seq-wgbs-library-kit,zymo-seq-rrbs-library-kit,pico-methyl-seq-library-prep-kit",
		"Application Kit Numbers":"D5465,D5460,D5461,D5455,D5456",
		"Application Kit 2 Handle":"ez-methylation-magprep-beads",
		"Application Kit 2 Numbers":"D4100-5-4,D4100-5-8,D4100-5-16",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Animal?Total@Total Nucleic Acid?Chromatin Analysis@NGS": {
		"Application Kit Handle":"zymo-seq-atac-library-kit",
		"Application Kit Numbers":"D5458",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Animal?Total@Total Nucleic Acid?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Animal?Total@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Animal?Total@Total Nucleic Acid?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Animal?Total@Total Nucleic Acid?DNA Methylation@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Application Kit 2 Handle":"ez-dna-methylation-lightning-automation-kit",
		"Application Kit 2 Numbers":"D5049",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Animal?Total@Total Nucleic Acid?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Animal?Total@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Animal?Total@Total Nucleic Acid?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Animal?Total@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Animal?Viral@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Animal?Viral@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Animal?Viral@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Animal?Microbial@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410,D6432",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Animal?Microbial@Fractional (DNA & RNA Separate)?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Animal?Microbial@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Animal?Microbial@Fractional (DNA & RNA Separate)?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Animal?Microbial@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Animal?Pathogen@Fractional (DNA & RNA Separate)?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Animal?Pathogen@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Animal?Pathogen@Fractional (DNA & RNA Separate)?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Animal?Pathogen@Fractional (DNA & RNA Separate)?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Animal?Pathogen@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Animal?Pathogen@Fractional (DNA & RNA Separate)?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Animal?Pathogen@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Animal?Viral@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Animal?Viral@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Animal?Viral@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Animal?Total@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Animal?Total@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Animal?Total@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Plasma@Animal?Cell-Free@DNA?DNA Methylation@NGS": {
		"Extraction/Purification Handle":"magicbead-cfdna-isolation-kit",
		"Extraction/Purification Numbers":"D4086",
		"Application Kit Handle":"zymo-seq-cell-free-dna-wgbs-library-kit",
		"Application Kit Numbers":"D5462,D5463",
		"Application Kit 2 Handle":"ez-methylation-magprep-beads",
		"Application Kit 2 Numbers":"D4100-5-4,D4100-5-8,D4100-5-16",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Plasma@Animal?Cell-Free@DNA?Fungal Sequencing@NGS": {
		"Extraction/Purification Handle":"magicbead-cfdna-isolation-kit",
		"Extraction/Purification Numbers":"D4086",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Plasma@Animal?Cell-Free@DNA?General/Other@NGS": {
		"Extraction/Purification Handle":"magicbead-cfdna-isolation-kit",
		"Extraction/Purification Numbers":"D4086",
		"Application Kit Handle":"zymo-seq-cell-free-dna-wgbs-library-kit",
		"Application Kit Numbers":"D5462,D5463",
	},
	"Plasma@Animal?Cell-Free@DNA?Microbial Sequencing@NGS": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"magicbead-cfdna-isolation-kit",
		"Extraction/Purification Numbers":"D4086",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Plasma@Animal?Cell-Free@DNA?DNA Methylation@PCR/rt-PCR": {
		"Extraction/Purification Handle":"magicbead-cfdna-isolation-kit",
		"Extraction/Purification Numbers":"D4086",
		"Application Kit Handle":"zymotaq-premix,zymotaq-dna-polymerase,zymotaq-qpcr-premix",
		"Application Kit Numbers":"E2003,E2004,E2001,E2002,E2054,E2055",
		"Application Kit 2 Handle":"ez-dna-methylation-lightning-automation-kit",
		"Application Kit 2 Numbers":"D5049",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Plasma@Animal?Cell-Free@DNA?Fungal Sequencing@PCR/rt-PCR": {
		"Extraction/Purification Handle":"magicbead-cfdna-isolation-kit",
		"Extraction/Purification Numbers":"D4086",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Plasma@Animal?Cell-Free@DNA?General/Other@PCR/rt-PCR": {
		"Extraction/Purification Handle":"magicbead-cfdna-isolation-kit",
		"Extraction/Purification Numbers":"D4086",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Plasma@Animal?Cell-Free@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"magicbead-cfdna-isolation-kit",
		"Extraction/Purification Numbers":"D4086",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Plasma@Animal?Cell-Free@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Plasma@Animal?Microbial@DNA?General/Other@NGS": {
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Plasma@Animal?Microbial@DNA?Microbial Sequencing@NGS": {
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Plasma@Animal?Microbial@DNA?General/Other@PCR/rt-PCR": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Plasma@Animal?Microbial@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Plasma@Animal?Microbial@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Plasma@Animal?Pathogen@DNA?Fungal Sequencing@NGS": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Plasma@Animal?Pathogen@DNA?General/Other@NGS": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
	},
	"Plasma@Animal?Pathogen@DNA?Microbial Sequencing@NGS": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Plasma@Animal?Pathogen@DNA?Fungal Sequencing@PCR/rt-PCR": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Plasma@Animal?Pathogen@DNA?General/Other@PCR/rt-PCR": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Plasma@Animal?Pathogen@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Plasma@Animal?Pathogen@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Plasma@Animal?Total@DNA?DNA Methylation@NGS": {
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
		"Application Kit Handle":"zymo-seq-wgbs-library-kit,zymo-seq-rrbs-library-kit,pico-methyl-seq-library-prep-kit",
		"Application Kit Numbers":"D5465,D5460,D5461,D5455,D5456",
		"Application Kit 2 Handle":"ez-methylation-magprep-beads",
		"Application Kit 2 Numbers":"D4100-5-4,D4100-5-8,D4100-5-16",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Plasma@Animal?Total@DNA?Chromatin Analysis@NGS": {
		"Application Kit Handle":"zymo-seq-atac-library-kit",
		"Application Kit Numbers":"D5458",
	},
	"Plasma@Animal?Total@DNA?Fungal Sequencing@NGS": {
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
	},
	"Plasma@Animal?Total@DNA?General/Other@NGS": {
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
	},
	"Plasma@Animal?Total@DNA?Microbial Sequencing@NGS": {
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Plasma@Animal?Total@DNA?DNA Methylation@PCR/rt-PCR": {
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
		"Application Kit Handle":"zymotaq-premix,zymotaq-dna-polymerase,zymotaq-qpcr-premix",
		"Application Kit Numbers":"E2003,E2004,E2001,E2002,E2054,E2055",
		"Application Kit 2 Handle":"ez-dna-methylation-lightning-automation-kit",
		"Application Kit 2 Numbers":"D5049",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Plasma@Animal?Total@DNA?Fungal Sequencing@PCR/rt-PCR": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Plasma@Animal?Total@DNA?General/Other@PCR/rt-PCR": {
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Plasma@Animal?Total@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Plasma@Animal?Total@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Plasma@Animal?Viral@DNA?General/Other@NGS": {
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
	},
	"Plasma@Animal?Viral@DNA?General/Other@PCR/rt-PCR": {
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Plasma@Animal?Viral@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Plasma@Animal?Microbial@RNA?General/Other@NGS": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Plasma@Animal?Microbial@RNA?Microbial Sequencing@NGS": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Plasma@Animal?Microbial@RNA?General/Other@PCR/rt-PCR": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Plasma@Animal?Microbial@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Plasma@Animal?Microbial@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Plasma@Animal?micro-RNA@RNA?General/Other@NGS": {
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Plasma@Animal?micro-RNA@RNA?General/Other@PCR/rt-PCR": {
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Plasma@Animal?Pathogen@RNA?Fungal Sequencing@NGS": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Plasma@Animal?Pathogen@RNA?General/Other@NGS": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Plasma@Animal?Pathogen@RNA?Microbial Sequencing@NGS": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Plasma@Animal?Pathogen@RNA?Fungal Sequencing@PCR/rt-PCR": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Plasma@Animal?Pathogen@RNA?General/Other@PCR/rt-PCR": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Plasma@Animal?Pathogen@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Plasma@Animal?Pathogen@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Plasma@Animal?Total@RNA?Fungal Sequencing@NGS": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Plasma@Animal?Total@RNA?General/Other@NGS": {
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Plasma@Animal?Total@RNA?Microbial Sequencing@NGS": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Plasma@Animal?Total@RNA?Fungal Sequencing@PCR/rt-PCR": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Plasma@Animal?Total@RNA?General/Other@PCR/rt-PCR": {
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Plasma@Animal?Total@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Plasma@Animal?Total@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Plasma@Animal?Viral@RNA?General/Other@NGS": {
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Plasma@Animal?Viral@RNA?General/Other@PCR/rt-PCR": {
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Plasma@Animal?Viral@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Plasma@Animal?Microbial@Total Nucleic Acid?General/Other@NGS": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410,D6432",
	},
	"Plasma@Animal?Microbial@Total Nucleic Acid?Microbial Sequencing@NGS": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Plasma@Animal?Microbial@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Plasma@Animal?Microbial@Total Nucleic Acid?Microbial Sequencing@PCR/rt-PCR": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Plasma@Animal?Microbial@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Plasma@Animal?Pathogen@Total Nucleic Acid?Fungal Sequencing@NGS": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Plasma@Animal?Pathogen@Total Nucleic Acid?General/Other@NGS": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
	},
	"Plasma@Animal?Pathogen@Total Nucleic Acid?Microbial Sequencing@NGS": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Plasma@Animal?Pathogen@Total Nucleic Acid?Fungal Sequencing@PCR/rt-PCR": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Plasma@Animal?Pathogen@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Plasma@Animal?Pathogen@Total Nucleic Acid?Microbial Sequencing@PCR/rt-PCR": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Plasma@Animal?Pathogen@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Plasma@Animal?Total@Total Nucleic Acid?DNA Methylation@NGS": {
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymo-seq-wgbs-library-kit,zymo-seq-rrbs-library-kit,pico-methyl-seq-library-prep-kit",
		"Application Kit Numbers":"D5465,D5460,D5461,D5455,D5456",
		"Application Kit 2 Handle":"ez-methylation-magprep-beads",
		"Application Kit 2 Numbers":"D4100-5-4,D4100-5-8,D4100-5-16",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Plasma@Animal?Total@Total Nucleic Acid?Chromatin Analysis@NGS": {
		"Application Kit Handle":"zymo-seq-atac-library-kit",
		"Application Kit Numbers":"D5458",
	},
	"Plasma@Animal?Total@Total Nucleic Acid?Fungal Sequencing@NGS": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Plasma@Animal?Total@Total Nucleic Acid?General/Other@NGS": {
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
	},
	"Plasma@Animal?Total@Total Nucleic Acid?Microbial Sequencing@NGS": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Plasma@Animal?Total@Total Nucleic Acid?DNA Methylation@PCR/rt-PCR": {
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Application Kit 2 Handle":"ez-dna-methylation-lightning-automation-kit",
		"Application Kit 2 Numbers":"D5049",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Plasma@Animal?Total@Total Nucleic Acid?Fungal Sequencing@PCR/rt-PCR": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Plasma@Animal?Total@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Plasma@Animal?Total@Total Nucleic Acid?Microbial Sequencing@PCR/rt-PCR": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Plasma@Animal?Total@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Plasma@Animal?Viral@Total Nucleic Acid?General/Other@NGS": {
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
	},
	"Plasma@Animal?Viral@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Plasma@Animal?Viral@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Plasma@Animal?Microbial@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410,D6432",
	},
	"Plasma@Animal?Microbial@Fractional (DNA & RNA Separate)?Microbial Sequencing@NGS": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410",
	},
	"Plasma@Animal?Microbial@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Plasma@Animal?Microbial@Fractional (DNA & RNA Separate)?Microbial Sequencing@PCR/rt-PCR": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Plasma@Animal?Microbial@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Plasma@Animal?Pathogen@Fractional (DNA & RNA Separate)?Fungal Sequencing@NGS": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Plasma@Animal?Pathogen@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
	},
	"Plasma@Animal?Pathogen@Fractional (DNA & RNA Separate)?Microbial Sequencing@NGS": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410",
	},
	"Plasma@Animal?Pathogen@Fractional (DNA & RNA Separate)?Fungal Sequencing@PCR/rt-PCR": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Plasma@Animal?Pathogen@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Plasma@Animal?Pathogen@Fractional (DNA & RNA Separate)?Microbial Sequencing@PCR/rt-PCR": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Plasma@Animal?Pathogen@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Plasma@Animal?Viral@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
	},
	"Plasma@Animal?Viral@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Plasma@Animal?Viral@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Plasma@Animal?Total@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
	},
	"Plasma@Animal?Total@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Plasma@Animal?Total@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Serum@Animal?Cell-Free@DNA?DNA Methylation@NGS": {
		"Extraction/Purification Handle":"magicbead-cfdna-isolation-kit",
		"Extraction/Purification Numbers":"D4086",
		"Application Kit Handle":"zymo-seq-cell-free-dna-wgbs-library-kit",
		"Application Kit Numbers":"D5462,D5463",
		"Application Kit 2 Handle":"ez-methylation-magprep-beads",
		"Application Kit 2 Numbers":"D4100-5-4,D4100-5-8,D4100-5-16",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Serum@Animal?Cell-Free@DNA?Fungal Sequencing@NGS": {
		"Extraction/Purification Handle":"magicbead-cfdna-isolation-kit",
		"Extraction/Purification Numbers":"D4086",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Serum@Animal?Cell-Free@DNA?General/Other@NGS": {
		"Extraction/Purification Handle":"magicbead-cfdna-isolation-kit",
		"Extraction/Purification Numbers":"D4086",
		"Application Kit Handle":"zymo-seq-cell-free-dna-wgbs-library-kit",
		"Application Kit Numbers":"D5462,D5463",
	},
	"Serum@Animal?Cell-Free@DNA?Microbial Sequencing@NGS": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"magicbead-cfdna-isolation-kit",
		"Extraction/Purification Numbers":"D4086",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Serum@Animal?Cell-Free@DNA?DNA Methylation@PCR/rt-PCR": {
		"Extraction/Purification Handle":"magicbead-cfdna-isolation-kit",
		"Extraction/Purification Numbers":"D4086",
		"Application Kit Handle":"zymotaq-premix,zymotaq-dna-polymerase,zymotaq-qpcr-premix",
		"Application Kit Numbers":"E2003,E2004,E2001,E2002,E2054,E2055",
		"Application Kit 2 Handle":"ez-dna-methylation-lightning-automation-kit",
		"Application Kit 2 Numbers":"D5049",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Serum@Animal?Cell-Free@DNA?Fungal Sequencing@PCR/rt-PCR": {
		"Extraction/Purification Handle":"magicbead-cfdna-isolation-kit",
		"Extraction/Purification Numbers":"D4086",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Serum@Animal?Cell-Free@DNA?General/Other@PCR/rt-PCR": {
		"Extraction/Purification Handle":"magicbead-cfdna-isolation-kit",
		"Extraction/Purification Numbers":"D4086",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Serum@Animal?Cell-Free@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"magicbead-cfdna-isolation-kit",
		"Extraction/Purification Numbers":"D4086",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Serum@Animal?Cell-Free@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Serum@Animal?Microbial@DNA?General/Other@NGS": {
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Serum@Animal?Microbial@DNA?Microbial Sequencing@NGS": {
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Serum@Animal?Microbial@DNA?General/Other@PCR/rt-PCR": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Serum@Animal?Microbial@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Serum@Animal?Microbial@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Serum@Animal?Pathogen@DNA?Fungal Sequencing@NGS": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Serum@Animal?Pathogen@DNA?General/Other@NGS": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
	},
	"Serum@Animal?Pathogen@DNA?Microbial Sequencing@NGS": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Serum@Animal?Pathogen@DNA?Fungal Sequencing@PCR/rt-PCR": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Serum@Animal?Pathogen@DNA?General/Other@PCR/rt-PCR": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Serum@Animal?Pathogen@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Serum@Animal?Pathogen@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Serum@Animal?Total@DNA?DNA Methylation@NGS": {
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
		"Application Kit Handle":"zymo-seq-wgbs-library-kit,zymo-seq-rrbs-library-kit,pico-methyl-seq-library-prep-kit",
		"Application Kit Numbers":"D5465,D5460,D5461,D5455,D5456",
		"Application Kit 2 Handle":"ez-methylation-magprep-beads",
		"Application Kit 2 Numbers":"D4100-5-4,D4100-5-8,D4100-5-16",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Serum@Animal?Total@DNA?Chromatin Analysis@NGS": {
		"Application Kit Handle":"zymo-seq-atac-library-kit",
		"Application Kit Numbers":"D5458",
	},
	"Serum@Animal?Total@DNA?Fungal Sequencing@NGS": {
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
	},
	"Serum@Animal?Total@DNA?General/Other@NGS": {
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
	},
	"Serum@Animal?Total@DNA?Microbial Sequencing@NGS": {
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Serum@Animal?Total@DNA?DNA Methylation@PCR/rt-PCR": {
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
		"Application Kit Handle":"zymotaq-premix,zymotaq-dna-polymerase,zymotaq-qpcr-premix",
		"Application Kit Numbers":"E2003,E2004,E2001,E2002,E2054,E2055",
		"Application Kit 2 Handle":"ez-dna-methylation-lightning-automation-kit",
		"Application Kit 2 Numbers":"D5049",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Serum@Animal?Total@DNA?Fungal Sequencing@PCR/rt-PCR": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Serum@Animal?Total@DNA?General/Other@PCR/rt-PCR": {
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Serum@Animal?Total@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Serum@Animal?Total@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Serum@Animal?Viral@DNA?General/Other@NGS": {
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
	},
	"Serum@Animal?Viral@DNA?General/Other@PCR/rt-PCR": {
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Serum@Animal?Viral@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Serum@Animal?Microbial@RNA?General/Other@NGS": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Serum@Animal?Microbial@RNA?Microbial Sequencing@NGS": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Serum@Animal?Microbial@RNA?General/Other@PCR/rt-PCR": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Serum@Animal?Microbial@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Serum@Animal?Microbial@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Serum@Animal?micro-RNA@RNA?General/Other@NGS": {
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Serum@Animal?micro-RNA@RNA?General/Other@PCR/rt-PCR": {
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Serum@Animal?Pathogen@RNA?Fungal Sequencing@NGS": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Serum@Animal?Pathogen@RNA?General/Other@NGS": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Serum@Animal?Pathogen@RNA?Microbial Sequencing@NGS": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Serum@Animal?Pathogen@RNA?Fungal Sequencing@PCR/rt-PCR": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Serum@Animal?Pathogen@RNA?General/Other@PCR/rt-PCR": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Serum@Animal?Pathogen@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Serum@Animal?Pathogen@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Serum@Animal?Total@RNA?Fungal Sequencing@NGS": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Serum@Animal?Total@RNA?General/Other@NGS": {
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Serum@Animal?Total@RNA?Microbial Sequencing@NGS": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Serum@Animal?Total@RNA?Fungal Sequencing@PCR/rt-PCR": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Serum@Animal?Total@RNA?General/Other@PCR/rt-PCR": {
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Serum@Animal?Total@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Serum@Animal?Total@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Serum@Animal?Viral@RNA?General/Other@NGS": {
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Serum@Animal?Viral@RNA?General/Other@PCR/rt-PCR": {
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Serum@Animal?Viral@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Serum@Animal?Microbial@Total Nucleic Acid?General/Other@NGS": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410,D6432",
	},
	"Serum@Animal?Microbial@Total Nucleic Acid?Microbial Sequencing@NGS": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Serum@Animal?Microbial@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Serum@Animal?Microbial@Total Nucleic Acid?Microbial Sequencing@PCR/rt-PCR": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Serum@Animal?Microbial@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Serum@Animal?Pathogen@Total Nucleic Acid?Fungal Sequencing@NGS": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Serum@Animal?Pathogen@Total Nucleic Acid?General/Other@NGS": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
	},
	"Serum@Animal?Pathogen@Total Nucleic Acid?Microbial Sequencing@NGS": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Serum@Animal?Pathogen@Total Nucleic Acid?Fungal Sequencing@PCR/rt-PCR": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Serum@Animal?Pathogen@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Serum@Animal?Pathogen@Total Nucleic Acid?Microbial Sequencing@PCR/rt-PCR": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Serum@Animal?Pathogen@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Serum@Animal?Total@Total Nucleic Acid?DNA Methylation@NGS": {
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymo-seq-wgbs-library-kit,zymo-seq-rrbs-library-kit,pico-methyl-seq-library-prep-kit",
		"Application Kit Numbers":"D5465,D5460,D5461,D5455,D5456",
		"Application Kit 2 Handle":"ez-methylation-magprep-beads",
		"Application Kit 2 Numbers":"D4100-5-4,D4100-5-8,D4100-5-16",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Serum@Animal?Total@Total Nucleic Acid?Chromatin Analysis@NGS": {
		"Application Kit Handle":"zymo-seq-atac-library-kit",
		"Application Kit Numbers":"D5458",
	},
	"Serum@Animal?Total@Total Nucleic Acid?Fungal Sequencing@NGS": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Serum@Animal?Total@Total Nucleic Acid?General/Other@NGS": {
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
	},
	"Serum@Animal?Total@Total Nucleic Acid?Microbial Sequencing@NGS": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Serum@Animal?Total@Total Nucleic Acid?DNA Methylation@PCR/rt-PCR": {
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Application Kit 2 Handle":"ez-dna-methylation-lightning-automation-kit",
		"Application Kit 2 Numbers":"D5049",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Serum@Animal?Total@Total Nucleic Acid?Fungal Sequencing@PCR/rt-PCR": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Serum@Animal?Total@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Serum@Animal?Total@Total Nucleic Acid?Microbial Sequencing@PCR/rt-PCR": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Serum@Animal?Total@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Serum@Animal?Viral@Total Nucleic Acid?General/Other@NGS": {
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
	},
	"Serum@Animal?Viral@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Serum@Animal?Viral@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Serum@Animal?Microbial@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410,D6432",
	},
	"Serum@Animal?Microbial@Fractional (DNA & RNA Separate)?Microbial Sequencing@NGS": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410",
	},
	"Serum@Animal?Microbial@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Serum@Animal?Microbial@Fractional (DNA & RNA Separate)?Microbial Sequencing@PCR/rt-PCR": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Serum@Animal?Microbial@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Serum@Animal?Pathogen@Fractional (DNA & RNA Separate)?Fungal Sequencing@NGS": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Serum@Animal?Pathogen@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
	},
	"Serum@Animal?Pathogen@Fractional (DNA & RNA Separate)?Microbial Sequencing@NGS": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410",
	},
	"Serum@Animal?Pathogen@Fractional (DNA & RNA Separate)?Fungal Sequencing@PCR/rt-PCR": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Serum@Animal?Pathogen@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Serum@Animal?Pathogen@Fractional (DNA & RNA Separate)?Microbial Sequencing@PCR/rt-PCR": {
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Serum@Animal?Pathogen@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Serum@Animal?Viral@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
	},
	"Serum@Animal?Viral@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Serum@Animal?Viral@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Serum@Animal?Total@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
	},
	"Serum@Animal?Total@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Serum@Animal?Total@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Milk@Animal?Cell-Free@DNA?DNA Methylation@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Extraction/Purification Handle":"magicbead-cfdna-isolation-kit",
		"Extraction/Purification Numbers":"D4086",
		"Application Kit Handle":"zymo-seq-cell-free-dna-wgbs-library-kit",
		"Application Kit Numbers":"D5462,D5463",
		"Application Kit 2 Handle":"ez-methylation-magprep-beads",
		"Application Kit 2 Numbers":"D4100-5-4,D4100-5-8,D4100-5-16",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Milk@Animal?Cell-Free@DNA?Fungal Sequencing@NGS": {
		"Extraction/Purification Handle":"magicbead-cfdna-isolation-kit",
		"Extraction/Purification Numbers":"D4086",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Milk@Animal?Cell-Free@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"magicbead-cfdna-isolation-kit",
		"Extraction/Purification Numbers":"D4086",
		"Application Kit Handle":"zymo-seq-cell-free-dna-wgbs-library-kit",
		"Application Kit Numbers":"D5462,D5463",
	},
	"Milk@Animal?Cell-Free@DNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"magicbead-cfdna-isolation-kit",
		"Extraction/Purification Numbers":"D4086",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Milk@Animal?Cell-Free@DNA?DNA Methylation@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Extraction/Purification Handle":"magicbead-cfdna-isolation-kit",
		"Extraction/Purification Numbers":"D4086",
		"Application Kit Handle":"zymotaq-premix,zymotaq-dna-polymerase,zymotaq-qpcr-premix",
		"Application Kit Numbers":"E2003,E2004,E2001,E2002,E2054,E2055",
		"Application Kit 2 Handle":"ez-dna-methylation-lightning-automation-kit",
		"Application Kit 2 Numbers":"D5049",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Milk@Animal?Cell-Free@DNA?Fungal Sequencing@PCR/rt-PCR": {
		"Extraction/Purification Handle":"magicbead-cfdna-isolation-kit",
		"Extraction/Purification Numbers":"D4086",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Milk@Animal?Cell-Free@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"magicbead-cfdna-isolation-kit",
		"Extraction/Purification Numbers":"D4086",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Milk@Animal?Cell-Free@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"magicbead-cfdna-isolation-kit",
		"Extraction/Purification Numbers":"D4086",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Milk@Animal?Cell-Free@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Milk@Animal?Microbial@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Milk@Animal?Microbial@DNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Milk@Animal?Microbial@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Milk@Animal?Microbial@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Milk@Animal?Microbial@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Milk@Animal?Pathogen@DNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Milk@Animal?Pathogen@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
	},
	"Milk@Animal?Pathogen@DNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Milk@Animal?Pathogen@DNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Milk@Animal?Pathogen@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Milk@Animal?Pathogen@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Milk@Animal?Pathogen@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Milk@Animal?Total@DNA?DNA Methylation@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
		"Application Kit Handle":"zymo-seq-wgbs-library-kit,zymo-seq-rrbs-library-kit,pico-methyl-seq-library-prep-kit",
		"Application Kit Numbers":"D5465,D5460,D5461,D5455,D5456",
		"Application Kit 2 Handle":"ez-methylation-magprep-beads",
		"Application Kit 2 Numbers":"D4100-5-4,D4100-5-8,D4100-5-16",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Milk@Animal?Total@DNA?Chromatin Analysis@NGS": {
		"Application Kit Handle":"zymo-seq-atac-library-kit",
		"Application Kit Numbers":"D5458",
	},
	"Milk@Animal?Total@DNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
	},
	"Milk@Animal?Total@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
	},
	"Milk@Animal?Total@DNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Milk@Animal?Total@DNA?DNA Methylation@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
		"Application Kit Handle":"zymotaq-premix,zymotaq-dna-polymerase,zymotaq-qpcr-premix",
		"Application Kit Numbers":"E2003,E2004,E2001,E2002,E2054,E2055",
		"Application Kit 2 Handle":"ez-dna-methylation-lightning-automation-kit",
		"Application Kit 2 Numbers":"D5049",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Milk@Animal?Total@DNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Milk@Animal?Total@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Milk@Animal?Total@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Milk@Animal?Total@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Milk@Animal?Viral@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
	},
	"Milk@Animal?Viral@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Milk@Animal?Viral@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Milk@Animal?Microbial@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Milk@Animal?Microbial@RNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Milk@Animal?Microbial@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Milk@Animal?Microbial@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Milk@Animal?Microbial@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Milk@Animal?micro-RNA@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Milk@Animal?micro-RNA@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Milk@Animal?Pathogen@RNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Milk@Animal?Pathogen@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Milk@Animal?Pathogen@RNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Milk@Animal?Pathogen@RNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Milk@Animal?Pathogen@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Milk@Animal?Pathogen@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Milk@Animal?Pathogen@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Milk@Animal?Total@RNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Milk@Animal?Total@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Milk@Animal?Total@RNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Milk@Animal?Total@RNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Milk@Animal?Total@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Milk@Animal?Total@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Milk@Animal?Total@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Milk@Animal?Viral@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Milk@Animal?Viral@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Milk@Animal?Viral@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Milk@Animal?Microbial@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410,D6432",
	},
	"Milk@Animal?Microbial@Total Nucleic Acid?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Milk@Animal?Microbial@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Milk@Animal?Microbial@Total Nucleic Acid?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Milk@Animal?Microbial@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Milk@Animal?Pathogen@Total Nucleic Acid?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Milk@Animal?Pathogen@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
	},
	"Milk@Animal?Pathogen@Total Nucleic Acid?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Milk@Animal?Pathogen@Total Nucleic Acid?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Milk@Animal?Pathogen@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Milk@Animal?Pathogen@Total Nucleic Acid?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Milk@Animal?Pathogen@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Milk@Animal?Total@Total Nucleic Acid?DNA Methylation@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymo-seq-wgbs-library-kit,zymo-seq-rrbs-library-kit,pico-methyl-seq-library-prep-kit",
		"Application Kit Numbers":"D5465,D5460,D5461,D5455,D5456",
		"Application Kit 2 Handle":"ez-methylation-magprep-beads",
		"Application Kit 2 Numbers":"D4100-5-4,D4100-5-8,D4100-5-16",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Milk@Animal?Total@Total Nucleic Acid?Chromatin Analysis@NGS": {
		"Application Kit Handle":"zymo-seq-atac-library-kit",
		"Application Kit Numbers":"D5458",
	},
	"Milk@Animal?Total@Total Nucleic Acid?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Milk@Animal?Total@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
	},
	"Milk@Animal?Total@Total Nucleic Acid?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Milk@Animal?Total@Total Nucleic Acid?DNA Methylation@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Application Kit 2 Handle":"ez-dna-methylation-lightning-automation-kit",
		"Application Kit 2 Numbers":"D5049",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Milk@Animal?Total@Total Nucleic Acid?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Milk@Animal?Total@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Milk@Animal?Total@Total Nucleic Acid?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Milk@Animal?Total@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Milk@Animal?Viral@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
	},
	"Milk@Animal?Viral@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Milk@Animal?Viral@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Milk@Animal?Microbial@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410,D6432",
	},
	"Milk@Animal?Microbial@Fractional (DNA & RNA Separate)?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410",
	},
	"Milk@Animal?Microbial@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Milk@Animal?Microbial@Fractional (DNA & RNA Separate)?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Milk@Animal?Microbial@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Milk@Animal?Pathogen@Fractional (DNA & RNA Separate)?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Milk@Animal?Pathogen@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
	},
	"Milk@Animal?Pathogen@Fractional (DNA & RNA Separate)?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410",
	},
	"Milk@Animal?Pathogen@Fractional (DNA & RNA Separate)?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Milk@Animal?Pathogen@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Milk@Animal?Pathogen@Fractional (DNA & RNA Separate)?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Milk@Animal?Pathogen@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Milk@Animal?Viral@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
	},
	"Milk@Animal?Viral@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Milk@Animal?Viral@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Milk@Animal?Total@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
	},
	"Milk@Animal?Total@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Milk@Animal?Total@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Fungus@Microbial?High-Molecular Weight@DNA?DNA Methylation@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-hmw-magbead-kit",
		"Extraction/Purification Numbers":"D6060",
		"Application Kit Handle":"zymo-seq-wgbs-library-kit,zymo-seq-rrbs-library-kit,pico-methyl-seq-library-prep-kit",
		"Application Kit Numbers":"D5465,D5460,D5461,D5455,D5456",
		"Application Kit 2 Handle":"ez-methylation-magprep-beads",
		"Application Kit 2 Numbers":"D4100-5-4,D4100-5-8,D4100-5-16",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Fungus@Microbial?High-Molecular Weight@DNA?Chromatin Analysis@NGS": {
		"Application Kit Handle":"zymo-seq-atac-library-kit",
		"Application Kit Numbers":"D5458",
	},
	"Fungus@Microbial?High-Molecular Weight@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-hmw-magbead-kit",
		"Extraction/Purification Numbers":"D6060",
	},
	"Fungus@Microbial?High-Molecular Weight@DNA?DNA Methylation@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-hmw-magbead-kit",
		"Extraction/Purification Numbers":"D6060",
		"Application Kit Handle":"zymotaq-premix,zymotaq-dna-polymerase,zymotaq-qpcr-premix",
		"Application Kit Numbers":"E2003,E2004,E2001,E2002,E2054,E2055",
		"Application Kit 2 Handle":"ez-dna-methylation-lightning-automation-kit",
		"Application Kit 2 Numbers":"D5049",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Fungus@Microbial?High-Molecular Weight@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-hmw-magbead-kit",
		"Extraction/Purification Numbers":"D6060",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Fungus@Microbial?High-Molecular Weight@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Fungus@Microbial?Microbial@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Fungus@Microbial?Microbial@DNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Fungus@Microbial?Microbial@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Fungus@Microbial?Microbial@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Fungus@Microbial?Microbial@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Fungus@Microbial?Pathogen@DNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Fungus@Microbial?Pathogen@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
	},
	"Fungus@Microbial?Pathogen@DNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Fungus@Microbial?Pathogen@DNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Fungus@Microbial?Pathogen@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Fungus@Microbial?Pathogen@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Fungus@Microbial?Pathogen@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Fungus@Microbial?Total@DNA?DNA Methylation@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"zymo-seq-wgbs-library-kit,zymo-seq-rrbs-library-kit,pico-methyl-seq-library-prep-kit",
		"Application Kit Numbers":"D5465,D5460,D5461,D5455,D5456",
		"Application Kit 2 Handle":"ez-methylation-magprep-beads",
		"Application Kit 2 Numbers":"D4100-5-4,D4100-5-8,D4100-5-16",
	},
	"Fungus@Microbial?Total@DNA?Chromatin Analysis@NGS": {
		"Application Kit Handle":"zymo-seq-atac-library-kit",
		"Application Kit Numbers":"D5458",
	},
	"Fungus@Microbial?Total@DNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
	},
	"Fungus@Microbial?Total@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
	},
	"Fungus@Microbial?Total@DNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Fungus@Microbial?Total@DNA?DNA Methylation@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymotaq-dna-polymerase,zymotaq-qpcr-premix",
		"Application Kit Numbers":"E2003,E2004,E2001,E2002,E2054,E2055",
		"Application Kit 2 Handle":"ez-dna-methylation-lightning-automation-kit",
		"Application Kit 2 Numbers":"D5049",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Fungus@Microbial?Total@DNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Fungus@Microbial?Total@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Fungus@Microbial?Total@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Fungus@Microbial?Total@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Fungus@Microbial?Viral@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
	},
	"Fungus@Microbial?Viral@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Fungus@Microbial?Viral@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Fungus@Microbial?Microbial@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Fungus@Microbial?Microbial@RNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Fungus@Microbial?Microbial@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Fungus@Microbial?Microbial@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Fungus@Microbial?Microbial@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Fungus@Microbial?micro-RNA@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Fungus@Microbial?micro-RNA@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Fungus@Microbial?Pathogen@RNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Fungus@Microbial?Pathogen@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Fungus@Microbial?Pathogen@RNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Fungus@Microbial?Pathogen@RNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Fungus@Microbial?Pathogen@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Fungus@Microbial?Pathogen@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Fungus@Microbial?Pathogen@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Fungus@Microbial?Total@RNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Fungus@Microbial?Total@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Fungus@Microbial?Total@RNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Fungus@Microbial?Total@RNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Fungus@Microbial?Total@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Fungus@Microbial?Total@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Fungus@Microbial?Total@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Fungus@Microbial?Viral@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Fungus@Microbial?Viral@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Fungus@Microbial?Viral@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Fungus@Microbial?Microbial@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410,D6432",
	},
	"Fungus@Microbial?Microbial@Total Nucleic Acid?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Fungus@Microbial?Microbial@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Fungus@Microbial?Microbial@Total Nucleic Acid?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Fungus@Microbial?Microbial@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Fungus@Microbial?Pathogen@Total Nucleic Acid?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Fungus@Microbial?Pathogen@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
	},
	"Fungus@Microbial?Pathogen@Total Nucleic Acid?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Fungus@Microbial?Pathogen@Total Nucleic Acid?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Fungus@Microbial?Pathogen@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Fungus@Microbial?Pathogen@Total Nucleic Acid?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Fungus@Microbial?Pathogen@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Fungus@Microbial?Total@Total Nucleic Acid?DNA Methylation@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-wgbs-library-kit,zymo-seq-rrbs-library-kit,pico-methyl-seq-library-prep-kit",
		"Application Kit Numbers":"D5465,D5460,D5461,D5455,D5456",
		"Application Kit 2 Handle":"ez-methylation-magprep-beads",
		"Application Kit 2 Numbers":"D4100-5-4,D4100-5-8,D4100-5-16",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Fungus@Microbial?Total@Total Nucleic Acid?Chromatin Analysis@NGS": {
		"Application Kit Handle":"zymo-seq-atac-library-kit",
		"Application Kit Numbers":"D5458",
	},
	"Fungus@Microbial?Total@Total Nucleic Acid?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Fungus@Microbial?Total@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
	},
	"Fungus@Microbial?Total@Total Nucleic Acid?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Fungus@Microbial?Total@Total Nucleic Acid?DNA Methylation@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Application Kit 2 Handle":"ez-dna-methylation-lightning-automation-kit",
		"Application Kit 2 Numbers":"D5049",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Fungus@Microbial?Total@Total Nucleic Acid?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Fungus@Microbial?Total@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Fungus@Microbial?Total@Total Nucleic Acid?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Fungus@Microbial?Total@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Fungus@Microbial?Viral@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
	},
	"Fungus@Microbial?Viral@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Fungus@Microbial?Viral@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Fungus@Microbial?Microbial@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410,D6432",
	},
	"Fungus@Microbial?Microbial@Fractional (DNA & RNA Separate)?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410",
	},
	"Fungus@Microbial?Microbial@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Fungus@Microbial?Microbial@Fractional (DNA & RNA Separate)?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Fungus@Microbial?Microbial@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Fungus@Microbial?Pathogen@Fractional (DNA & RNA Separate)?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Fungus@Microbial?Pathogen@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
	},
	"Fungus@Microbial?Pathogen@Fractional (DNA & RNA Separate)?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410",
	},
	"Fungus@Microbial?Pathogen@Fractional (DNA & RNA Separate)?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Fungus@Microbial?Pathogen@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Fungus@Microbial?Pathogen@Fractional (DNA & RNA Separate)?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Fungus@Microbial?Pathogen@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Fungus@Microbial?Viral@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
	},
	"Fungus@Microbial?Viral@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Fungus@Microbial?Viral@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Fungus@Microbial?Total@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
	},
	"Fungus@Microbial?Total@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Fungus@Microbial?Total@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Trizol@Microbial?Microbial@RNA?General/Other@NGS": {
		"Collection Handle":"tri-reagent",
		"Collection Numbers":"R2050-1-200",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"direct-zol-96-magbead-rna",
		"Extraction/Purification Numbers":"R2100,R2101,R2102,R2103",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Trizol@Microbial?Microbial@RNA?Microbial Sequencing@NGS": {
		"Collection Handle":"tri-reagent",
		"Collection Numbers":"R2050-1-200",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"direct-zol-96-magbead-rna",
		"Extraction/Purification Numbers":"R2100,R2101,R2102,R2103",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Trizol@Microbial?Microbial@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"tri-reagent",
		"Collection Numbers":"R2050-1-200",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"direct-zol-96-magbead-rna",
		"Extraction/Purification Numbers":"R2100,R2101,R2102,R2103",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Trizol@Microbial?Microbial@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"tri-reagent",
		"Collection Numbers":"R2050-1-200",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"direct-zol-96-magbead-rna",
		"Extraction/Purification Numbers":"R2100,R2101,R2102,R2103",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Trizol@Microbial?Microbial@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Trizol@Microbial?micro-RNA@RNA?General/Other@NGS": {
		"Collection Handle":"tri-reagent",
		"Collection Numbers":"R2050-1-200",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Trizol@Microbial?micro-RNA@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"tri-reagent",
		"Collection Numbers":"R2050-1-200",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Trizol@Microbial?Pathogen@RNA?Fungal Sequencing@NGS": {
		"Collection Handle":"tri-reagent",
		"Collection Numbers":"R2050-1-200",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Trizol@Microbial?Pathogen@RNA?General/Other@NGS": {
		"Collection Handle":"tri-reagent",
		"Collection Numbers":"R2050-1-200",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Trizol@Microbial?Pathogen@RNA?Microbial Sequencing@NGS": {
		"Collection Handle":"tri-reagent",
		"Collection Numbers":"R2050-1-200",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Trizol@Microbial?Pathogen@RNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"tri-reagent",
		"Collection Numbers":"R2050-1-200",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Trizol@Microbial?Pathogen@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"tri-reagent",
		"Collection Numbers":"R2050-1-200",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Trizol@Microbial?Pathogen@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"tri-reagent",
		"Collection Numbers":"R2050-1-200",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Trizol@Microbial?Pathogen@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Trizol@Microbial?Total@RNA?Fungal Sequencing@NGS": {
		"Collection Handle":"tri-reagent",
		"Collection Numbers":"R2050-1-200",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"direct-zol-96-magbead-rna",
		"Extraction/Purification Numbers":"R2100,R2101,R2102,R2103",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Trizol@Microbial?Total@RNA?General/Other@NGS": {
		"Collection Handle":"tri-reagent",
		"Collection Numbers":"R2050-1-200",
		"Extraction/Purification Handle":"direct-zol-96-magbead-rna",
		"Extraction/Purification Numbers":"R2100,R2101,R2102,R2103",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Trizol@Microbial?Total@RNA?Microbial Sequencing@NGS": {
		"Collection Handle":"tri-reagent",
		"Collection Numbers":"R2050-1-200",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"direct-zol-96-magbead-rna",
		"Extraction/Purification Numbers":"R2100,R2101,R2102,R2103",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Trizol@Microbial?Total@RNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"tri-reagent",
		"Collection Numbers":"R2050-1-200",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"direct-zol-96-magbead-rna",
		"Extraction/Purification Numbers":"R2100,R2101,R2102,R2103",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Trizol@Microbial?Total@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"tri-reagent",
		"Collection Numbers":"R2050-1-200",
		"Extraction/Purification Handle":"direct-zol-96-magbead-rna",
		"Extraction/Purification Numbers":"R2100,R2101,R2102,R2103",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Trizol@Microbial?Total@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"tri-reagent",
		"Collection Numbers":"R2050-1-200",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"direct-zol-96-magbead-rna",
		"Extraction/Purification Numbers":"R2100,R2101,R2102,R2103",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Trizol@Microbial?Total@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Trizol@Microbial?Viral@RNA?General/Other@NGS": {
		"Collection Handle":"tri-reagent",
		"Collection Numbers":"R2050-1-200",
		"Extraction/Purification Handle":"direct-zol-96-magbead-rna",
		"Extraction/Purification Numbers":"R2100,R2101,R2102,R2103",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Trizol@Microbial?Viral@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"tri-reagent",
		"Collection Numbers":"R2050-1-200",
		"Extraction/Purification Handle":"direct-zol-96-magbead-rna",
		"Extraction/Purification Numbers":"R2100,R2101,R2102,R2103",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Trizol@Microbial?Viral@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Bacterial Culture@Microbial?Microbial@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Bacterial Culture@Microbial?Microbial@DNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Bacterial Culture@Microbial?Microbial@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Bacterial Culture@Microbial?Microbial@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Bacterial Culture@Microbial?Microbial@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Bacterial Culture@Microbial?Pathogen@DNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Bacterial Culture@Microbial?Pathogen@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
	},
	"Bacterial Culture@Microbial?Pathogen@DNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Bacterial Culture@Microbial?Pathogen@DNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Bacterial Culture@Microbial?Pathogen@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Bacterial Culture@Microbial?Pathogen@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Bacterial Culture@Microbial?Pathogen@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Bacterial Culture@Microbial?Total@DNA?DNA Methylation@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"zymo-seq-wgbs-library-kit,zymo-seq-rrbs-library-kit,pico-methyl-seq-library-prep-kit",
		"Application Kit Numbers":"D5465,D5460,D5461,D5455,D5456",
		"Application Kit 2 Handle":"ez-methylation-magprep-beads",
		"Application Kit 2 Numbers":"D4100-5-4,D4100-5-8,D4100-5-16",
	},
	"Bacterial Culture@Microbial?Total@DNA?Chromatin Analysis@NGS": {
		"Application Kit Handle":"zymo-seq-atac-library-kit",
		"Application Kit Numbers":"D5458",
	},
	"Bacterial Culture@Microbial?Total@DNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
	},
	"Bacterial Culture@Microbial?Total@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
	},
	"Bacterial Culture@Microbial?Total@DNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Bacterial Culture@Microbial?Total@DNA?DNA Methylation@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymotaq-dna-polymerase,zymotaq-qpcr-premix",
		"Application Kit Numbers":"E2003,E2004,E2001,E2002,E2054,E2055",
		"Application Kit 2 Handle":"ez-dna-methylation-lightning-automation-kit",
		"Application Kit 2 Numbers":"D5049",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Bacterial Culture@Microbial?Total@DNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Bacterial Culture@Microbial?Total@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Bacterial Culture@Microbial?Total@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Bacterial Culture@Microbial?Total@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Bacterial Culture@Microbial?Viral@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
	},
	"Bacterial Culture@Microbial?Viral@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Bacterial Culture@Microbial?Viral@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Bacterial Culture@Microbial?Microbial@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Bacterial Culture@Microbial?Microbial@RNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Bacterial Culture@Microbial?Microbial@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Bacterial Culture@Microbial?Microbial@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Bacterial Culture@Microbial?Microbial@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Bacterial Culture@Microbial?micro-RNA@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Bacterial Culture@Microbial?micro-RNA@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Bacterial Culture@Microbial?Pathogen@RNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Bacterial Culture@Microbial?Pathogen@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Bacterial Culture@Microbial?Pathogen@RNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Bacterial Culture@Microbial?Pathogen@RNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Bacterial Culture@Microbial?Pathogen@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Bacterial Culture@Microbial?Pathogen@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Bacterial Culture@Microbial?Pathogen@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Bacterial Culture@Microbial?Total@RNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Bacterial Culture@Microbial?Total@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Bacterial Culture@Microbial?Total@RNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Bacterial Culture@Microbial?Total@RNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Bacterial Culture@Microbial?Total@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Bacterial Culture@Microbial?Total@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Bacterial Culture@Microbial?Total@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Bacterial Culture@Microbial?Viral@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Bacterial Culture@Microbial?Viral@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Bacterial Culture@Microbial?Viral@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Bacterial Culture@Microbial?Microbial@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410,D6432",
	},
	"Bacterial Culture@Microbial?Microbial@Total Nucleic Acid?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Bacterial Culture@Microbial?Microbial@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Bacterial Culture@Microbial?Microbial@Total Nucleic Acid?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Bacterial Culture@Microbial?Microbial@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Bacterial Culture@Microbial?Pathogen@Total Nucleic Acid?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Bacterial Culture@Microbial?Pathogen@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
	},
	"Bacterial Culture@Microbial?Pathogen@Total Nucleic Acid?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Bacterial Culture@Microbial?Pathogen@Total Nucleic Acid?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Bacterial Culture@Microbial?Pathogen@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Bacterial Culture@Microbial?Pathogen@Total Nucleic Acid?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Bacterial Culture@Microbial?Pathogen@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Bacterial Culture@Microbial?Total@Total Nucleic Acid?DNA Methylation@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-wgbs-library-kit,zymo-seq-rrbs-library-kit,pico-methyl-seq-library-prep-kit",
		"Application Kit Numbers":"D5465,D5460,D5461,D5455,D5456",
		"Application Kit 2 Handle":"ez-methylation-magprep-beads",
		"Application Kit 2 Numbers":"D4100-5-4,D4100-5-8,D4100-5-16",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Bacterial Culture@Microbial?Total@Total Nucleic Acid?Chromatin Analysis@NGS": {
		"Application Kit Handle":"zymo-seq-atac-library-kit",
		"Application Kit Numbers":"D5458",
	},
	"Bacterial Culture@Microbial?Total@Total Nucleic Acid?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Bacterial Culture@Microbial?Total@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
	},
	"Bacterial Culture@Microbial?Total@Total Nucleic Acid?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Bacterial Culture@Microbial?Total@Total Nucleic Acid?DNA Methylation@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Application Kit 2 Handle":"ez-dna-methylation-lightning-automation-kit",
		"Application Kit 2 Numbers":"D5049",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Bacterial Culture@Microbial?Total@Total Nucleic Acid?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Bacterial Culture@Microbial?Total@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Bacterial Culture@Microbial?Total@Total Nucleic Acid?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Bacterial Culture@Microbial?Total@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Bacterial Culture@Microbial?Viral@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
	},
	"Bacterial Culture@Microbial?Viral@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Bacterial Culture@Microbial?Viral@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Bacterial Culture@Microbial?Microbial@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410,D6432",
	},
	"Bacterial Culture@Microbial?Microbial@Fractional (DNA & RNA Separate)?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410",
	},
	"Bacterial Culture@Microbial?Microbial@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Bacterial Culture@Microbial?Microbial@Fractional (DNA & RNA Separate)?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Bacterial Culture@Microbial?Microbial@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Bacterial Culture@Microbial?Pathogen@Fractional (DNA & RNA Separate)?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Bacterial Culture@Microbial?Pathogen@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
	},
	"Bacterial Culture@Microbial?Pathogen@Fractional (DNA & RNA Separate)?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410",
	},
	"Bacterial Culture@Microbial?Pathogen@Fractional (DNA & RNA Separate)?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Bacterial Culture@Microbial?Pathogen@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Bacterial Culture@Microbial?Pathogen@Fractional (DNA & RNA Separate)?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Bacterial Culture@Microbial?Pathogen@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Bacterial Culture@Microbial?Viral@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
	},
	"Bacterial Culture@Microbial?Viral@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Bacterial Culture@Microbial?Viral@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Bacterial Culture@Microbial?Total@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
	},
	"Bacterial Culture@Microbial?Total@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Bacterial Culture@Microbial?Total@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Yeast@Microbial?Microbial@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Yeast@Microbial?Microbial@DNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Yeast@Microbial?Microbial@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Yeast@Microbial?Microbial@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Yeast@Microbial?Microbial@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Yeast@Microbial?Total@DNA?DNA Methylation@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"zymo-seq-wgbs-library-kit,zymo-seq-rrbs-library-kit,pico-methyl-seq-library-prep-kit",
		"Application Kit Numbers":"D5465,D5460,D5461,D5455,D5456",
		"Application Kit 2 Handle":"ez-methylation-magprep-beads",
		"Application Kit 2 Numbers":"D4100-5-4,D4100-5-8,D4100-5-16",
	},
	"Yeast@Microbial?Total@DNA?Chromatin Analysis@NGS": {
		"Application Kit Handle":"zymo-seq-atac-library-kit",
		"Application Kit Numbers":"D5458",
	},
	"Yeast@Microbial?Total@DNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
	},
	"Yeast@Microbial?Total@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
	},
	"Yeast@Microbial?Total@DNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Yeast@Microbial?Total@DNA?DNA Methylation@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymotaq-dna-polymerase,zymotaq-qpcr-premix",
		"Application Kit Numbers":"E2003,E2004,E2001,E2002,E2054,E2055",
		"Application Kit 2 Handle":"ez-dna-methylation-lightning-automation-kit",
		"Application Kit 2 Numbers":"D5049",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Yeast@Microbial?Total@DNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Yeast@Microbial?Total@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Yeast@Microbial?Total@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Yeast@Microbial?Total@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Yeast@Microbial?Microbial@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Yeast@Microbial?Microbial@RNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Yeast@Microbial?Microbial@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Yeast@Microbial?Microbial@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Yeast@Microbial?Microbial@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Yeast@Microbial?Total@RNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Yeast@Microbial?Total@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Yeast@Microbial?Total@RNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Yeast@Microbial?Total@RNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Yeast@Microbial?Total@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Yeast@Microbial?Total@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Yeast@Microbial?Total@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Yeast@Microbial?Microbial@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410,D6432",
	},
	"Yeast@Microbial?Microbial@Total Nucleic Acid?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Yeast@Microbial?Microbial@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Yeast@Microbial?Microbial@Total Nucleic Acid?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Yeast@Microbial?Microbial@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Yeast@Microbial?Total@Total Nucleic Acid?DNA Methylation@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-wgbs-library-kit,zymo-seq-rrbs-library-kit,pico-methyl-seq-library-prep-kit",
		"Application Kit Numbers":"D5465,D5460,D5461,D5455,D5456",
		"Application Kit 2 Handle":"ez-methylation-magprep-beads",
		"Application Kit 2 Numbers":"D4100-5-4,D4100-5-8,D4100-5-16",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Yeast@Microbial?Total@Total Nucleic Acid?Chromatin Analysis@NGS": {
		"Application Kit Handle":"zymo-seq-atac-library-kit",
		"Application Kit Numbers":"D5458",
	},
	"Yeast@Microbial?Total@Total Nucleic Acid?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Yeast@Microbial?Total@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410,D6432",
	},
	"Yeast@Microbial?Total@Total Nucleic Acid?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Yeast@Microbial?Total@Total Nucleic Acid?DNA Methylation@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Application Kit 2 Handle":"ez-dna-methylation-lightning-automation-kit",
		"Application Kit 2 Numbers":"D5049",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Yeast@Microbial?Total@Total Nucleic Acid?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Yeast@Microbial?Total@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Yeast@Microbial?Total@Total Nucleic Acid?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Yeast@Microbial?Total@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Yeast@Microbial?Microbial@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410,D6432",
	},
	"Yeast@Microbial?Microbial@Fractional (DNA & RNA Separate)?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410",
	},
	"Yeast@Microbial?Microbial@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Yeast@Microbial?Microbial@Fractional (DNA & RNA Separate)?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Yeast@Microbial?Microbial@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Yeast@Microbial?Total@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
	},
	"Yeast@Microbial?Total@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Yeast@Microbial?Total@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Waste Water@Microbial?Microbial@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Waste Water@Microbial?Microbial@DNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Waste Water@Microbial?Microbial@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Waste Water@Microbial?Microbial@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Waste Water@Microbial?Microbial@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Waste Water@Microbial?Pathogen@DNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Waste Water@Microbial?Pathogen@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
	},
	"Waste Water@Microbial?Pathogen@DNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Waste Water@Microbial?Pathogen@DNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Waste Water@Microbial?Pathogen@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Waste Water@Microbial?Pathogen@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Waste Water@Microbial?Pathogen@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Waste Water@Microbial?Total@DNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
	},
	"Waste Water@Microbial?Total@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
	},
	"Waste Water@Microbial?Total@DNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Waste Water@Microbial?Total@DNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Waste Water@Microbial?Total@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Waste Water@Microbial?Total@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Waste Water@Microbial?Total@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Waste Water@Microbial?Viral@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
	},
	"Waste Water@Microbial?Viral@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Waste Water@Microbial?Viral@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Waste Water@Microbial?Microbial@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Waste Water@Microbial?Microbial@RNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Waste Water@Microbial?Microbial@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Waste Water@Microbial?Microbial@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Waste Water@Microbial?Microbial@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Waste Water@Microbial?micro-RNA@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Waste Water@Microbial?micro-RNA@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Waste Water@Microbial?Pathogen@RNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Waste Water@Microbial?Pathogen@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Waste Water@Microbial?Pathogen@RNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Waste Water@Microbial?Pathogen@RNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Waste Water@Microbial?Pathogen@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Waste Water@Microbial?Pathogen@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Waste Water@Microbial?Pathogen@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Waste Water@Microbial?Total@RNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Waste Water@Microbial?Total@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Waste Water@Microbial?Total@RNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Waste Water@Microbial?Total@RNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Waste Water@Microbial?Total@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Waste Water@Microbial?Total@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Waste Water@Microbial?Total@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Waste Water@Microbial?Viral@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Waste Water@Microbial?Viral@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Waste Water@Microbial?Viral@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Waste Water@Microbial?Microbial@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410,D6432",
	},
	"Waste Water@Microbial?Microbial@Total Nucleic Acid?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Waste Water@Microbial?Microbial@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Waste Water@Microbial?Microbial@Total Nucleic Acid?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Waste Water@Microbial?Microbial@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Waste Water@Microbial?Pathogen@Total Nucleic Acid?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Waste Water@Microbial?Pathogen@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
	},
	"Waste Water@Microbial?Pathogen@Total Nucleic Acid?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Waste Water@Microbial?Pathogen@Total Nucleic Acid?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Waste Water@Microbial?Pathogen@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Waste Water@Microbial?Pathogen@Total Nucleic Acid?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Waste Water@Microbial?Pathogen@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Waste Water@Microbial?Total@Total Nucleic Acid?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Waste Water@Microbial?Total@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
	},
	"Waste Water@Microbial?Total@Total Nucleic Acid?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Waste Water@Microbial?Total@Total Nucleic Acid?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Waste Water@Microbial?Total@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Waste Water@Microbial?Total@Total Nucleic Acid?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Waste Water@Microbial?Total@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Waste Water@Microbial?Viral@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
	},
	"Waste Water@Microbial?Viral@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Waste Water@Microbial?Viral@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Waste Water@Microbial?Microbial@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410,D6432",
	},
	"Waste Water@Microbial?Microbial@Fractional (DNA & RNA Separate)?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410",
	},
	"Waste Water@Microbial?Microbial@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Waste Water@Microbial?Microbial@Fractional (DNA & RNA Separate)?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Waste Water@Microbial?Microbial@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Waste Water@Microbial?Pathogen@Fractional (DNA & RNA Separate)?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Waste Water@Microbial?Pathogen@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
	},
	"Waste Water@Microbial?Pathogen@Fractional (DNA & RNA Separate)?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410",
	},
	"Waste Water@Microbial?Pathogen@Fractional (DNA & RNA Separate)?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Waste Water@Microbial?Pathogen@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Waste Water@Microbial?Pathogen@Fractional (DNA & RNA Separate)?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Waste Water@Microbial?Pathogen@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Waste Water@Microbial?Viral@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
	},
	"Waste Water@Microbial?Viral@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Waste Water@Microbial?Viral@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Waste Water@Microbial?Total@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
	},
	"Waste Water@Microbial?Total@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Waste Water@Microbial?Total@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Soil@Microbial?Microbial@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Soil@Microbial?Microbial@DNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Soil@Microbial?Microbial@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Soil@Microbial?Microbial@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Soil@Microbial?Microbial@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Soil@Microbial?Pathogen@DNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Soil@Microbial?Pathogen@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
	},
	"Soil@Microbial?Pathogen@DNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Soil@Microbial?Pathogen@DNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Soil@Microbial?Pathogen@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Soil@Microbial?Pathogen@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Soil@Microbial?Pathogen@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Soil@Microbial?Total@DNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
	},
	"Soil@Microbial?Total@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
	},
	"Soil@Microbial?Total@DNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Soil@Microbial?Total@DNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Soil@Microbial?Total@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Soil@Microbial?Total@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Soil@Microbial?Total@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Soil@Microbial?Viral@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
	},
	"Soil@Microbial?Viral@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Soil@Microbial?Viral@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Soil@Microbial?Microbial@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Soil@Microbial?Microbial@RNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Soil@Microbial?Microbial@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Soil@Microbial?Microbial@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Soil@Microbial?Microbial@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Soil@Microbial?micro-RNA@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Soil@Microbial?micro-RNA@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Soil@Microbial?Pathogen@RNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Soil@Microbial?Pathogen@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Soil@Microbial?Pathogen@RNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Soil@Microbial?Pathogen@RNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Soil@Microbial?Pathogen@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Soil@Microbial?Pathogen@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Soil@Microbial?Pathogen@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Soil@Microbial?Total@RNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Soil@Microbial?Total@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Soil@Microbial?Total@RNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Soil@Microbial?Total@RNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Soil@Microbial?Total@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Soil@Microbial?Total@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Soil@Microbial?Total@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Soil@Microbial?Viral@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Soil@Microbial?Viral@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Soil@Microbial?Viral@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Soil@Microbial?Microbial@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410,D6432",
	},
	"Soil@Microbial?Microbial@Total Nucleic Acid?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Soil@Microbial?Microbial@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Soil@Microbial?Microbial@Total Nucleic Acid?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Soil@Microbial?Microbial@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Soil@Microbial?Pathogen@Total Nucleic Acid?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Soil@Microbial?Pathogen@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
	},
	"Soil@Microbial?Pathogen@Total Nucleic Acid?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Soil@Microbial?Pathogen@Total Nucleic Acid?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Soil@Microbial?Pathogen@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Soil@Microbial?Pathogen@Total Nucleic Acid?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Soil@Microbial?Pathogen@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Soil@Microbial?Total@Total Nucleic Acid?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Soil@Microbial?Total@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
	},
	"Soil@Microbial?Total@Total Nucleic Acid?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Soil@Microbial?Total@Total Nucleic Acid?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Soil@Microbial?Total@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Soil@Microbial?Total@Total Nucleic Acid?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Soil@Microbial?Total@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Soil@Microbial?Viral@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
	},
	"Soil@Microbial?Viral@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Soil@Microbial?Viral@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Soil@Microbial?Microbial@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410,D6432",
	},
	"Soil@Microbial?Microbial@Fractional (DNA & RNA Separate)?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410",
	},
	"Soil@Microbial?Microbial@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Soil@Microbial?Microbial@Fractional (DNA & RNA Separate)?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Soil@Microbial?Microbial@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Soil@Microbial?Pathogen@Fractional (DNA & RNA Separate)?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Soil@Microbial?Pathogen@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
	},
	"Soil@Microbial?Pathogen@Fractional (DNA & RNA Separate)?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410",
	},
	"Soil@Microbial?Pathogen@Fractional (DNA & RNA Separate)?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Soil@Microbial?Pathogen@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Soil@Microbial?Pathogen@Fractional (DNA & RNA Separate)?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Soil@Microbial?Pathogen@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Soil@Microbial?Viral@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
	},
	"Soil@Microbial?Viral@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Soil@Microbial?Viral@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Soil@Microbial?Total@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
	},
	"Soil@Microbial?Total@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Soil@Microbial?Total@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Microbial?High-Molecular Weight@DNA?DNA Methylation@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"quick-dna-hmw-magbead-kit",
		"Extraction/Purification Numbers":"D6060",
		"Application Kit Handle":"zymo-seq-wgbs-library-kit,zymo-seq-rrbs-library-kit,pico-methyl-seq-library-prep-kit",
		"Application Kit Numbers":"D5465,D5460,D5461,D5455,D5456",
		"Application Kit 2 Handle":"ez-methylation-magprep-beads",
		"Application Kit 2 Numbers":"D4100-5-4,D4100-5-8,D4100-5-16",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Microbial?High-Molecular Weight@DNA?Chromatin Analysis@NGS": {
		"Application Kit Handle":"zymo-seq-atac-library-kit",
		"Application Kit Numbers":"D5458",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Microbial?High-Molecular Weight@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"quick-dna-hmw-magbead-kit",
		"Extraction/Purification Numbers":"D6060",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Microbial?High-Molecular Weight@DNA?DNA Methylation@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"quick-dna-hmw-magbead-kit",
		"Extraction/Purification Numbers":"D6060",
		"Application Kit Handle":"zymotaq-premix,zymotaq-dna-polymerase,zymotaq-qpcr-premix",
		"Application Kit Numbers":"E2003,E2004,E2001,E2002,E2054,E2055",
		"Application Kit 2 Handle":"ez-dna-methylation-lightning-automation-kit",
		"Application Kit 2 Numbers":"D5049",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Microbial?High-Molecular Weight@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"quick-dna-hmw-magbead-kit",
		"Extraction/Purification Numbers":"D6060",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Microbial?High-Molecular Weight@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Microbial?Microbial@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Microbial?Microbial@DNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Microbial?Microbial@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Microbial?Microbial@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Microbial?Microbial@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Microbial?Pathogen@DNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Microbial?Pathogen@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Microbial?Pathogen@DNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Microbial?Pathogen@DNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Microbial?Pathogen@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Microbial?Pathogen@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Microbial?Pathogen@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Microbial?Total@DNA?DNA Methylation@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"zymo-seq-wgbs-library-kit,zymo-seq-rrbs-library-kit,pico-methyl-seq-library-prep-kit",
		"Application Kit Numbers":"D5465,D5460,D5461,D5455,D5456",
		"Application Kit 2 Handle":"ez-methylation-magprep-beads",
		"Application Kit 2 Numbers":"D4100-5-4,D4100-5-8,D4100-5-16",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Microbial?Total@DNA?Chromatin Analysis@NGS": {
		"Application Kit Handle":"zymo-seq-atac-library-kit",
		"Application Kit Numbers":"D5458",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Microbial?Total@DNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Microbial?Total@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Microbial?Total@DNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Microbial?Total@DNA?DNA Methylation@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymotaq-dna-polymerase,zymotaq-qpcr-premix",
		"Application Kit Numbers":"E2003,E2004,E2001,E2002,E2054,E2055",
		"Application Kit 2 Handle":"ez-dna-methylation-lightning-automation-kit",
		"Application Kit 2 Numbers":"D5049",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Microbial?Total@DNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Microbial?Total@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Microbial?Total@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Microbial?Total@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Microbial?Viral@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Microbial?Viral@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Microbial?Viral@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Microbial?Microbial@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Microbial?Microbial@RNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Microbial?Microbial@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Microbial?Microbial@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Microbial?Microbial@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Microbial?micro-RNA@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Microbial?micro-RNA@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Microbial?Pathogen@RNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Microbial?Pathogen@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Microbial?Pathogen@RNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Microbial?Pathogen@RNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Microbial?Pathogen@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Microbial?Pathogen@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Microbial?Pathogen@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Microbial?Total@RNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Microbial?Total@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Microbial?Total@RNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Microbial?Total@RNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Microbial?Total@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Microbial?Total@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Microbial?Total@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Microbial?Viral@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Microbial?Viral@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Microbial?Viral@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Microbial?Microbial@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410,D6432",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Microbial?Microbial@Total Nucleic Acid?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Microbial?Microbial@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Microbial?Microbial@Total Nucleic Acid?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Microbial?Microbial@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Microbial?Pathogen@Total Nucleic Acid?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Microbial?Pathogen@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Microbial?Pathogen@Total Nucleic Acid?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Microbial?Pathogen@Total Nucleic Acid?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Microbial?Pathogen@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Microbial?Pathogen@Total Nucleic Acid?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Microbial?Pathogen@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Microbial?Total@Total Nucleic Acid?DNA Methylation@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-wgbs-library-kit,zymo-seq-rrbs-library-kit,pico-methyl-seq-library-prep-kit",
		"Application Kit Numbers":"D5465,D5460,D5461,D5455,D5456",
		"Application Kit 2 Handle":"ez-methylation-magprep-beads",
		"Application Kit 2 Numbers":"D4100-5-4,D4100-5-8,D4100-5-16",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Microbial?Total@Total Nucleic Acid?Chromatin Analysis@NGS": {
		"Application Kit Handle":"zymo-seq-atac-library-kit",
		"Application Kit Numbers":"D5458",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Microbial?Total@Total Nucleic Acid?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Microbial?Total@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Microbial?Total@Total Nucleic Acid?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Microbial?Total@Total Nucleic Acid?DNA Methylation@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Application Kit 2 Handle":"ez-dna-methylation-lightning-automation-kit",
		"Application Kit 2 Numbers":"D5049",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Microbial?Total@Total Nucleic Acid?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Microbial?Total@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Microbial?Total@Total Nucleic Acid?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Microbial?Total@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Microbial?Viral@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Microbial?Viral@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Microbial?Viral@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Microbial?Microbial@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410,D6432",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Microbial?Microbial@Fractional (DNA & RNA Separate)?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Microbial?Microbial@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Microbial?Microbial@Fractional (DNA & RNA Separate)?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Microbial?Microbial@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Microbial?Pathogen@Fractional (DNA & RNA Separate)?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Microbial?Pathogen@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Microbial?Pathogen@Fractional (DNA & RNA Separate)?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Microbial?Pathogen@Fractional (DNA & RNA Separate)?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Microbial?Pathogen@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Microbial?Pathogen@Fractional (DNA & RNA Separate)?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Microbial?Pathogen@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Microbial?Viral@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Microbial?Viral@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Microbial?Viral@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Microbial?Total@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Microbial?Total@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Microbial?Total@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Insects@Environmental?High-Molecular Weight@DNA?DNA Methylation@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-2-0-mm",
		"Sample Prep Numbers":"S6014-50",
		"Extraction/Purification Handle":"quick-dna-hmw-magbead-kit",
		"Extraction/Purification Numbers":"D6060",
		"Application Kit Handle":"zymo-seq-wgbs-library-kit,zymo-seq-rrbs-library-kit,pico-methyl-seq-library-prep-kit",
		"Application Kit Numbers":"D5465,D5460,D5461,D5455,D5456",
		"Application Kit 2 Handle":"ez-methylation-magprep-beads",
		"Application Kit 2 Numbers":"D4100-5-4,D4100-5-8,D4100-5-16",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Insects@Environmental?High-Molecular Weight@DNA?Chromatin Analysis@NGS": {
		"Application Kit Handle":"zymo-seq-atac-library-kit",
		"Application Kit Numbers":"D5458",
	},
	"Insects@Environmental?High-Molecular Weight@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-2-0-mm",
		"Sample Prep Numbers":"S6014-50",
		"Extraction/Purification Handle":"quick-dna-hmw-magbead-kit",
		"Extraction/Purification Numbers":"D6060",
	},
	"Insects@Environmental?High-Molecular Weight@DNA?DNA Methylation@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-2-0-mm",
		"Sample Prep Numbers":"S6014-50",
		"Extraction/Purification Handle":"quick-dna-hmw-magbead-kit",
		"Extraction/Purification Numbers":"D6060",
		"Application Kit Handle":"zymotaq-premix,zymotaq-dna-polymerase,zymotaq-qpcr-premix",
		"Application Kit Numbers":"E2003,E2004,E2001,E2002,E2054,E2055",
		"Application Kit 2 Handle":"ez-dna-methylation-lightning-automation-kit",
		"Application Kit 2 Numbers":"D5049",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Insects@Environmental?High-Molecular Weight@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-2-0-mm",
		"Sample Prep Numbers":"S6014-50",
		"Extraction/Purification Handle":"quick-dna-hmw-magbead-kit",
		"Extraction/Purification Numbers":"D6060",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Insects@Environmental?High-Molecular Weight@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Insects@Environmental?Microbial@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Insects@Environmental?Microbial@DNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Insects@Environmental?Microbial@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Insects@Environmental?Microbial@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Insects@Environmental?Microbial@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Insects@Environmental?Pathogen@DNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-2-0-mm",
		"Sample Prep Numbers":"S6014-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Insects@Environmental?Pathogen@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
	},
	"Insects@Environmental?Pathogen@DNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Insects@Environmental?Pathogen@DNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-2-0-mm",
		"Sample Prep Numbers":"S6014-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Insects@Environmental?Pathogen@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Insects@Environmental?Pathogen@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Insects@Environmental?Pathogen@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Insects@Environmental?Total@DNA?DNA Methylation@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"zymo-seq-wgbs-library-kit,zymo-seq-rrbs-library-kit,pico-methyl-seq-library-prep-kit",
		"Application Kit Numbers":"D5465,D5460,D5461,D5455,D5456",
		"Application Kit 2 Handle":"ez-methylation-magprep-beads",
		"Application Kit 2 Numbers":"D4100-5-4,D4100-5-8,D4100-5-16",
	},
	"Insects@Environmental?Total@DNA?Chromatin Analysis@NGS": {
		"Application Kit Handle":"zymo-seq-atac-library-kit",
		"Application Kit Numbers":"D5458",
	},
	"Insects@Environmental?Total@DNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
	},
	"Insects@Environmental?Total@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-2-0-mm",
		"Sample Prep Numbers":"S6014-50",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
	},
	"Insects@Environmental?Total@DNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Insects@Environmental?Total@DNA?DNA Methylation@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-2-0-mm",
		"Sample Prep Numbers":"S6014-50",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
		"Application Kit Handle":"zymotaq-premix,zymotaq-dna-polymerase,zymotaq-qpcr-premix",
		"Application Kit Numbers":"E2003,E2004,E2001,E2002,E2054,E2055",
		"Application Kit 2 Handle":"ez-dna-methylation-lightning-automation-kit",
		"Application Kit 2 Numbers":"D5049",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Insects@Environmental?Total@DNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-2-0-mm",
		"Sample Prep Numbers":"S6014-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Insects@Environmental?Total@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-2-0-mm",
		"Sample Prep Numbers":"S6014-50",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Insects@Environmental?Total@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Insects@Environmental?Total@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Insects@Environmental?Viral@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-2-0-mm",
		"Sample Prep Numbers":"S6014-50",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
	},
	"Insects@Environmental?Viral@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-2-0-mm",
		"Sample Prep Numbers":"S6014-50",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Insects@Environmental?Viral@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Insects@Environmental?Microbial@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Insects@Environmental?Microbial@RNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Insects@Environmental?Microbial@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Insects@Environmental?Microbial@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Insects@Environmental?Microbial@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Insects@Environmental?micro-RNA@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-2-0-mm",
		"Sample Prep Numbers":"S6014-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Insects@Environmental?micro-RNA@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-2-0-mm",
		"Sample Prep Numbers":"S6014-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Insects@Environmental?Pathogen@RNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-2-0-mm",
		"Sample Prep Numbers":"S6014-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Insects@Environmental?Pathogen@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Insects@Environmental?Pathogen@RNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Insects@Environmental?Pathogen@RNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-2-0-mm",
		"Sample Prep Numbers":"S6014-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Insects@Environmental?Pathogen@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Insects@Environmental?Pathogen@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Insects@Environmental?Pathogen@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Insects@Environmental?Total@RNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-2-0-mm",
		"Sample Prep Numbers":"S6014-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Insects@Environmental?Total@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-2-0-mm",
		"Sample Prep Numbers":"S6014-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Insects@Environmental?Total@RNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Insects@Environmental?Total@RNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-2-0-mm",
		"Sample Prep Numbers":"S6014-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Insects@Environmental?Total@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-2-0-mm",
		"Sample Prep Numbers":"S6014-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Insects@Environmental?Total@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Insects@Environmental?Total@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Insects@Environmental?Viral@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-2-0-mm",
		"Sample Prep Numbers":"S6014-50",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Insects@Environmental?Viral@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-2-0-mm",
		"Sample Prep Numbers":"S6014-50",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Insects@Environmental?Viral@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Insects@Environmental?Microbial@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410,D6432",
	},
	"Insects@Environmental?Microbial@Total Nucleic Acid?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Insects@Environmental?Microbial@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Insects@Environmental?Microbial@Total Nucleic Acid?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Insects@Environmental?Microbial@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Insects@Environmental?Pathogen@Total Nucleic Acid?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-2-0-mm",
		"Sample Prep Numbers":"S6014-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Insects@Environmental?Pathogen@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
	},
	"Insects@Environmental?Pathogen@Total Nucleic Acid?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Insects@Environmental?Pathogen@Total Nucleic Acid?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-2-0-mm",
		"Sample Prep Numbers":"S6014-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Insects@Environmental?Pathogen@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Insects@Environmental?Pathogen@Total Nucleic Acid?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Insects@Environmental?Pathogen@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Insects@Environmental?Total@Total Nucleic Acid?DNA Methylation@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-2-0-mm",
		"Sample Prep Numbers":"S6014-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-wgbs-library-kit,zymo-seq-rrbs-library-kit,pico-methyl-seq-library-prep-kit",
		"Application Kit Numbers":"D5465,D5460,D5461,D5455,D5456",
		"Application Kit 2 Handle":"ez-methylation-magprep-beads",
		"Application Kit 2 Numbers":"D4100-5-4,D4100-5-8,D4100-5-16",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Insects@Environmental?Total@Total Nucleic Acid?Chromatin Analysis@NGS": {
		"Application Kit Handle":"zymo-seq-atac-library-kit",
		"Application Kit Numbers":"D5458",
	},
	"Insects@Environmental?Total@Total Nucleic Acid?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Insects@Environmental?Total@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-2-0-mm",
		"Sample Prep Numbers":"S6014-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
	},
	"Insects@Environmental?Total@Total Nucleic Acid?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Insects@Environmental?Total@Total Nucleic Acid?DNA Methylation@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-2-0-mm",
		"Sample Prep Numbers":"S6014-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Application Kit 2 Handle":"ez-dna-methylation-lightning-automation-kit",
		"Application Kit 2 Numbers":"D5049",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Insects@Environmental?Total@Total Nucleic Acid?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Insects@Environmental?Total@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-2-0-mm",
		"Sample Prep Numbers":"S6014-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Insects@Environmental?Total@Total Nucleic Acid?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Insects@Environmental?Total@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Insects@Environmental?Viral@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-2-0-mm",
		"Sample Prep Numbers":"S6014-50",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
	},
	"Insects@Environmental?Viral@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-2-0-mm",
		"Sample Prep Numbers":"S6014-50",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Insects@Environmental?Viral@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Insects@Environmental?Microbial@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410,D6432",
	},
	"Insects@Environmental?Microbial@Fractional (DNA & RNA Separate)?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410",
	},
	"Insects@Environmental?Microbial@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Insects@Environmental?Microbial@Fractional (DNA & RNA Separate)?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Insects@Environmental?Microbial@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Insects@Environmental?Pathogen@Fractional (DNA & RNA Separate)?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-2-0-mm",
		"Sample Prep Numbers":"S6014-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Insects@Environmental?Pathogen@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
	},
	"Insects@Environmental?Pathogen@Fractional (DNA & RNA Separate)?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410",
	},
	"Insects@Environmental?Pathogen@Fractional (DNA & RNA Separate)?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-2-0-mm",
		"Sample Prep Numbers":"S6014-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Insects@Environmental?Pathogen@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Insects@Environmental?Pathogen@Fractional (DNA & RNA Separate)?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Insects@Environmental?Pathogen@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Insects@Environmental?Viral@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-2-0-mm",
		"Sample Prep Numbers":"S6014-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
	},
	"Insects@Environmental?Viral@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-2-0-mm",
		"Sample Prep Numbers":"S6014-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Insects@Environmental?Viral@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Insects@Environmental?Total@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-2-0-mm",
		"Sample Prep Numbers":"S6014-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
	},
	"Insects@Environmental?Total@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-2-0-mm",
		"Sample Prep Numbers":"S6014-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Insects@Environmental?Total@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Fungus@Environmental?High-Molecular Weight@DNA?DNA Methylation@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-hmw-magbead-kit",
		"Extraction/Purification Numbers":"D6060",
		"Application Kit Handle":"zymo-seq-wgbs-library-kit,zymo-seq-rrbs-library-kit,pico-methyl-seq-library-prep-kit",
		"Application Kit Numbers":"D5465,D5460,D5461,D5455,D5456",
		"Application Kit 2 Handle":"ez-methylation-magprep-beads",
		"Application Kit 2 Numbers":"D4100-5-4,D4100-5-8,D4100-5-16",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Fungus@Environmental?High-Molecular Weight@DNA?Chromatin Analysis@NGS": {
		"Application Kit Handle":"zymo-seq-atac-library-kit",
		"Application Kit Numbers":"D5458",
	},
	"Fungus@Environmental?High-Molecular Weight@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-hmw-magbead-kit",
		"Extraction/Purification Numbers":"D6060",
	},
	"Fungus@Environmental?High-Molecular Weight@DNA?DNA Methylation@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-hmw-magbead-kit",
		"Extraction/Purification Numbers":"D6060",
		"Application Kit Handle":"zymotaq-premix,zymotaq-dna-polymerase,zymotaq-qpcr-premix",
		"Application Kit Numbers":"E2003,E2004,E2001,E2002,E2054,E2055",
		"Application Kit 2 Handle":"ez-dna-methylation-lightning-automation-kit",
		"Application Kit 2 Numbers":"D5049",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Fungus@Environmental?High-Molecular Weight@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-hmw-magbead-kit",
		"Extraction/Purification Numbers":"D6060",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Fungus@Environmental?High-Molecular Weight@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Fungus@Environmental?Microbial@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Fungus@Environmental?Microbial@DNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Fungus@Environmental?Microbial@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Fungus@Environmental?Microbial@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Fungus@Environmental?Microbial@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Fungus@Environmental?Pathogen@DNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Fungus@Environmental?Pathogen@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
	},
	"Fungus@Environmental?Pathogen@DNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Fungus@Environmental?Pathogen@DNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Fungus@Environmental?Pathogen@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Fungus@Environmental?Pathogen@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Fungus@Environmental?Pathogen@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Fungus@Environmental?Total@DNA?DNA Methylation@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"zymo-seq-wgbs-library-kit,zymo-seq-rrbs-library-kit,pico-methyl-seq-library-prep-kit",
		"Application Kit Numbers":"D5465,D5460,D5461,D5455,D5456",
		"Application Kit 2 Handle":"ez-methylation-magprep-beads",
		"Application Kit 2 Numbers":"D4100-5-4,D4100-5-8,D4100-5-16",
	},
	"Fungus@Environmental?Total@DNA?Chromatin Analysis@NGS": {
		"Application Kit Handle":"zymo-seq-atac-library-kit",
		"Application Kit Numbers":"D5458",
	},
	"Fungus@Environmental?Total@DNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
	},
	"Fungus@Environmental?Total@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
	},
	"Fungus@Environmental?Total@DNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Fungus@Environmental?Total@DNA?DNA Methylation@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymotaq-dna-polymerase,zymotaq-qpcr-premix",
		"Application Kit Numbers":"E2003,E2004,E2001,E2002,E2054,E2055",
		"Application Kit 2 Handle":"ez-dna-methylation-lightning-automation-kit",
		"Application Kit 2 Numbers":"D5049",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Fungus@Environmental?Total@DNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Fungus@Environmental?Total@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Fungus@Environmental?Total@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Fungus@Environmental?Total@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Fungus@Environmental?Viral@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
	},
	"Fungus@Environmental?Viral@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Fungus@Environmental?Viral@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Fungus@Environmental?Microbial@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Fungus@Environmental?Microbial@RNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Fungus@Environmental?Microbial@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Fungus@Environmental?Microbial@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Fungus@Environmental?Microbial@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Fungus@Environmental?micro-RNA@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Fungus@Environmental?micro-RNA@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Fungus@Environmental?Pathogen@RNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Fungus@Environmental?Pathogen@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Fungus@Environmental?Pathogen@RNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Fungus@Environmental?Pathogen@RNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Fungus@Environmental?Pathogen@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Fungus@Environmental?Pathogen@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Fungus@Environmental?Pathogen@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Fungus@Environmental?Total@RNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Fungus@Environmental?Total@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Fungus@Environmental?Total@RNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Fungus@Environmental?Total@RNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Fungus@Environmental?Total@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Fungus@Environmental?Total@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Fungus@Environmental?Total@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Fungus@Environmental?Viral@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Fungus@Environmental?Viral@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Fungus@Environmental?Viral@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Fungus@Environmental?Microbial@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410,D6432",
	},
	"Fungus@Environmental?Microbial@Total Nucleic Acid?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Fungus@Environmental?Microbial@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Fungus@Environmental?Microbial@Total Nucleic Acid?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Fungus@Environmental?Microbial@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Fungus@Environmental?Pathogen@Total Nucleic Acid?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Fungus@Environmental?Pathogen@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
	},
	"Fungus@Environmental?Pathogen@Total Nucleic Acid?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Fungus@Environmental?Pathogen@Total Nucleic Acid?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Fungus@Environmental?Pathogen@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Fungus@Environmental?Pathogen@Total Nucleic Acid?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Fungus@Environmental?Pathogen@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Fungus@Environmental?Total@Total Nucleic Acid?DNA Methylation@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-wgbs-library-kit,zymo-seq-rrbs-library-kit,pico-methyl-seq-library-prep-kit",
		"Application Kit Numbers":"D5465,D5460,D5461,D5455,D5456",
		"Application Kit 2 Handle":"ez-methylation-magprep-beads",
		"Application Kit 2 Numbers":"D4100-5-4,D4100-5-8,D4100-5-16",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Fungus@Environmental?Total@Total Nucleic Acid?Chromatin Analysis@NGS": {
		"Application Kit Handle":"zymo-seq-atac-library-kit",
		"Application Kit Numbers":"D5458",
	},
	"Fungus@Environmental?Total@Total Nucleic Acid?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Fungus@Environmental?Total@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
	},
	"Fungus@Environmental?Total@Total Nucleic Acid?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Fungus@Environmental?Total@Total Nucleic Acid?DNA Methylation@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Application Kit 2 Handle":"ez-dna-methylation-lightning-automation-kit",
		"Application Kit 2 Numbers":"D5049",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Fungus@Environmental?Total@Total Nucleic Acid?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Fungus@Environmental?Total@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Fungus@Environmental?Total@Total Nucleic Acid?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Fungus@Environmental?Total@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Fungus@Environmental?Viral@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
	},
	"Fungus@Environmental?Viral@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Fungus@Environmental?Viral@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Fungus@Environmental?Microbial@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410,D6432",
	},
	"Fungus@Environmental?Microbial@Fractional (DNA & RNA Separate)?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410",
	},
	"Fungus@Environmental?Microbial@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Fungus@Environmental?Microbial@Fractional (DNA & RNA Separate)?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Fungus@Environmental?Microbial@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Fungus@Environmental?Pathogen@Fractional (DNA & RNA Separate)?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Fungus@Environmental?Pathogen@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
	},
	"Fungus@Environmental?Pathogen@Fractional (DNA & RNA Separate)?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410",
	},
	"Fungus@Environmental?Pathogen@Fractional (DNA & RNA Separate)?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Fungus@Environmental?Pathogen@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Fungus@Environmental?Pathogen@Fractional (DNA & RNA Separate)?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Fungus@Environmental?Pathogen@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Fungus@Environmental?Viral@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
	},
	"Fungus@Environmental?Viral@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Fungus@Environmental?Viral@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Fungus@Environmental?Total@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
	},
	"Fungus@Environmental?Total@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Fungus@Environmental?Total@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Seeds@Environmental?High-Molecular Weight@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-dna-hmw-magbead-kit",
		"Extraction/Purification Numbers":"D6060",
	},
	"Seeds@Environmental?High-Molecular Weight@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-dna-hmw-magbead-kit",
		"Extraction/Purification Numbers":"D6060",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Seeds@Environmental?High-Molecular Weight@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Seeds@Environmental?Total@DNA?DNA Methylation@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
		"Application Kit Handle":"zymo-seq-wgbs-library-kit,zymo-seq-rrbs-library-kit,pico-methyl-seq-library-prep-kit",
		"Application Kit Numbers":"D5465,D5460,D5461,D5455,D5456",
		"Application Kit 2 Handle":"ez-methylation-magprep-beads",
		"Application Kit 2 Numbers":"D4100-5-4,D4100-5-8,D4100-5-16",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Seeds@Environmental?Total@DNA?Chromatin Analysis@NGS": {
		"Application Kit Handle":"zymo-seq-atac-library-kit",
		"Application Kit Numbers":"D5458",
	},
	"Seeds@Environmental?Total@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
	},
	"Seeds@Environmental?Total@DNA?DNA Methylation@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
		"Application Kit Handle":"zymotaq-premix,zymotaq-dna-polymerase,zymotaq-qpcr-premix",
		"Application Kit Numbers":"E2003,E2004,E2001,E2002,E2054,E2055",
		"Application Kit 2 Handle":"ez-dna-methylation-lightning-automation-kit",
		"Application Kit 2 Numbers":"D5049",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Seeds@Environmental?Total@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Seeds@Environmental?Total@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Seeds@Environmental?micro-RNA@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Seeds@Environmental?micro-RNA@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Seeds@Environmental?Total@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Seeds@Environmental?Total@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Seeds@Environmental?Total@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Seeds@Environmental?Total@Total Nucleic Acid?DNA Methylation@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-wgbs-library-kit,zymo-seq-rrbs-library-kit,pico-methyl-seq-library-prep-kit",
		"Application Kit Numbers":"D5465,D5460,D5461,D5455,D5456",
		"Application Kit 2 Handle":"ez-methylation-magprep-beads",
		"Application Kit 2 Numbers":"D4100-5-4,D4100-5-8,D4100-5-16",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Seeds@Environmental?Total@Total Nucleic Acid?Chromatin Analysis@NGS": {
		"Application Kit Handle":"zymo-seq-atac-library-kit",
		"Application Kit Numbers":"D5458",
	},
	"Seeds@Environmental?Total@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
	},
	"Seeds@Environmental?Total@Total Nucleic Acid?DNA Methylation@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Application Kit 2 Handle":"ez-dna-methylation-lightning-automation-kit",
		"Application Kit 2 Numbers":"D5049",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Seeds@Environmental?Total@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Seeds@Environmental?Total@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Seeds@Environmental?Total@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
	},
	"Seeds@Environmental?Total@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Seeds@Environmental?Total@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Plant@Environmental?High-Molecular Weight@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-hmw-magbead-kit",
		"Extraction/Purification Numbers":"D6060",
	},
	"Plant@Environmental?High-Molecular Weight@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-hmw-magbead-kit",
		"Extraction/Purification Numbers":"D6060",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Plant@Environmental?High-Molecular Weight@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Plant@Environmental?Total@DNA?DNA Methylation@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
		"Application Kit Handle":"zymo-seq-wgbs-library-kit,zymo-seq-rrbs-library-kit,pico-methyl-seq-library-prep-kit",
		"Application Kit Numbers":"D5465,D5460,D5461,D5455,D5456",
		"Application Kit 2 Handle":"ez-methylation-magprep-beads",
		"Application Kit 2 Numbers":"D4100-5-4,D4100-5-8,D4100-5-16",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Plant@Environmental?Total@DNA?Chromatin Analysis@NGS": {
		"Application Kit Handle":"zymo-seq-atac-library-kit",
		"Application Kit Numbers":"D5458",
	},
	"Plant@Environmental?Total@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
	},
	"Plant@Environmental?Total@DNA?DNA Methylation@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
		"Application Kit Handle":"zymotaq-premix,zymotaq-dna-polymerase,zymotaq-qpcr-premix",
		"Application Kit Numbers":"E2003,E2004,E2001,E2002,E2054,E2055",
		"Application Kit 2 Handle":"ez-dna-methylation-lightning-automation-kit",
		"Application Kit 2 Numbers":"D5049",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Plant@Environmental?Total@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Plant@Environmental?Total@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Plant@Environmental?micro-RNA@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Plant@Environmental?micro-RNA@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Plant@Environmental?Total@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Plant@Environmental?Total@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Plant@Environmental?Total@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Plant@Environmental?Total@Total Nucleic Acid?DNA Methylation@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-wgbs-library-kit,zymo-seq-rrbs-library-kit,pico-methyl-seq-library-prep-kit",
		"Application Kit Numbers":"D5465,D5460,D5461,D5455,D5456",
		"Application Kit 2 Handle":"ez-methylation-magprep-beads",
		"Application Kit 2 Numbers":"D4100-5-4,D4100-5-8,D4100-5-16",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Plant@Environmental?Total@Total Nucleic Acid?Chromatin Analysis@NGS": {
		"Application Kit Handle":"zymo-seq-atac-library-kit",
		"Application Kit Numbers":"D5458",
	},
	"Plant@Environmental?Total@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
	},
	"Plant@Environmental?Total@Total Nucleic Acid?DNA Methylation@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Application Kit 2 Handle":"ez-dna-methylation-lightning-automation-kit",
		"Application Kit 2 Numbers":"D5049",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Plant@Environmental?Total@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Plant@Environmental?Total@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Plant@Environmental?Total@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
	},
	"Plant@Environmental?Total@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Plant@Environmental?Total@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Yeast@Environmental?Microbial@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Yeast@Environmental?Microbial@DNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Yeast@Environmental?Microbial@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Yeast@Environmental?Microbial@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Yeast@Environmental?Microbial@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Yeast@Environmental?Total@DNA?DNA Methylation@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"zymo-seq-wgbs-library-kit,zymo-seq-rrbs-library-kit,pico-methyl-seq-library-prep-kit",
		"Application Kit Numbers":"D5465,D5460,D5461,D5455,D5456",
		"Application Kit 2 Handle":"ez-methylation-magprep-beads",
		"Application Kit 2 Numbers":"D4100-5-4,D4100-5-8,D4100-5-16",
	},
	"Yeast@Environmental?Total@DNA?Chromatin Analysis@NGS": {
		"Application Kit Handle":"zymo-seq-atac-library-kit",
		"Application Kit Numbers":"D5458",
	},
	"Yeast@Environmental?Total@DNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
	},
	"Yeast@Environmental?Total@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
	},
	"Yeast@Environmental?Total@DNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Yeast@Environmental?Total@DNA?DNA Methylation@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymotaq-dna-polymerase,zymotaq-qpcr-premix",
		"Application Kit Numbers":"E2003,E2004,E2001,E2002,E2054,E2055",
		"Application Kit 2 Handle":"ez-dna-methylation-lightning-automation-kit",
		"Application Kit 2 Numbers":"D5049",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Yeast@Environmental?Total@DNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Yeast@Environmental?Total@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Yeast@Environmental?Total@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Yeast@Environmental?Total@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Yeast@Environmental?Microbial@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Yeast@Environmental?Microbial@RNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Yeast@Environmental?Microbial@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Yeast@Environmental?Microbial@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Yeast@Environmental?Microbial@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Yeast@Environmental?Total@RNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Yeast@Environmental?Total@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Yeast@Environmental?Total@RNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Yeast@Environmental?Total@RNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Yeast@Environmental?Total@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Yeast@Environmental?Total@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Yeast@Environmental?Total@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Yeast@Environmental?Microbial@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410,D6432",
	},
	"Yeast@Environmental?Microbial@Total Nucleic Acid?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Yeast@Environmental?Microbial@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Yeast@Environmental?Microbial@Total Nucleic Acid?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Yeast@Environmental?Microbial@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Yeast@Environmental?Total@Total Nucleic Acid?DNA Methylation@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-wgbs-library-kit,zymo-seq-rrbs-library-kit,pico-methyl-seq-library-prep-kit",
		"Application Kit Numbers":"D5465,D5460,D5461,D5455,D5456",
		"Application Kit 2 Handle":"ez-methylation-magprep-beads",
		"Application Kit 2 Numbers":"D4100-5-4,D4100-5-8,D4100-5-16",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Yeast@Environmental?Total@Total Nucleic Acid?Chromatin Analysis@NGS": {
		"Application Kit Handle":"zymo-seq-atac-library-kit",
		"Application Kit Numbers":"D5458",
	},
	"Yeast@Environmental?Total@Total Nucleic Acid?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Yeast@Environmental?Total@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
	},
	"Yeast@Environmental?Total@Total Nucleic Acid?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Yeast@Environmental?Total@Total Nucleic Acid?DNA Methylation@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Application Kit 2 Handle":"ez-dna-methylation-lightning-automation-kit",
		"Application Kit 2 Numbers":"D5049",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Yeast@Environmental?Total@Total Nucleic Acid?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Yeast@Environmental?Total@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Yeast@Environmental?Total@Total Nucleic Acid?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Yeast@Environmental?Total@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Yeast@Environmental?Microbial@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410,D6432",
	},
	"Yeast@Environmental?Microbial@Fractional (DNA & RNA Separate)?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410",
	},
	"Yeast@Environmental?Microbial@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Yeast@Environmental?Microbial@Fractional (DNA & RNA Separate)?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Yeast@Environmental?Microbial@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Yeast@Environmental?Total@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
	},
	"Yeast@Environmental?Total@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Yeast@Environmental?Total@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Waste Water@Environmental?Microbial@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Waste Water@Environmental?Microbial@DNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Waste Water@Environmental?Microbial@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Waste Water@Environmental?Microbial@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Waste Water@Environmental?Microbial@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Waste Water@Environmental?Pathogen@DNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Waste Water@Environmental?Pathogen@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
	},
	"Waste Water@Environmental?Pathogen@DNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Waste Water@Environmental?Pathogen@DNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Waste Water@Environmental?Pathogen@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Waste Water@Environmental?Pathogen@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Waste Water@Environmental?Pathogen@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Waste Water@Environmental?Total@DNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
	},
	"Waste Water@Environmental?Total@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
	},
	"Waste Water@Environmental?Total@DNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Waste Water@Environmental?Total@DNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Waste Water@Environmental?Total@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Waste Water@Environmental?Total@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Waste Water@Environmental?Total@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Waste Water@Environmental?Viral@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
	},
	"Waste Water@Environmental?Viral@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Waste Water@Environmental?Viral@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Waste Water@Environmental?Microbial@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Waste Water@Environmental?Microbial@RNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Waste Water@Environmental?Microbial@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Waste Water@Environmental?Microbial@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Waste Water@Environmental?Microbial@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Waste Water@Environmental?micro-RNA@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Waste Water@Environmental?micro-RNA@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Waste Water@Environmental?Pathogen@RNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Waste Water@Environmental?Pathogen@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Waste Water@Environmental?Pathogen@RNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Waste Water@Environmental?Pathogen@RNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Waste Water@Environmental?Pathogen@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Waste Water@Environmental?Pathogen@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Waste Water@Environmental?Pathogen@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Waste Water@Environmental?Total@RNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Waste Water@Environmental?Total@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Waste Water@Environmental?Total@RNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Waste Water@Environmental?Total@RNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Waste Water@Environmental?Total@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Waste Water@Environmental?Total@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Waste Water@Environmental?Total@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Waste Water@Environmental?Viral@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Waste Water@Environmental?Viral@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Waste Water@Environmental?Viral@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Waste Water@Environmental?Microbial@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410,D6432",
	},
	"Waste Water@Environmental?Microbial@Total Nucleic Acid?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Waste Water@Environmental?Microbial@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Waste Water@Environmental?Microbial@Total Nucleic Acid?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Waste Water@Environmental?Microbial@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Waste Water@Environmental?Pathogen@Total Nucleic Acid?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Waste Water@Environmental?Pathogen@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
	},
	"Waste Water@Environmental?Pathogen@Total Nucleic Acid?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Waste Water@Environmental?Pathogen@Total Nucleic Acid?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Waste Water@Environmental?Pathogen@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Waste Water@Environmental?Pathogen@Total Nucleic Acid?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Waste Water@Environmental?Pathogen@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Waste Water@Environmental?Total@Total Nucleic Acid?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Waste Water@Environmental?Total@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
	},
	"Waste Water@Environmental?Total@Total Nucleic Acid?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Waste Water@Environmental?Total@Total Nucleic Acid?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Waste Water@Environmental?Total@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Waste Water@Environmental?Total@Total Nucleic Acid?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Waste Water@Environmental?Total@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Waste Water@Environmental?Viral@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
	},
	"Waste Water@Environmental?Viral@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Waste Water@Environmental?Viral@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Waste Water@Environmental?Microbial@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410,D6432",
	},
	"Waste Water@Environmental?Microbial@Fractional (DNA & RNA Separate)?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410",
	},
	"Waste Water@Environmental?Microbial@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Waste Water@Environmental?Microbial@Fractional (DNA & RNA Separate)?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Waste Water@Environmental?Microbial@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Waste Water@Environmental?Pathogen@Fractional (DNA & RNA Separate)?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Waste Water@Environmental?Pathogen@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
	},
	"Waste Water@Environmental?Pathogen@Fractional (DNA & RNA Separate)?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410",
	},
	"Waste Water@Environmental?Pathogen@Fractional (DNA & RNA Separate)?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Waste Water@Environmental?Pathogen@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Waste Water@Environmental?Pathogen@Fractional (DNA & RNA Separate)?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Waste Water@Environmental?Pathogen@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Waste Water@Environmental?Viral@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
	},
	"Waste Water@Environmental?Viral@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Waste Water@Environmental?Viral@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Waste Water@Environmental?Total@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
	},
	"Waste Water@Environmental?Total@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Waste Water@Environmental?Total@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Soil@Environmental?Microbial@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Soil@Environmental?Microbial@DNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Soil@Environmental?Microbial@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Soil@Environmental?Microbial@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Soil@Environmental?Microbial@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Soil@Environmental?Pathogen@DNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Soil@Environmental?Pathogen@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
	},
	"Soil@Environmental?Pathogen@DNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Soil@Environmental?Pathogen@DNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Soil@Environmental?Pathogen@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Soil@Environmental?Pathogen@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Soil@Environmental?Pathogen@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Soil@Environmental?Total@DNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
	},
	"Soil@Environmental?Total@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
	},
	"Soil@Environmental?Total@DNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Soil@Environmental?Total@DNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Soil@Environmental?Total@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Soil@Environmental?Total@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Soil@Environmental?Total@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Soil@Environmental?Viral@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
	},
	"Soil@Environmental?Viral@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Soil@Environmental?Viral@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Soil@Environmental?Microbial@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Soil@Environmental?Microbial@RNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Soil@Environmental?Microbial@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Soil@Environmental?Microbial@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Soil@Environmental?Microbial@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Soil@Environmental?micro-RNA@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Soil@Environmental?micro-RNA@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Soil@Environmental?Pathogen@RNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Soil@Environmental?Pathogen@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Soil@Environmental?Pathogen@RNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Soil@Environmental?Pathogen@RNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Soil@Environmental?Pathogen@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Soil@Environmental?Pathogen@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Soil@Environmental?Pathogen@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Soil@Environmental?Total@RNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Soil@Environmental?Total@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Soil@Environmental?Total@RNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Soil@Environmental?Total@RNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Soil@Environmental?Total@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Soil@Environmental?Total@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Soil@Environmental?Total@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Soil@Environmental?Viral@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Soil@Environmental?Viral@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Soil@Environmental?Viral@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Soil@Environmental?Microbial@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410,D6432",
	},
	"Soil@Environmental?Microbial@Total Nucleic Acid?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Soil@Environmental?Microbial@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Soil@Environmental?Microbial@Total Nucleic Acid?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Soil@Environmental?Microbial@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Soil@Environmental?Pathogen@Total Nucleic Acid?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Soil@Environmental?Pathogen@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
	},
	"Soil@Environmental?Pathogen@Total Nucleic Acid?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Soil@Environmental?Pathogen@Total Nucleic Acid?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Soil@Environmental?Pathogen@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Soil@Environmental?Pathogen@Total Nucleic Acid?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Soil@Environmental?Pathogen@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Soil@Environmental?Total@Total Nucleic Acid?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Soil@Environmental?Total@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
	},
	"Soil@Environmental?Total@Total Nucleic Acid?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Soil@Environmental?Total@Total Nucleic Acid?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Soil@Environmental?Total@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Soil@Environmental?Total@Total Nucleic Acid?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Soil@Environmental?Total@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Soil@Environmental?Viral@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
	},
	"Soil@Environmental?Viral@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Soil@Environmental?Viral@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Soil@Environmental?Microbial@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410,D6432",
	},
	"Soil@Environmental?Microbial@Fractional (DNA & RNA Separate)?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410",
	},
	"Soil@Environmental?Microbial@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Soil@Environmental?Microbial@Fractional (DNA & RNA Separate)?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Soil@Environmental?Microbial@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Soil@Environmental?Pathogen@Fractional (DNA & RNA Separate)?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Soil@Environmental?Pathogen@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
	},
	"Soil@Environmental?Pathogen@Fractional (DNA & RNA Separate)?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410",
	},
	"Soil@Environmental?Pathogen@Fractional (DNA & RNA Separate)?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-50,R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Soil@Environmental?Pathogen@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Soil@Environmental?Pathogen@Fractional (DNA & RNA Separate)?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Soil@Environmental?Pathogen@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Soil@Environmental?Viral@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
	},
	"Soil@Environmental?Viral@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Soil@Environmental?Viral@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Soil@Environmental?Total@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
	},
	"Soil@Environmental?Total@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield",
		"Collection Numbers":"R1100-250",
		"Sample Prep Handle":"zr-bashing-bead-lysis-tubes",
		"Sample Prep Numbers":"S6003-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Soil@Environmental?Total@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Environmental?High-Molecular Weight@DNA?DNA Methylation@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"quick-dna-hmw-magbead-kit",
		"Extraction/Purification Numbers":"D6060",
		"Application Kit Handle":"zymo-seq-wgbs-library-kit,zymo-seq-rrbs-library-kit,pico-methyl-seq-library-prep-kit",
		"Application Kit Numbers":"D5465,D5460,D5461,D5455,D5456",
		"Application Kit 2 Handle":"ez-methylation-magprep-beads",
		"Application Kit 2 Numbers":"D4100-5-4,D4100-5-8,D4100-5-16",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Environmental?High-Molecular Weight@DNA?Chromatin Analysis@NGS": {
		"Application Kit Handle":"zymo-seq-atac-library-kit",
		"Application Kit Numbers":"D5458",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Environmental?High-Molecular Weight@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"quick-dna-hmw-magbead-kit",
		"Extraction/Purification Numbers":"D6060",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Environmental?High-Molecular Weight@DNA?DNA Methylation@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"quick-dna-hmw-magbead-kit",
		"Extraction/Purification Numbers":"D6060",
		"Application Kit Handle":"zymotaq-premix,zymotaq-dna-polymerase,zymotaq-qpcr-premix",
		"Application Kit Numbers":"E2003,E2004,E2001,E2002,E2054,E2055",
		"Application Kit 2 Handle":"ez-dna-methylation-lightning-automation-kit",
		"Application Kit 2 Numbers":"D5049",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Environmental?High-Molecular Weight@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"quick-dna-hmw-magbead-kit",
		"Extraction/Purification Numbers":"D6060",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Environmental?High-Molecular Weight@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Environmental?Microbial@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Environmental?Microbial@DNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Environmental?Microbial@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Environmental?Microbial@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Environmental?Microbial@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Environmental?Pathogen@DNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Environmental?Pathogen@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Environmental?Pathogen@DNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Environmental?Pathogen@DNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Environmental?Pathogen@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Environmental?Pathogen@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Environmental?Pathogen@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Environmental?Total@DNA?DNA Methylation@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"zymo-seq-wgbs-library-kit,zymo-seq-rrbs-library-kit,pico-methyl-seq-library-prep-kit",
		"Application Kit Numbers":"D5465,D5460,D5461,D5455,D5456",
		"Application Kit 2 Handle":"ez-methylation-magprep-beads",
		"Application Kit 2 Numbers":"D4100-5-4,D4100-5-8,D4100-5-16",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Environmental?Total@DNA?Chromatin Analysis@NGS": {
		"Application Kit Handle":"zymo-seq-atac-library-kit",
		"Application Kit Numbers":"D5458",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Environmental?Total@DNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Environmental?Total@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Environmental?Total@DNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4302,D4308",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Environmental?Total@DNA?DNA Methylation@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymotaq-dna-polymerase,zymotaq-qpcr-premix",
		"Application Kit Numbers":"E2003,E2004,E2001,E2002,E2054,E2055",
		"Application Kit 2 Handle":"ez-dna-methylation-lightning-automation-kit",
		"Application Kit 2 Numbers":"D5049",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Environmental?Total@DNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Environmental?Total@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"quick-dna-magbead-plus-kit",
		"Extraction/Purification Numbers":"D4081,D4082",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Environmental?Total@DNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-96-magbead-kit",
		"Extraction/Purification Numbers":"D4306",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Environmental?Total@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Environmental?Viral@DNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Environmental?Viral@DNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Environmental?Viral@DNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit",
		"Application Kit Numbers":"D4012",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Environmental?Microbial@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Environmental?Microbial@RNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Environmental?Microbial@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Environmental?Microbial@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-rna",
		"Extraction/Purification Numbers":"R2137,R2138",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Environmental?Microbial@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Environmental?micro-RNA@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Environmental?micro-RNA@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Environmental?Pathogen@RNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Environmental?Pathogen@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Environmental?Pathogen@RNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Environmental?Pathogen@RNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Environmental?Pathogen@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Environmental?Pathogen@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Environmental?Pathogen@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Environmental?Total@RNA?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Environmental?Total@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Environmental?Total@RNA?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Environmental?Total@RNA?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Environmental?Total@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Environmental?Total@RNA?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-rna-magbead",
		"Extraction/Purification Numbers":"R2132,R2133",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Environmental?Total@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Environmental?Viral@RNA?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit",
		"Application Kit Numbers":"R3000,R3003,R3001",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Environmental?Viral@RNA?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"R3012,R3014",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Environmental?Viral@RNA?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Environmental?Microbial@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410,D6432",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Environmental?Microbial@Total Nucleic Acid?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Environmental?Microbial@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Environmental?Microbial@Total Nucleic Acid?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Environmental?Microbial@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Environmental?Pathogen@Total Nucleic Acid?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Environmental?Pathogen@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Environmental?Pathogen@Total Nucleic Acid?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Environmental?Pathogen@Total Nucleic Acid?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Environmental?Pathogen@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Environmental?Pathogen@Total Nucleic Acid?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-pathogen-magbead",
		"Extraction/Purification Numbers":"R2145,R2146",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Environmental?Pathogen@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Environmental?Total@Total Nucleic Acid?DNA Methylation@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-wgbs-library-kit,zymo-seq-rrbs-library-kit,pico-methyl-seq-library-prep-kit",
		"Application Kit Numbers":"D5465,D5460,D5461,D5455,D5456",
		"Application Kit 2 Handle":"ez-methylation-magprep-beads",
		"Application Kit 2 Numbers":"D4100-5-4,D4100-5-8,D4100-5-16",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Environmental?Total@Total Nucleic Acid?Chromatin Analysis@NGS": {
		"Application Kit Handle":"zymo-seq-atac-library-kit",
		"Application Kit Numbers":"D5458",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Environmental?Total@Total Nucleic Acid?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Environmental?Total@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Environmental?Total@Total Nucleic Acid?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"quick-16s-plus-ngs-library-prep-kit-v1-v2,quick-16s-plus-ngs-library-prep-kit-v1-v3,quick-16s-plus-ngs-library-prep-kit-v3-v4-udi,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"D6434-PS1,D6440-PS1,D6421-PS1,D6430-PS1",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Environmental?Total@Total Nucleic Acid?DNA Methylation@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Application Kit 2 Handle":"ez-dna-methylation-lightning-automation-kit",
		"Application Kit 2 Numbers":"D5049",
		"Controls Handle":"human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5014",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Environmental?Total@Total Nucleic Acid?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Environmental?Total@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Environmental?Total@Total Nucleic Acid?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Environmental?Total@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Environmental?Viral@Total Nucleic Acid?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Environmental?Viral@Total Nucleic Acid?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"quick-dna-rna-viral-magbead",
		"Extraction/Purification Numbers":"R2140,R2141",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Environmental?Viral@Total Nucleic Acid?Post-Extraction Clean-up": {
		"Application Kit Handle":"rna-clean-concentrator-magbead",
		"Application Kit Numbers":"R1081",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Environmental?Microbial@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit,quick-16s-plus-ngs-library-prep-kit-v4",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410,D6432",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Environmental?Microbial@Fractional (DNA & RNA Separate)?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Environmental?Microbial@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Environmental?Microbial@Fractional (DNA & RNA Separate)?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard,zymobiomics-microbial-community-dna-standard",
		"Controls Numbers":"D6300,D6306",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Environmental?Microbial@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Environmental?Pathogen@Fractional (DNA & RNA Separate)?Fungal Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"quick-its-plus-ngs-library-prep-kit-udi",
		"Application Kit Numbers":"D6425-PS1",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Environmental?Pathogen@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Environmental?Pathogen@Fractional (DNA & RNA Separate)?Microbial Sequencing@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymo-seq-ribofree-total-rna-library-kit,zymo-seq-ribofree-universal-cdna-kit,quick-16s-ngs-library-prep-kit",
		"Application Kit Numbers":"R3000,R3001,D6400,D6410",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Environmental?Pathogen@Fractional (DNA & RNA Separate)?Fungal Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Environmental?Pathogen@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Sample Prep 2 Handle":"proteinase-k-w-storage-buffer-set",
		"Sample Prep 2 Numbers":"D3001-2-125",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Environmental?Pathogen@Fractional (DNA & RNA Separate)?Microbial Sequencing@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Sample Prep Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"Sample Prep Numbers":"S6012-50",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
		"Controls Handle":"zymobiomics-microbial-community-standard",
		"Controls Numbers":"D6300",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Environmental?Pathogen@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Environmental?Viral@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Environmental?Viral@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"zymobiomics-magbead-dna-rna",
		"Extraction/Purification Numbers":"R2135,R2136",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Environmental?Viral@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Environmental?Total@Fractional (DNA & RNA Separate)?General/Other@NGS": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Environmental?Total@Fractional (DNA & RNA Separate)?General/Other@PCR/rt-PCR": {
		"Collection Handle":"dna-rna-shield-collection-tube-w-swab",
		"Collection Numbers":"R1109",
		"Extraction/Purification Handle":"quick-dna-rna-magbead",
		"Extraction/Purification Numbers":"R2130,R2131",
		"Application Kit Handle":"zymotaq-premix,zymoscript-rt-premix-kit,zymoscript-one-step-rt-qpcr-kit",
		"Application Kit Numbers":"E2003,E2004,R3012,R3014",
	},
	"Swabs (Buccal, Vaginal, Skin, Recetal, Environment)@Environmental?Total@Fractional (DNA & RNA Separate)?Post-Extraction Clean-up": {
		"Application Kit Handle":"dna-clean-concentrator-magbead-kit,rna-clean-concentrator-magbead",
		"Application Kit Numbers":"D4012,R1081",
	},
}